<template>
  <div>
    <div class="loader"></div>
    <div style="height: 1000vh"></div>
    <section
      id="desk"
      class="static statement view public invoice"
      ref="document"
    >
      <aside id="alerts"></aside>
      <form
        novalidate=""
        autocomplete="off"
        id="view_public_invoice"
        accept-charset="UTF-8"
        data-form-type="statement"
        data-statement-type="invoice"
        data-statement-action="view_public"
        class="form_standard"
        data-handler-action=""
        data-object-id="d7ad27e8ff85433fa1eeed145973fb7b"
        data-success-message=""
      >
        <input
          type="hidden"
          name="statement[statement_status]"
          value="unsent"
        />
        <div class="flippable">
          <div class="board front">
            <div id="page" class="page" style="margin-top: 40px">
              <div>
                <input type="hidden" name="statement[type]" value="invoice" />
                <input type="hidden" name="statement[item_order]" value="" />
                <input
                  type="hidden"
                  name="statement[number_format]"
                  value="1"
                />
                <input
                  type="hidden"
                  name="statement[number_precision]"
                  value="2"
                />
                <section class="statement_section">
                  <div class="statement_contacts">
                    <div class="form_row address_from">
                      <div class="form_heading">
                        <label>From</label>
                      </div>
                      <div class="address relative">
                        <p>
                          {{ this.cname }}<br />{{ this.uaddress }}<br />{{
                            this.ucity
                          }}, {{ this.ustate }}, {{ this.upincode }}<br />{{
                            this.ucountry
                          }}<br />{{ this.taxname_one }}<br />{{
                            this.taxname_two
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form_row address_to"
                      data-identifier="autocomplete_wrapper"
                    >
                      <div class="form_heading">
                        <label>To</label>
                      </div>
                      <div class="address relative">
                        <p>{{ this.name }}</p>
                        {{ this.caddress }}<br />{{ this.ccity }},
                        {{ this.cstate }}{{ this.cpincode }}<br />{{
                          this.ccountry
                        }}<br />{{ this.taxno }}
                      </div>
                    </div>
                  </div>
                  <div class="statement_details">
                    <div class="form_row">
                      <div class="form_heading">
                        <label>Invoice No.</label>
                      </div>
                      <input
                        disabled=""
                        type="text"
                        v-model="this.invoice_no"
                      />
                    </div>
                    <div class="form_row">
                      <div class="form_heading">
                        <label>Date</label>
                      </div>
                      <p>{{ this.date }}</p>
                    </div>
                    <div class="form_row">
                      <div class="form_heading">
                        <label>Invoice Due</label>
                      </div>
                      <p>{{ this.due_date }}</p>
                    </div>
                  </div>
                </section>
                <div class="product-table">
                  <ul class="item_rows">
                    <li class="one_item_line no_border">
                      <ul class="item_row no_border">
                        <li class="item_column name_description">
                          <h2 class="item_column_heading">
                            <b style="font-weight: bold !important"
                              >Description</b
                            >
                          </h2>
                        </li>
                        <li class="item_column quantity">
                          <h2 class="item_column_heading">
                            <b style="font-weight: bold !important">Quantity</b>
                          </h2>
                        </li>
                        <li class="item_column unit">
                          <h2 class="item_column_heading">
                            <b style="font-weight: bold !important">Rate</b>
                          </h2>
                        </li>
                        <li class="item_column amount">
                          <h2 class="item_column_heading">
                            <b style="font-weight: bold !important">Amount</b>
                          </h2>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul class="item_rows item_area" id="drag_item_list">
                    <li
                      class="one_item_line actual"
                      data-parent-identifier="one_item_line"
                      data-id="1"
                      data-type="item"
                      v-for="item in items"
                      :key="item.id"
                    >
                      <ul class="item_row">
                        <li class="item_column name_description">
                          <div class="inner">
                            <div
                              id="item_textarea_1"
                              class="item_textarea_container"
                            >
                              <p
                                class="item_textarea view_statement_textarea_replacement"
                              >
                                {{ item.description }}
                              </p>
                              <div
                                class="files_area file_upload_1"
                                data-fileupload-id="1"
                              >
                                <div
                                  class="tag date"
                                  id="date_tag_1"
                                  data-tag-type="date"
                                  style="display: none"
                                >
                                  <a class="close_item"></a>
                                  <div class="inside">
                                    <span class="filename" data-real-date=""
                                      >Jan 01 1970</span
                                    >
                                  </div>
                                </div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="item_column quantity">
                          <div class="inner">
                            <div class="quantity_input">
                              <input
                                data-validate="required"
                                disabled=""
                                name="statement[item_quantity]"
                                placeholder="Quantity"
                                type="text"
                                data-input-restriction="number"
                                data-trigger="calculation"
                                data-calculation="quantity"
                                style="font-size: 12px !important"
                                v-model="item.qty"
                              />
                            </div>
                          </div>
                        </li>
                        <li class="item_column unit">
                          <div class="inner">
                            <div class="unit_input">
                              <input
                                disabled=""
                                name="statement[item_rate]"
                                placeholder="Unit Price"
                                type="text"
                                data-input-restriction="number"
                                data-trigger="calculation"
                                data-calculation="rate"
                                data-autocomplete-fill="rate"
                                style="font-size: 12px !important"
                                v-model="item.price"
                              />
                              <div class="unit_lower"></div>
                            </div>
                          </div>
                        </li>
                        <li class="item_column amount">
                          <div class="inner">
                            <div class="total_input">
                              <input
                                disabled=""
                                class="with_addon total no_border_radius_left"
                                name="statement[item_amount]"
                                data-trigger="calculation"
                                data-format-number="precision"
                                data-calculation="line_total"
                                placeholder="0.00"
                                type="text"
                                style="font-size: 12px !important"
                                v-model="item.amount"
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div class="totals">
                  <div class="totals_container">
                    <ul class="statement_amount_container">
                      <li class="statement_amount">
                        <div class="col">Sub Total</div>
                        <input
                          class="col no_input"
                          type="text"
                          disabled=""
                          data-format-number="precision"
                          v-model="this.subtotal"
                          data-calculation="subtotal"
                        />
                      </li>
                    </ul>
                    <!-- <div id="tax_discount_shipping_wrapper">
                      <ul
                        class="statement_amount_container tds total tax"
                        data-tds-type="tax"
                      >
                        <li class="statement_amount">
                          <div class="col">
                            Tax (<span data-currency="code"
                              >{{ this.tax }} %</span
                            >)
                          </div>
                          <label
                            class="col no_input"
                            type="text"
                            disabled=""
                            data-calculation="item_tax_result"
                            >{{ this.taxvalue }}</label
                          >
                        </li>
                      </ul>
                    </div> -->
                    <div
                      id="tax_discount_shipping_wrapper"
                      v-for="(tax, k) in this.tax_list"
                      :key="k"
                    >
                      <ul
                        class="statement_amount_container tds total tax"
                        data-tds-type="tax"
                      >
                        <li class="statement_amount">
                          <div class="col">
                            {{ tax.tax_name }} (<span data-currency="code"
                              >{{ tax.tax_rate }}%</span
                            >)
                          </div>
                          <label
                            class="col no_input"
                            type="text"
                            disabled=""
                            data-calculation="item_tax_result"
                            >{{ tax.tax_amount }}</label
                          >
                        </li>
                      </ul>
                    </div>
                    <div id="item_tax_discount_shipping_wrapper"></div>
                    <ul class="statement_amount_container">
                      <li class="statement_amount" style="border-bottom: none">
                        <div class="col">
                          <b style="font-weight: bold !important">Total</b>
                          (<span data-currency="code">{{ this.currency }}</span
                          >)
                        </div>
                        <strong
                          ><input
                            class="col no_input bold"
                            type="text"
                            disabled=""
                            data-format-number="precision"
                            data-calculation="total"
                            v-model="this.total"
                        /></strong>
                      </li>
                    </ul>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
              <footer>
                <p>
                  <strong style="font-weight: bold !important">Email: </strong
                  >{{ this.email }}
                </p>
                <p style="white-space: pre-line">{{ this.notes }}</p>
              </footer>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import axios from "axios";
import base_url from "../../base_url.js";
// import html2pdf from "html2pdf.js";

const $ = require("jquery");
window.$ = $;

export default {
  data() {
    return {
      cname: "",
      image: "",
      uaddress: "",
      ucity: "",
      ustate: "",
      upincode: "",
      ucountry: "",
      taxname_one: "",
      taxno_one: "",
      taxname_two: "",
      taxno_two: "",
      taxno: "",
      taxvalue: "",
      name: "",
      caddress: "",
      ccity: "",
      cstate: "",
      cpincode: "",
      ccountry: "",
      invoice_no: "",
      date: "",
      due_date: "",
      subtotal: "",
      tax: "",
      total: "",
      email: "",
      notes: "",
      items: [],
      admin_id: "",
      tax_list: [],
    };
  },
  created() {
    this.start();
  },
  methods: {
    async start() {
      const response = await axios.get(
        `${base_url}/download_invoice/${this.$route.params.id}`
      );
      console.log("path id" + this.$route.params.id);
      console.log("donwload api call start");
      console.log(response);
      console.log("donwload api call end");
      this.cname = response.data.cname;
      this.uaddress = response.data.uaddress;
      this.ucity = response.data.ucity;
      this.ustate = response.data.ustate;
      this.upincode = response.data.upincode;
      this.ucountry = response.data.ucountry;
      this.admin_id = response.data.uid;
      if (response.data.taxname_one && response.data.taxno_one) {
        this.taxname_one =
          response.data.taxname_one + ": " + response.data.taxno_one;
      }
      if (response.data.taxname_two && response.data.taxno_two) {
        this.taxname_two =
          response.data.taxname_two + ": " + response.data.taxno_two;
      }
      if (response.data.client_type == "Organization") {
        this.name = response.data.organization;
      } else {
        this.name = response.data.name;
      }
      this.caddress = response.data.caddress;
      this.ccity = response.data.ccity;
      if (response.data.cstate) {
        this.cstate = response.data.cstate + ", ";
      }
      this.cpincode = response.data.cpincode;
      this.ccountry = response.data.ccountry;
      this.taxno = response.data.taxno;
      this.invoice_no = response.data.invoice_no;
      const res = await axios.post(
        // `${base_url}/forpdftabledata/${encodeURIComponent(this.invoice_no)}`
        `${base_url}/forpdftabledata/${this.$route.params.id}`
      );

      this.items = res.data;
      if (this.items.length == 5) {
        $("#page").addClass("highlight");
      } else {
        $("#page").removeClass("highlight");
      }
      this.date = this.convertDate(response.data.date);
      this.due_date = this.convertDate(response.data.due_date);
      this.subtotal = response.data.subtotal;
      this.currency = response.data.currency;
      if (response.data.tax) {
        this.tax = response.data.tax;
      } else {
        this.tax = 0;
      }
      await axios.post(`${base_url}/get_invoice_tax_details`, {
        	admin_id: this.admin_id,
        	invoice_no: this.$route.params.id
      	}).then((res) => {
        	console.log(res.data);
        	this.tax_list = res.data;
      	});
      this.total = response.data.total;
      this.taxvalue = parseFloat(
        (response.data.subtotal * response.data.tax) / 100
      ).toFixed(2);
      this.email = response.data.email;
      this.notes = response.data.notes;
      var element = document.getElementById("desk");
      var filename = "Invoice " + `${this.invoice_no}` + ".pdf";
      var doc = new jsPDF("p", "mm", "a4");
      doc.html(element, {
        callback: function (pdf) {
          this.image = response.data.image;
          // var imgData = `${base_url}/static/file_1648182519935.png`;
          var imgData = `${base_url}/static/${this.image}`;
          var totalPages = pdf.internal.getNumberOfPages();
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            if (i == 1) {
              pdf.setFontSize(25).text("Invoice", 13, 16);
            }
            // for image - > x,y,width,height
            pdf.addImage(imgData, "PNG", 150, 8, 50, 10);
          }
          // Save the PDF
          pdf.save(filename);
        },
        html2canvas: {
          allowTaint: true,
          useCORS: true,
        },
        margin: [10, 10, 10, 10],
        autoPaging: "text",
        x: 0,
        y: 0,
        pagebreak: {
          avoid: ["footer"],
        },
        enableLinks: true,
        width: 190, //target width in the PDF document
        windowWidth: 675, //window width in CSS pixels
      });
       this.$router.back();
    },
    convertDate: function (cvt_date) {
      var date = new Date(cvt_date);
      var year = date.getFullYear();
      var month = date.toLocaleString("default", { month: "short" });
      var dt = date.getDate();
      if (dt < 10) {
        dt = "0" + dt;
      }
      if (month < 10) {
        month = "0" + month;
      }
      const cvt_date_formate = month + " " + dt + ", " + year;
      return cvt_date_formate;
    },
  },
};
</script>

<style scoped>
footer p:nth-last-child(1) {
  margin-bottom: 0;
}

.product-table .one_item_line {
  display: flex !important;
  border-bottom: 2px solid #e7e7e7 !important;
  align-items: end;
}

.product-table .item_column {
  display: inline-block !important;
}

.product-table .item_row {
  display: block !important;
  width: 100%;
  min-height: 60px;
  overflow: hidden;
  padding: 10px 0;
}

.product-table .item_column.name_description {
  width: 50%;
  vertical-align: middle;
}

.product-table .item_column.quantity {
  width: 15%;
  vertical-align: middle;
}

.product-table .item_column.unit {
  width: 15%;
  vertical-align: middle;
}

.product-table .item_column.amount {
  width: 20%;
  vertical-align: middle;
}

.product-table .item_column_heading {
  line-height: 35px;
}

.loader {
  position: sticky;
  left: 47%;
  top: 40%;
  z-index: 1;
  width: 120px;
  height: 120px;
  margin: -76px 0 0 -76px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

#desk {
  margin: 0 auto;
  max-width: 980px;
  padding-bottom: 20px;
  font-size: 14px;
  position: relative !important;
}

.form_standard {
  -webkit-backface-visibility: hidden;
}

#desk.statement .board {
  margin-bottom: 20px;
}

#desk.statement.view .board:not(.inputs_enabled) input,
#desk.statement.view .board:not(.inputs_enabled) select,
#desk.statement.view
  .board:not(.inputs_enabled)
  [data-currency="code"]:not(.total) {
  tab-index: -1;
  background: transparent !important;
  border: 0 solid transparent !important;
  padding: 0 !important;
}

#desk.statement.view .board:not(.inputs_enabled) .statement_section {
  border-bottom: 0;
  margin-bottom: 10px;
}

.statement_section {
  margin-bottom: 30px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  float: left;
  width: 100%;
  height: auto;
  padding-bottom: 15px;
}

.item_rows {
  margin: 0;
  padding: 0;
  list-style: none;
  clear: both;
  position: relative;
}

#desk.statement.view header {
  border-bottom: 0;
  padding-bottom: 0;
}

#desk.statement header {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e7e7e7;
}

.statement_section .statement_logo_container {
  top: -3px;
}

.statement_section h1 {
  width: 180px;
}

.statement_section h1 {
  margin: 0 0 50px;
  position: absolute;
  right: 0;
}

.statement_logo_container a {
  display: block;
  padding: 10px;
  border: 2px dotted transparent;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  position: relative;
  display: block;
  width: 225px;
  height: 125px;
  float: right;
}

#desk.statement.view .statement_logo_container a {
  pointer-events: none;
  cursor: default;
}

.statement_logo_container img {
  max-width: 100%;
  max-height: 100%;
  float: right;
}

.hidden {
  display: none !important;
  visibility: hidden;
}

.title {
  margin: 0;
  line-height: 1;
  font-weight: normal;
}

#desk.statement header h2.title input {
  display: inline-block;
  width: auto;
}

input[type="text"],
input[type="search"],
input[type="email"],
input[type="password"],
input[type="number"] {
  padding: 0 5px;
  outline: none;
  font-weight: 400;
  line-height: 35px;
  height: 35px;
  color: #333333;
  -webkit-appearance: none;
  width: 100%;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: #fff;
  border: 2px solid #d7d7d9;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

#desk.statement header h2.title .statement_status {
  display: inline-block;
  margin-right: 10px;
  font-size: inherit;
  text-transform: capitalize;
  vertical-align: top;
  text-align: center;
  background: #e35256;
  font-weight: 400;
  padding: 7px 10px;
  color: #fff;
}

#desk.statement header h2.title .statement_status span {
  font-size: 19px;
  display: inline-block;
}

#desk.statement.view .hide_on_view {
  display: none !important;
}

.form_row.inline {
  padding-right: 20px;
}

#desk.statement.view .statement_details .form_heading {
  margin-bottom: 0;
}

#desk.statement.view .board:not(.inputs_enabled) .input_addon {
  cursor: default;
  pointer-events: none;
  background: transparent !important;
  border-color: transparent !important;
  width: 0;
  margin-right: 10px;
}

.input_addon {
  font-size: 14px;
  width: 45px;
  padding-top: 6px;
}

.input_addon {
  font-size: 15px;
  font-weight: 400;
  height: 35px;
  width: 30px;
  padding-top: 5px;
  display: inline-block;
  color: #555;
  text-align: center;
  border-right: none !important;
  margin-right: -5px;
  white-space: nowrap;
  vertical-align: bottom;
  background: #d7d7d9;
  border: 2px solid #d7d7d9;
  border-radius: 2px 0 0 2px;
  -webkit-border-radius: 2px 0 0 2px;
  -moz-border-radius: 2px 0 0 2px;
}

.max_100 {
  max-width: 100px !important;
}

.form_row {
  margin-top: 20px;
  margin-bottom: 20px;
}

.right {
  float: right;
}

.left {
  float: left;
}

select {
  text-transform: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  color: #4b4b57;
  display: inline-block;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  outline: 0;
  padding: 6px;
  text-align: left;
  width: 100%;
  height: 35px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: #f3f3f4;
  border: 2px solid #d7d7d9;
}

#desk.statement.view .board:not(.inputs_enabled) .select_arrows {
  display: none;
}

.form_row.currency_select {
  width: 66%;
}

.form_row.inline:last-of-type {
  padding-right: 0;
}

.inline {
  display: inline-block !important;
}

.statement_section .form_heading,
#desk.statement .page.recurring .form_row .form_heading,
#desk.statement .page.extra .form_row .form_heading {
  margin: 0 0 5px;
  padding: 0;
}

.statement_section .form_heading label {
  margin: 0;
  line-height: 1;
}

.statement_contacts {
  margin: 0 20px 0 0;
  width: 40%;
  float: left;
}

.address_from {
  min-height: 104px;
}

#desk.statement.view .form_row.address_from .form_heading,
#desk.statement.view .form_row.address_to .form_heading {
  margin-bottom: 10px !important;
}

.statement_section .form_heading label {
  font-weight: 600;
}

.relative {
  position: relative !important;
}

.statement_contacts p {
  margin: 0;
}

.statement_contacts .form_row,
.statement_contacts .form_row {
  margin: 0 0 15px;
  padding: 0;
}

#desk.statement.view .autocomplete_card {
  padding: 0;
  border: 0;
  background: transparent;
}

#desk.statement.view .autocomplete_card .close_icon {
  display: none;
  pointer-events: none;
  cursor: default;
}

#desk.statement.view .statement_details {
  width: 50%;
}

.statement_details {
  width: 35%;
  float: right;
}

.item_rows {
  margin: 0;
  padding: 0;
  list-style: none;
  clear: both;
  position: relative;
}

.one_item_line {
  margin: 0;
  padding: 0;
  width: 100%;
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: left;
  /* min-height: 60px; */
}

.item_row {
  margin: 0;
  padding: 0;
  list-style: none;
  display: table-row;
  border-collapse: collapse;
}

.item_column {
  margin: 0;
  padding: 0;
  display: table-cell;
  border-collapse: collapse;
  vertical-align: top;
}

.item_column_heading {
  margin: 0;
  padding: 0 10px;
  padding-bottom: 5px;
  /* border-bottom: 2px solid #e7e7e7; */
  font-size: 14px;
  color: #333;
  display: none;
  background: #ffffff;
  white-space: nowrap;
  font-weight: normal;
}

.item_column_heading.first {
  padding: 0 10px 5px 0;
}

.one_item_line:first-child .item_column_heading {
  display: block;
}

.item_column .inner {
  /* padding: 10px; */
}

#desk.receipt .item_column .inner {
  padding: 5px 10px;
}

.item_column.action .inner .relative {
  width: 38px;
}

.item_column.action .inner .relative ul.dropdown-menu {
  right: 0;
  left: auto;
}

.item_column .inner.first {
  padding: 10px 10px 10px 0;
}

.item_textarea {
  overflow: hidden;
  height: 55px;
}

.item_textarea p {
  margin: 0 0 10px !important;
}

.view_statement_textarea_replacement {
  height: auto;
  min-height: 34px;
  margin: 0;
  font-size: 12px;
}

#desk.statement .item_rows .item_column h2 {
  padding-left: 5px;
  text-align: right;
}

#desk.statement .item_rows .name_description h2 {
  padding-left: 0;
  text-align: left;
}

#desk.statement h3 {
  font-size: 14px;
  font-weight: inherit;
}

#desk.statement header {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e7e7e7;
}

.name_description .inner {
  padding-left: 0;
  padding-right: 5px;
  float: left;
  width: 100%;
  padding-top: 0 !important;
}

.item_column.quantity {
  width: 85px;
}

.item_column.quantity .inner {
  /* padding: 10px 5px; */
  padding-top: 0 !important;
}

.item_column.unit {
  width: 95px;
}

.item_column.unit .inner {
  padding: 10px 5px;
  padding-top: 0 !important;
}

.item_column.amount {
  width: 140px;
}

.item_column.amount .inner {
  padding: 10px 5px;
  padding-top: 0 !important;
}

.item_column.action {
  width: 45px;
}

.item_column.action .button {
  padding: 0;
  height: 35px;
  width: 38px;
  display: block;
  background: #f3f3f4;
}

.item_column.action .button.dropdown-toggle:before {
  left: 5px;
  top: 3px;
}

.item_column.action .button.dropdown-toggle:after {
  right: 5px;
  top: -1px;
}

.item_column.action .inner {
  padding: 10px 5px;
}

.item_textarea_container textarea {
  line-height: 130%;
  resize: vertical;
  overflow: hidden;
  width: 100%;
  border: 0;
  background: #fff;
}

#desk.files .files_area {
  margin-bottom: 25px;
}

.quantity_input {
  text-align: right;
  color: #999;
}

.quantity_input input {
  text-align: right;
  height: 20px !important;
}

.unit_input {
  text-align: right;
  color: #999;
}

.unit_input input {
  text-align: right;
  height: 20px !important;
}

.form_standard .unit_lower {
  margin-top: 5px;
  display: inline-block;
  width: 100%;
}

.form_standard .unit_lower .text_unit_input_css {
  width: 72%;
}

.total_input {
  text-align: right;
  color: #999;
}

.total_input input {
  text-align: right;
  height: 20px !important;
}

.form_list .form_list_set {
  margin: 0 0 20px;
  padding: 5px 10px;
}

#desk.statement .totals {
  margin-top: -28px;
}

#desk.statement .totals .totals_container {
  width: auto;
  max-width: 75%;
  float: right;
}

.statement_amount_container {
  margin: 0;
  padding: 0;
  width: 100%;
  float: left;
  list-style: none;
}

.statement_amount_container select {
  background: #fff;
}

.statement_amount .close_icon:after {
  font-family: "Ionicons";
  content: "\f128";
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  position: absolute;
  margin-top: 10px;
  color: #9d9d9d;
  cursor: pointer;
  margin-left: -23px;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  left: 0;
}

.statement_amount_container .statement_amount {
  margin: 0;
  padding: 7px;
  width: 100%;
  float: left;
  border-bottom: 1px solid #e7e7e7;
  height: 42px;
  position: relative;
}

.statement_amount_container.total_due .statement_amount {
  border: 3px solid;
  padding: 4px 8px;
  border-radius: 3px;
  border-left-width: 82px;
}

.statement_amount_container.total_due .td_label {
  margin-left: -106px;
  color: #fff;
}

.statement_amount_container.total_due .td_currency {
  display: inline-block;
  width: 30px;
}

.statement_amount_container.tds .statement_amount {
  padding: 7px 7px 7px 0;
}

.statement_amount .col {
  width: 30%;
  float: left;
  white-space: nowrap;
}

.statement_amount .col.second .inner {
  width: 67%;
}

.statement_amount .col:first-child,
.statement_amount .col:last-child {
  line-height: 25px !important;
}

.statement_amount .col + .col {
  text-align: right;
  width: 70%;
}

.statement_amount .col.first {
  width: 18% !important;
}

.statement_amount .col.second {
  width: 80% !important;
}

.statement_amount .col.third {
  width: 20% !important;
}

.form_standard input.with_addon:disabled {
  border-left: none;
}

.standard-search {
  display: block;
  margin-bottom: 0;
  float: right;
  position: relative;
}

@font-face {
  font-family: "Linearicons";
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "FriendlyFont";
  src: url(/fonts/FriendlyFont.eot);
  src: url(/fonts/FriendlyFont.eot) format("embedded-opentype"),
    url(/fonts/FriendlyFont.woff) format("woff"),
    url(/fonts/FriendlyFont.otf) format("opentype");
  font-style: normal;
  font-weight: 400;
}

[data-retina="false"] {
  display: block;
}

[data-retina="true"] {
  display: none;
}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  [data-retina="false"] {
    display: none;
  }

  [data-retina="true"] {
    display: block;
  }
}

html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  /*min-width: 1082px;*/
}

body {
  margin: 0;
  -webkit-font-smoothing: subpixel-antialiased;
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

* {
  letter-spacing: normal !important;
}

*,
:before,
:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

article,
aside,
footer,
header,
main,
menu,
nav,
section,
summary {
  display: block;
}

a {
  background: transparent;
}

a:active,
a:hover,
a:focus,
label:active,
label:hover,
label:focus,
button:hover,
button:hover,
button:focus {
  outline: 0;
}

b,
strong {
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-weight: normal !important;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

small {
  font-size: 80%;
}

img {
  border: 0;
}

hr {
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
}

button,
input,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}

button {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

select {
  text-transform: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  color: #4b4b57;
  display: inline-block;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  outline: 0;
  padding: 6px;
  text-align: left;
  width: 100%;
  height: 35px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: #f3f3f4;
  border: 2px solid #d7d7d9;
}

.dropdown-menu select:disabled {
  opacity: 0.5 !important;
}

button,
html input[type="button"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

input {
  line-height: normal;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

fieldset {
  border: 1px solid silver;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 10px 17px 10px 15px;
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

:before,
:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

html {
  font-size: 16px;
  -webkit-tap-highlight-color: transparent;
}

body {
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: #333333;
  background: #f3f3f4;
  position: relative;
  font-weight: 300;
  min-height: 100%;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  vertical-align: baseline;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

a {
  color: #2676a5;
  text-decoration: none;
}

a:hover,
a:focus {
  text-decoration: none;
}

figure {
  margin: 0;
}

img {
  vertical-align: middle;
}

hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #9d9d9d;
}

.x_page hr {
  border-color: #e8e8e9;
}

fieldset {
  padding: 0;
  margin: 0;
  border: 0;
  min-width: 0;
}

label {
  max-width: 100%;
}

input[type="search"] {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

input[type="radio"],
input[type="checkbox"] {
  margin-top: 1px \9;
  line-height: normal;
}

input[type="file"] {
  display: block;
}

.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background: #fff;
  border: 2px solid #c1c1c1;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.dropdown-menu li:first-of-type:hover {
  border-radius: 3px 3px 0 0;
  -webkit-border-radius: 3px 3px 0 0;
  -moz-border-radius: 3px 3px 0 0;
}

.dropdown-menu li:last-of-type:hover {
  border-radius: 0 0 3px 3px;
  -webkit-border-radius: 0 0 3px 3px;
  -moz-border-radius: 0 0 3px 3px;
}

.dropdown-menu.popover {
  top: 35px;
  width: 180px;
}

.textarea_actions.right .dropdown-menu.popover {
  left: -2px;
}

.save_button {
  padding: 6px 10px 0;
  height: 30px;
  display: inline-block;
  border: none;
  color: #fff;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  cursor: pointer;
}

.dropdown-menu .divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background: #e5e5e5;
}

.dropdown-menu > li > a,
.dropdown-menu.contains_button > li > a {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857;
  color: #434860;
  white-space: nowrap;
}

.dropdown-menu > li a.use_existing_tag_item {
  display: inline-block;
  width: auto !important;
  font-size: 13px;
}

.dropdown-menu > li a.cancel_link {
  display: inline-block;
  width: 50px !important;
}

.dropdown-menu > li .form_row {
  margin-top: 11px;
  margin-bottom: 2px;
}

.dropdown-menu > .active > a {
  color: #fff;
  text-decoration: none;
  outline: 0;
  background: #2c87e5;
}

.dropdown-menu > .disabled > a {
  color: #88888f;
}

.open > .dropdown-menu {
  display: block;
}

.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

body {
  font-size: 1em;
  line-height: 1.4;
}

img {
  vertical-align: middle;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

textarea {
  resize: vertical;
}

.hidden {
  display: none !important;
  visibility: hidden;
}

.visibility_hidden {
  visibility: hidden !important;
}

.visibility_hidden_absolute {
  visibility: hidden !important;
  position: absolute !important;
}

#desk.statement .totals {
  margin-top: -28px;
}

#desk.statement .totals .totals_container {
  width: auto;
  max-width: 75%;
  float: right;
}

.statement_amount_container {
  margin: 0;
  padding: 0;
  width: 100%;
  float: left;
  list-style: none;
}

.statement_amount_container select {
  background: #fff;
}

.statement_amount .close_icon:after {
  font-family: "Ionicons";
  content: "\f128";
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  position: absolute;
  margin-top: 10px;
  color: #9d9d9d;
  cursor: pointer;
  margin-left: -23px;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  left: 0;
}

.statement_amount_container.total_due .statement_amount {
  border: 3px solid;
  padding: 4px 8px;
  border-radius: 3px;
  border-left-width: 82px;
}

.statement_amount_container.total_due .td_label {
  margin-left: -106px;
  color: #fff;
}

.statement_amount_container.total_due .td_currency {
  display: inline-block;
  width: 30px;
}

.statement_amount_container.tds .statement_amount {
  padding: 7px 7px 7px 0;
}

.statement_amount .col {
  width: 30%;
  float: left;
  white-space: nowrap;
}

.statement_amount .col.second .inner {
  width: 67%;
}

.statement_amount .col + .col {
  text-align: right;
  width: 70%;
}

.statement_amount .col.first {
  width: 18% !important;
}

.statement_amount .col.second {
  width: 80% !important;
}

.statement_amount .col.third {
  width: 20% !important;
}

.form_standard input.with_addon:disabled {
  border-left: none;
}

.standard-search {
  display: block;
  margin-bottom: 0;
  float: right;
  position: relative;
}

.table_contact_autocomplete {
  float: left;
  display: inline-block;
  left: 0;
  width: 37px;
  height: 35px;
  margin-right: -1px;
  cursor: pointer;
  position: relative;
  z-index: 1;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  overflow: hidden;
}

.table_contact_autocomplete:not(.open):hover:before {
  color: #444;
}

.table_contact_autocomplete.open {
  width: 200px;
  margin-right: -2px;
}

.table_contact_autocomplete.open.recprofile {
  width: 205px;
}

.table_contact_autocomplete.open input[type="text"] {
  padding-left: 32px;
}

.table_contact_autocomplete.open.filled input[type="text"],
.table_contact_autocomplete.open.filled input[type="text"]:focus {
  background: #e0e0e2;
  cursor: default;
  pointer-events: none;
}

.table_contact_autocomplete.open.filled
  input[type="text"]
  + .remove_contact:before {
  color: #9d9d9d;
  font-family: "Ionicons";
  content: "\f129";
  font-size: 14px;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  right: 12px;
  top: 10px;
  -webkit-font-smoothing: antialiased;
  position: absolute;
}

.table_contact_autocomplete.open.filled
  input[type="text"]
  + .remove_contact:active:before {
  color: #666;
}

.table_contact_autocomplete:before {
  color: #9d9d9d;
  font-family: "Ionicons";
  content: "\f3a0";
  font-size: 17px;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  left: 12px;
  top: 8px;
  -webkit-font-smoothing: antialiased;
  position: absolute;
}

.table_contact_autocomplete.open:before {
  left: 11px;
}

.table_contact_autocomplete.open.filled.recprofile:before {
  content: "\f3a8";
}

.table_contact_autocomplete input[type="text"] {
  border: 2px solid #d7d7d9 !important;
  color: #868686 !important;
  border-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  padding: 4px 30px 4px 31px;
  background: #e0e0e2;
  cursor: pointer;
}

.table_contact_autocomplete.filled:after {
  color: #999;
  font-family: "Ionicons";
  content: "\f35f";
  font-size: 17px;
  margin-top: 1px;
  margin-left: 0;
  vertical-align: top;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  position: absolute;
  right: 10px;
}

.table_contact_autocomplete + .dropdown-menu a.selected:after {
  font-family: "Linearicons";
  font-size: 13px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 600;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
  content: "\e934";
  position: absolute;
  right: 13px;
}

.table_contact_autocomplete + .dropdown-menu {
  width: 175px;
}

.standard-search_container {
  display: block;
  position: relative;
  width: 260px;
  margin: 0 auto;
}

footer {
  overflow: auto;
  display: block;
}

.no_margin {
  margin: 0 !important;
}

.new_item {
  display: inline-block;
  line-height: 1;
  font-style: normal;
  line-height: 18px;
  padding: 8px 12px 0;
  height: 35px;
  font-size: 14px !important;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  color: #fff;
  text-align: center;
}

.new_item.dropdown-toggle {
  margin-top: 10px;
}

.x_form .new_item:not(.add_dynamic_fields) {
  margin-top: -10px;
  margin-bottom: 10px;
  width: 100%;
  border: none;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}

.inline {
  display: inline-block !important;
}

.left {
  float: left;
}

.right {
  float: right;
}

small {
  font-size: 0.85em;
}

.button.dropdown-toggle.select-all-none input[type="checkbox"] {
  position: relative;
  top: 7px;
  left: 5px;
}

:-webkit-input-placeholder {
  color: #999;
  font-weight: 300;
}

:-moz-placeholder {
  color: #999;
  font-weight: 300;
}

:-ms-input-placeholder {
  color: #999;
  font-weight: 300;
}

input,
textarea {
  outline: none;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

textarea {
  resize: vertical;
}

.form_standard {
  -webkit-backface-visibility: hidden;
}

input[type="text"],
input[type="search"],
input[type="email"],
input[type="password"],
input[type="number"] {
  padding: 0 5px;
  outline: none;
  font-weight: 400;
  /*line-height: 35px;*/
  height: 35px;
  color: #333333;
  -webkit-appearance: none;
  width: 100%;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: #fff;
  border: 2px solid #d7d7d9;
}

input[type="text"]:disabled,
input[type="search"]:disabled,
input[type="email"]:disabled,
input[type="password"]:disabled,
input[type="number"]:disabled {
  -webkit-text-fill-color: #333333;
  -webkit-opacity: 1;
  color: #333333;
}

#desk.settings input:disabled,
#desk input[readonly],
#desk textarea[readonly] {
  background: #d7d7d9 !important;
  color: inherit;
}

#desk.settings.small input.short,
#desk.settings.small select.short {
  max-width: 460px;
}

#desk.settings.editor textarea {
  background: #fff;
  width: 100%;
  height: 330px;
}

.unit_input input,
.quantity_input input {
  width: 99% !important;
}

.form_standard input[type="text"].with_addon,
.form_standard select.with_addon {
  width: 72%;
}

.form_standard input[type="text"].with_addon.total {
  width: 74%;
  z-index: 1;
  position: relative;
  background: #fff;
}

.form_standard input[type="text"].with_addon.total.border {
  width: 70%;
  border-radius: 0 2px 2px 0;
  -webkit-border-radius: 0 2px 2px 0;
  -moz-border-radius: 0 2px 2px 0;
}

.form_standard input[type="text"].with_addon_right,
.form_standard select.with_addon_right {
  float: left;
}

.form_row {
  margin-top: 20px;
  margin-bottom: 20px;
}

#desk.settings .form_row {
  margin-top: 0;
}

#desk.settings .form_row:last-of-type {
  margin-bottom: 0;
}

.form_row.inline {
  padding-right: 20px;
}

/*.statement_lang_curr_container {
    width: 53%
}*/
.form_row.currency_select {
  width: 66%;
}

.form_row.statement_description input,
.form_row.statement_description textarea {
  width: 62%;
  border: 2px solid #d7d7d9;
  background: transparent;
  padding-left: 5px;
}

.form_row.statement_description p {
  width: 62%;
}

/*.form_row.statement_description input:hover,
.form_row.statement_description textarea:hover {
    border: 2px solid #e7e7e7
}*/
.form_row.statement_description textarea:focus {
  border-color: #8c8c91;
}

.form_row.inline:last-of-type {
  padding-right: 0;
}

.input_addon {
  font-size: 15px;
  font-weight: 400;
  height: 35px;
  width: 30px;
  padding-top: 5px;
  display: inline-block;
  color: #555;
  text-align: center;
  border-right: none !important;
  margin-right: -5px;
  white-space: nowrap;
  vertical-align: bottom;
  background: #d7d7d9;
  border: 2px solid #d7d7d9;
  border-radius: 2px 0 0 2px;
  -webkit-border-radius: 2px 0 0 2px;
  -moz-border-radius: 2px 0 0 2px;
}

table .input_addon {
  padding-top: 8px;
}

.input_addon.on-right {
  border-radius: 0 2px 2px 0;
  -webkit-border-radius: 0 2px 2px 0;
  -moz-border-radius: 0 2px 2px 0;
}

.input_addon.total {
  display: inline-block;
  padding: 8px 0 4px 6px;
  width: 34px;
  font-size: 13px;
  z-index: 2;
  text-align: left;
  position: relative;
  background: #fff;
}

.input_addon.total.border {
  padding: 8px 7px 4px 6px;
  background: #d7d7d9;
  display: inline-block;
  text-align: center;
  width: 39px;
}

.input_addon.after {
  float: right;
  border: 1px solid #e7e7e7 !important;
  padding: 4.5px 10px;
  border-left: none !important;
  margin-right: 0;
  font-size: 14px;
}

.input_addon.fade {
  color: #a7a7a9;
}

textarea {
  padding: 5px 3px;
  border: 2px solid #d7d7d9;
  outline: none;
  -webkit-appearance: none;
  background: #fff;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  width: 100%;
}

select:focus {
  border-color: #8c8c91 !important;
}

textarea:focus,
input:not(.tds_name):not(.tds_rate):not([class^="css-"]):focus {
  background: #fff;
  border-color: #8c8c91;
}

.item_rows {
  margin: 0;
  padding: 0;
  list-style: none;
}

.item_row {
  margin: 0;
  padding: 10px 0;
  /* border-bottom: 1px solid #e7e7e7; */
  width: 100%;
}

.quantity_input {
  text-align: right;
  color: #999;
}

.quantity_input input {
  text-align: right;
  height: 20px !important;
}

.unit_input {
  text-align: right;
  color: #999;
}

.unit_input input {
  text-align: right;
  height: 20px !important;
}

.form_standard .unit_lower {
  margin-top: 5px;
  display: inline-block;
  width: 100%;
}

.form_standard .unit_lower .text_unit_input_css {
  width: 72%;
}

.total_input {
  text-align: right;
  color: #999;
}

.total_input input {
  text-align: right;
  height: 20px !important;
}

.form_list .form_list_set {
  margin: 0 0 20px;
  padding: 5px 10px;
}

#wrapper,
body,
html {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

#wrapper {
  width: 100%;
  position: relative;
  z-index: 1;
  background: #fff;
  -webkit-transition-property: -webkit-transform, left, right;
  -webkit-backface-visibility: hidden;
}

#wrapper {
  background: #fafafa;
}

h2,
.form_heading label,
strong {
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

/*.dropdown-toggle {
    *margin-bottom: -3px
}*/
.dropdown-toggle:active,
.open .dropdown-toggle {
  outline: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  padding: 0;
  margin: 5px 0 0;
  list-style: none;
  background: #fff;
  -webkit-background-clip: padding-box;
  -moz-background-clip: padding;
  background-clip: padding-box;
  -webkit-box-shadow: none;
  box-shadow: none;
  box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.2);
}

.table_sorting + .dropdown-menu:before {
  content: "Sort results by";
  width: 100%;
  text-align: left;
  padding: 4px 10px;
  background: #e8e8e9;
  display: block;
  font-size: 13px;
}

.table_sorting + .dropdown-menu {
  width: 200px;
}

.table_sorting + .dropdown-menu li {
  position: relative;
}

.table_sorting + .dropdown-menu li a {
  cursor: default;
}

.table_sorting + .dropdown-menu li a i {
  cursor: pointer;
}

.table_sorting + .dropdown-menu li a:hover {
  background: #ffffff;
}

.table_sorting + .dropdown-menu li a i:before {
  font-family: "Linearicons";
  font-size: 13px;
  margin-top: -3px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 600;
  font-variant: normal;
  text-transform: none;
  content: "\e673";
  position: absolute;
  right: 0px;
  font-style: initial;
  background: #f5f5f5;
  padding: 10px 10px;
  width: 33px;
  height: 40px;
  top: 3px;
}

.table_sorting + .dropdown-menu li a i:hover:before {
  background: #d7d7d9;
}

.table_sorting + .dropdown-menu li a i.asc:before {
  content: "\e939";
}

.table_sorting + .dropdown-menu li a i.desc:before {
  right: 33px;
  content: "\e93a";
}

.dropdown.in_table .dropdown-menu {
  box-sizing: border-box;
  float: right;
  left: auto;
  right: 0;
}

.dropdown-menu > li {
  float: none;
}

.dropdown-menu:not(.popover) li:not(.nohover):hover,
.dropdown-menu:not(.popover) li:not(.nohover).selected {
  background: rgba(0, 0, 0, 0.05);
}

.dropdown-menu.popover > li {
  padding: 8px;
}

.dropdown-menu.popover > li.border {
  border-top: 1px solid #e7e7e7;
}

.dropdown-menu.popover > li.gray {
  background: #fafafa;
}

.dropdown-menu.popover > li .new_item {
  border: none;
  background: transparent;
  padding: 2px 5px;
  height: 25px;
  text-align: left;
  color: #2676a5 !important;
}

.dropdown-menu > li.separator {
  border-top: 2px solid #d7d7d9;
}

.dropdown-menu li:first-child {
  border-top: 0 !important;
}

.dropdown-menu > li a,
.dropdown-menu.contains_buttons > li button {
  display: block;
  padding: 10px;
  clear: both;
  font-weight: 400;
  line-height: 20px;
  color: #000;
  cursor: pointer;
  white-space: nowrap;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  width: 100% !important;
}

.dropdown-menu.contains_buttons > li button {
  background: none;
  border: 0;
  text-align: left;
}

*,
::before,
::after {
  box-sizing: border-box;
}

body {
  font-size: 14px;
  color: #333333;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-weight: 400;
  position: relative;
}

a:hover,
a:focus {
  text-decoration: none !important;
  outline: none;
}

.button:hover:before,
.button:hover:after,
.button.clipboard:hover,
.button.reset_access_key:hover {
  color: #333 !important;
}

.button.delete:before {
  color: #999;
  font-family: "Ionicons";
  content: "\f37f";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 5px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.button.archive:before {
  color: #999;
  font-family: "Ionicons";
  content: "\f102";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 5px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.button.activate:before {
  color: #999;
  font-family: "Ionicons";
  content: "\f2a9";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 5px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.button.recover:before {
  color: #999;
  font-family: "Ionicons";
  content: "\f3a8";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 5px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.button.cancel:before {
  color: #999;
  font-family: "Ionicons";
  content: "\f36e";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 5px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.button.mark_unpaid:before {
  color: #999;
  line-height: 1;
  font-family: "Linearicons";
  font-size: 16px;
  margin-top: 5px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
  content: "\e99a";
}

.button.mark_paid:before {
  color: #999;
  font-family: "Linearicons";
  font-size: 16px;
  margin-top: 5px;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
  content: "\e999";
}

.button.dropdown-toggle:before {
  color: #999;
  font-family: "Ionicons";
  content: "\f2f7";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 5px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.button.dropdown-toggle.download:before {
  color: #999;
  font-family: "Ionicons";
  content: "\f2dd";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 4px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  left: 11px;
  top: 3px;
}

.button.dropdown-toggle.convert:before {
  color: #999;
  font-family: "Ionicons";
  content: "\f266";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 5px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  left: 11px;
  top: 1px;
}

.button.dropdown-toggle.mark:before {
  color: #999;
  font-size: 14px;
  margin-top: 5px;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
  content: "\e999";
  content: "Mark";
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.button.edit,
.button.revert,
.button.table_sorting:not(.dropdown-toggle),
.button.download:not(.dropdown-toggle),
.button.dropdown-toggle.in_table {
  height: 39px;
  width: 39px;
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px;
  background: #f5f5f5;
}

.button.dropdown-toggle.in_table {
  margin-left: 10px;
  width: 39px;
}

.button.dropdown-toggle.add_new.in_table:before {
  content: "\f396";
  left: 12px;
  top: 4px;
}

.button.dropdown-toggle.add_new.in_table:after {
  display: none;
}

.button.revert {
  margin-left: 10px;
}

.button.clipboard,
.button.reset_access_key {
  width: 85px;
  display: inline-block;
  vertical-align: middle;
  padding: 9px 0;
  background: #f5f5f5;
  color: #999;
  margin-right: 10px;
}

#desk.statement .button.clipboard {
  margin-right: 0;
  background: transparent;
}

.button.reset_access_key {
  width: auto;
  padding: 5px 10px;
  margin-left: 10px;
  margin-right: 0;
  float: right;
  margin-top: -20px;
}

span.copied {
  display: none;
}

.button.edit:before,
.button.revert:before,
.button.download:not(.dropdown-toggle):before,
.button.table_sorting:not(.dropdown-toggle):before {
  color: #999;
  font-family: "Ionicons";
  font-size: 16px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 9px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.button.edit:before {
  content: "\f2bf";
}

.button.revert:before {
  content: "\f4c7";
}

.button.download:before {
  content: "\f2dd";
}

.button.dropdown-toggle.table_sorting:before {
  font-size: 18px;
  left: 11px;
  top: 1px;
  content: "\f394";
}

.button.dropdown-toggle:after {
  color: #999;
  font-family: "Ionicons";
  content: "\f35f";
  font-size: 17px;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 9px;
  margin-left: 0;
  vertical-align: top;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.new_item.dropdown-toggle:after {
  color: #fff;
  font-family: "Ionicons";
  content: "\f35f";
  font-size: 17px;
  margin-bottom: 10px;
  margin-top: 1px;
  margin-left: 8px;
  vertical-align: top;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

#desk.statement footer a.button:before {
  color: #fff !important;
  font-family: "Ionicons";
  content: "\f2f7";
  font-size: 18px;
  margin-right: 8px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
}

#desk.statement footer a:not(.button) {
  color: inherit;
}

.item_area .one_item_line .drag_item {
  position: absolute;
  left: -5px;
  margin-top: 10px;
  color: #9d9d9d;
}

.item_area .one_item_line .drag_item:after {
  content: "\e87e";
  font-size: 16px;
  font-family: "Linearicons";
  line-height: 1;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  height: 61px;
  padding: 5px 0 0 3px;
  width: 26px;
  border: 2px solid #fff;
}

.item_area .one_item_line:first-child .item_column_heading {
  display: none;
}

.item_area .one_item_line .drag_item:hover:after {
  color: #000;
  background: #d7d7d9;
  border: 2px solid #d7d7d9;
  cursor: pointer;
}

.item_rows.item_area {
  /* margin-left: -20px; */
}

.item_area .one_item_line {
  /* padding-left: 20px; */
  display: block;
  border-bottom: 1px solid #e7e7e7;
}

.item_area .item_row {
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: left;
}

.item_area .one_item_line {
  cursor: default !important;
  display: flex !important;
    align-items: center;
}

.back_button {
  margin-left: 217px;
  color: #fff;
  padding: 8px 13px 7px;
  background: rgba(0, 0, 0, 0.47);
  border-radius: 2px;
  margin-right: 10px;
  font-size: 14px;
  margin-top: 6px;
  display: inline-block;
  height: 34px;
}

.back_button.secondary {
  margin-left: 0;
  margin-top: 15px;
  margin-right: 20px;
  float: left;
}

.dropdown-toggle:not(.attach_button).open:after,
.button.dropdown-toggle.open:after {
  content: "\f365" !important;
}

.back_button:before {
  margin-right: 10px;
  margin-top: 2px;
  font-family: "Ionicons";
  content: "\f124";
  font-size: 12px !important;
}

.sidebar_menu {
  z-index: 1;
  position: absolute;
  top: auto;
  bottom: 0;
  display: none;
  width: 100%;
  height: 100%;
  background: #2591e9;
  color: #fefefe;
  -webkit-transform: translate(0, 100%);
  transform: translate(0, 100%);
  overflow-y: auto;
}

.sidebar_menu ul.disabled {
  cursor: default;
  opacity: 0.2;
  pointer-events: none;
}

html.admin .sidebar_menu ul.disabled {
  margin-top: 137px;
}

html.user .sidebar_menu ul.disabled {
  margin-top: 94px;
}

html.permission_no_delete .permission_delete:not(form),
html.permission_no_edit .permission_edit:not(form),
html.permission_no_create .permission_create:not(form) {
  display: none !important;
}

html.permission_no_edit form.permission_edit input,
html.permission_no_edit form.permission_edit select,
html.permission_no_edit form.permission_edit textarea {
  pointer-events: none;
  cursor: default !important;
  border: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}

html.permission_no_edit form.permission_edit .select_arrows,
html.permission_no_edit form.permission_edit .add_dynamic_fields {
  display: none;
}

html.no_file_upload .attach_button.uploadify {
  display: none;
}

html.no_save_tds .dropdown-menu.popover.tax input.remember_tag,
html.no_save_tds .dropdown-menu.popover.tax input.remember_tag + label,
html.no_save_tds .dropdown-menu.popover.discount input.remember_tag,
html.no_save_tds .dropdown-menu.popover.discount input.remember_tag + label,
html.no_save_tds .dropdown-menu.popover.shipping input.remember_tag,
html.no_save_tds .dropdown-menu.popover.shipping input.remember_tag + label,
html.no_save_tds .statement_amount_container.tds input[type="checkbox"],
html.no_save_tds .statement_amount_container.tds input[type="checkbox"] + label,
html.max_items_reached .dropdown-menu.popover.tags input.remember_tag,
html.max_items_reached .dropdown-menu.popover.tags input.remember_tag + label,
html.max_items_reached [data-popup-id="new_saved_item"] {
  display: none !important;
}

.sidebar_menu ul li a {
  padding: 5px 10px;
  line-height: 1.4;
  font-size: 14px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-weight: 500;
}

.sidebar_menu ul li a.new {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  height: 47px;
  width: 50px;
  text-align: center;
  padding: 0;
  color: #fff;
  padding-top: 16px;
  background: rgba(0, 0, 0, 0);
}

.sidebar_menu ul li.current a.new:hover {
  background: rgba(0, 0, 0, 0.13);
}

.sidebar_menu ul li a.new:hover {
  background: rgba(0, 0, 0, 0.13);
}

.sidebar_menu ul li a.new:after {
  font-family: "Ionicons";
  font-size: 14px;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  vertical-align: middle;
  content: "\f218";
  margin-top: -4px;
  display: inline-block;
}

.sidebar_menu ul li a.new.upgrade_required {
  padding-top: 12px;
}

.sidebar_menu ul li a.new.upgrade_required:hover {
  background: transparent;
  color: #fff;
}

.sidebar_menu ul li a.new.upgrade_required:after {
  font-family: "Linearicons";
  content: "\e7b9";
  font-size: 20px;
  display: inline-block;
  margin-top: -3px;
}

.sidebar_menu ul li:hover a.new {
  display: block;
}

.sidebar_menu ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.sidebar_menu ul li a {
  display: block;
  text-decoration: none;
  color: #fff;
  white-space: nowrap;
}

.sidebar_menu ul li {
  border-bottom-style: solid;
  border-width: 1px;
  border-color: #fff;
  padding: 0;
  position: relative;
}

.sidebar_menu ul.sb_menu li a span.sidebar_menu_link_text {
  margin-left: 5px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  top: 1px;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.sidebar_menu ul.sb_menu li a.coming_soon:hover {
  cursor: default;
  pointer-events: none;
}

.sidebar_menu ul.sb_menu li a.coming_soon:hover {
  background: none;
}

.sidebar_menu ul.sb_menu li a.coming_soon span.coming_soon {
  color: #fff;
  background: #e35256;
  font-size: 11px;
  padding: 4px;
  border-radius: 3px;
  vertical-align: middle;
  margin-left: 10px;
  margin-top: -4px;
}

.sidebar_menu ul.sb_menu li a span.sidebar_menu_link_text:before {
  font-family: "Linearicons";
  font-size: 20px;
  margin-right: 10px;
  margin-top: -3px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
}

.sidebar_menu ul.sb_menu li a.dashboard span:before {
  content: "\e7f8";
}

.sidebar_menu
  ul.sb_menu
  li
  a.reports
  span:not(.coming_soon):not(.hide_compact):before {
  content: "\e7fb";
}

.sidebar_menu ul.sb_menu li a.invoices span:before {
  content: "\e6b5";
}

.sidebar_menu ul.sb_menu li a.bills span:before {
  content: "\e6b4";
}

.sidebar_menu ul.sb_menu li a.estimates span:before {
  content: "\e6b3";
}

.sidebar_menu ul.sb_menu li a.track span:before {
  content: "\e8ea";
}

.sidebar_menu ul.sb_menu li a.connections span:before {
  content: "\e726";
}

.sidebar_menu ul.sb_menu li a.files span:before {
  content: "\e6b8";
}

.sidebar_menu ul.sb_menu li a.trash span:before {
  content: "\e681";
}

.sidebar_menu
  ul.sb_menu
  li
  a.business_settings
  span:not(.hide_mobile):not(.hide_compact):before {
  content: "\e673";
}

.sidebar_menu ul.sb_menu li a span.hide_compact:before {
  content: none !important;
}

.sidebar_menu {
  position: fixed;
  z-index: 99999999;
  width: 210px;
  height: 100%;
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
  overflow: visible;
  float: left;
  display: block;
  background: #333333;
}

.sidebar_menu ul {
  display: block;
  margin: 20px auto 0;
  margin-left: 0;
}

.sidebar_menu ul li {
  border: none;
  clear: both;
  width: 100%;
}

.sidebar_menu ul li a {
  color: rgba(255, 255, 255, 0.8);
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  padding: 11px 0 11px 16px;
  height: 47px;
}

.sidebar_menu ul.disabled li a {
  color: rgba(255, 255, 255, 1);
}

.sidebar_menu ul:not(.disabled) li.current a:not(.new) {
  background: rgba(0, 0, 0, 0.25);
  color: #fff;
}

.sidebar_menu ul:not(.disabled) li a.active,
.sidebar_menu
  ul:not(.account):not(.disabled)
  li:not(.current):hover
  a:not(.new) {
  background: rgba(0, 0, 0, 0.12);
  color: #fff;
}

main {
  margin: 0 auto;
  padding: 0 16px 16px;
  min-height: 100%;
  margin: 0 0 0 210px;
  padding: 0;
  min-height: initial;
}

#desk {
  margin-right: 30px;
  padding-bottom: 20px;
  font-size: 14px;
  position: relative !important;
}

#desk.static,
#desk.small,
#desk.medium {
  max-width: none;
}

#desk.statement {
  max-width: 980px;
}

#desk.dashboard {
  max-width: none !important;
}

#container {
  background: #f3f3f4;
  padding-bottom: 50px;
  margin-left: 30px;
}

#container .announcement {
  width: auto;
  display: block;
  background: #fff;
  margin-bottom: 30px;
  border-radius: 3px;
  border: 2px solid #d7d7d9;
}

#container .announcement .announcement_content {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
}

#container .announcement .announcement_content .left,
#container .announcement .announcement_content .right {
  padding: 5px 20px;
  width: 50%;
}

#container .announcement .announcement_content .left {
  border-right: 1px solid #d7d7d9;
  padding-top: 15px;
}

#container .announcement .announcement_content .right {
  background: #f3f3f4;
}

#container .announcement .announcement_content h1 {
  font-size: 18px;
  margin-top: 20px;
}

#container .announcement .announcement_content ul {
  padding: 0;
  padding-left: 15px;
  font-size: 14px;
}

#container .announcement .announcement_content ul li {
  margin-bottom: 1px;
}

#container .announcement .announcement_header {
  padding: 5px 20px 5px 10px;
}

#container .announcement .announcement_content {
  border-top: 1px solid #d7d7d9;
}

#container .announcement .announcement_content form .form_row label {
  display: block;
  color: #8c8c91;
  font-size: 14px;
  margin-bottom: 5px;
}

#container .announcement .announcement_content form .form_row:last-of-type {
  margin-bottom: 0;
  margin-top: 25px;
}

#container .announcement .announcement_content form .form_row input {
  padding: 0 5px;
  outline: none;
  font-weight: 400;
  line-height: 35px;
  height: 35px;
  color: #333333;
  -webkit-appearance: none;
  width: 100%;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: #fff;
  border: 2px solid #d7d7d9;
  font-size: 14px;
}

#container .announcement .announcement_content form .form_row input:focus {
  border-color: #00a3d3;
}

#container .announcement .announcement_content form .form_row button {
  background: #00a3d3;
  color: #fff;
  text-align: center;
  padding: 0 10px;
  border: none;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  height: 36px;
  margin: 0;
  cursor: pointer;
  font-weight: 300;
  position: relative;
  font-size: 14px;
}

#container
  .announcement
  .announcement_content
  form
  .form_row
  button.loading:before {
  left: 37px !important;
}

#container .announcement .announcement_content form .form_row a.cancel_import {
  color: inherit;
  margin-left: 10px;
  font-size: 14px;
}

#container .announcement img {
  display: inline-block;
  float: left;
  margin-top: 7px;
}

#container .announcement p {
  display: inline-block;
  font-size: 14px;
  float: right;
}

#container .announcement p a:not(.normal_style) {
  padding: 11px 16px;
  font-size: 15px;
  text-align: center;
  outline: none;
  line-height: 1;
  text-decoration: none;
  display: inline-block;
  background: #00a3d3;
  color: #fff;
  font-weight: 400;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border: none;
  margin-left: 10px;
  cursor: pointer;
  position: relative;
}

#container {
  background: #f3f3f4;
  padding-bottom: 50px;
}

#desk .board.free {
  border: 0;
  background: transparent;
}

#desk.multiple .board {
  margin-bottom: 20px;
}

#desk.multiple .board:last-of-type {
  margin-bottom: 0;
}

#desk.dashboard .board.multiple_boxes .page,
#desk.dashboard .board:not(.multiple_boxes) {
  border-color: #d1d1d1;
  border-width: 2px;
}

#desk.dashboard .board.multiple_boxes .page {
  max-width: 50%;
}

#desk ul.blank {
  padding: 0;
  list-style: none;
  margin: 0;
}

#desk.dashboard ul.ataglance li {
  padding: 10px 20px;
  border-top: 1px solid #e8e8e9;
}

#desk.dashboard ul.ataglance li:first-of-type {
  border-top: none;
}

#desk.dashboard ul.ataglance li:before {
  font-family: "Ionicons";
  font-size: 18px;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-top: -4px;
  content: "\f3a8";
  margin-right: 10px;
}

#desk.dashboard ul.ataglance li.monthly_rec_rev:before {
  content: "\f26e";
}

#desk.dashboard ul.ataglance li.overdue:before {
  content: "\f3bc";
}

#desk.dashboard ul.ataglance li.total_received:before {
  content: "\f383";
}

#desk.dashboard ul.ataglance li.number_clients:before {
  content: "\f39e";
}

#desk.dashboard ul.ataglance li.time_to_pay:before {
  content: "\f3b3";
}

#desk.dashboard ul.linked_list li {
  padding: 10px 20px;
  border-top: 1px solid #e8e8e9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#desk.dashboard ul.linked_list a {
  color: inherit;
}

#desk.dashboard ul.linked_list a:hover li {
  color: inherit;
  background: rgba(243, 243, 243, 0.4);
}

#desk.dashboard ul.linked_list a:first-of-type li {
  border-top: none;
}

#desk.dashboard .board #main-chart {
  padding: 20px;
}

#desk.dashboard .board #pie-chart {
  float: left;
  height: 160px;
  width: 40%;
}

#desk.dashboard .board .no_data {
  position: absolute;
  left: 3%;
  top: 110px;
  color: #d7d7d9;
}

#desk.dashboard ul.legend {
  /*float: right;*/
  height: 160px;
  width: 54%;
  padding-top: 20px;
}

#desk.dashboard ul.legend li {
  padding: 7px 10px;
  background: #e8e8e9;
  margin-bottom: 7px;
  color: #333333;
  border-left: 10px solid;
  border-color: #333333;
  max-width: 260px;
}

#desk.dashboard ul.legend li:hover {
  background: rgba(54, 59, 77, 0.2);
}

#desk.dashboard ul.legend li.received {
  border-color: #3da07b;
}

#desk.dashboard ul.legend li.received:hover {
  background: rgba(61, 160, 123, 0.3);
}

#desk.dashboard ul.legend li.outstanding {
  border-color: #e35256;
}

#desk.dashboard ul.legend li.outstanding:hover {
  background: rgba(227, 82, 86, 0.3);
}

#desk.dashboard .board.chart .box_header {
  background: #e8e8e9;
  border-color: #e8e8e9;
}

#desk.dashboard #comparison-chart .highcharts-axis {
  display: none;
}

.highcharts-container {
  overflow: visible !important;
}

.graph_tooltip_new {
  background: #f5f5f5;
  border: 1px solid #d7d7d9;
  padding: 5px 5px;
  line-height: 20px;
  border-radius: 2px;
  box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.2);
}

#desk.dashboard #comparison-chart .tooltip_item {
  display: block;
  margin-bottom: 3px;
  font-family: inherit;
}

#desk.dashboard #main-chart .tooltip_item {
  background: #e8e8e9;
  border: 1px solid #d7d7d9;
  padding: 5px;
  border-radius: 3px;
  margin: 0 auto;
}

#desk.dashboard #comparison-chart .tooltip_item.Invoiced {
  color: #3da07b;
}

#desk.dashboard #comparison-chart .tooltip_item.Expenses {
  color: #e35256;
}

#desk .board .page.red {
  border-color: #e35256 !important;
  border-width: 2px !important;
}

#desk .board .page.green {
  border-color: #3da07b !important;
  border-width: 2px !important;
  color: inherit !important;
}

#desk .board .page.red .box_header {
  background: #e35256;
  color: #fff;
  font-weight: 400;
  border-color: #e35256;
}

#desk .board .page.green .box_header {
  background: #3da07b;
  color: #fff !important;
  font-weight: 400;
  border-color: #3da07b;
}

.board header.box_header {
  padding: 10px 20px;
  border-bottom: 1px solid #e8e8e9;
  background: #e8e8e9;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-weight: normal !important;
}

.board header.box_header a {
  float: right;
  font-weight: 400;
  cursor: pointer;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

/*.board header.box_header a.delete_business:before {
    font-family: 'Linearicons';
    font-size: 20px;
    margin-right: 7px;
    margin-top: -8px;
    vertical-align: text-top;
    display: inline-block;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-font-smoothing: grayscale;
    content: "\e681"
}*/
.board .page {
  padding: 16px 0;
}

.board {
  position: relative;
  background: #fff;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  margin-bottom: -12px;
  padding: 0;
  border: 0;
}

#desk.statement .board {
  margin-bottom: 20px;
}

#desk.settings .board.submit {
  border: 0;
  background: transparent;
  position: relative;
  box-shadow: none;
}

.board:after {
  content: "";
  display: table;
  clear: both;
}

.board .page {
  padding-top: 25px !important;
  padding-left: 50px !important;
  padding-right: 50px !important;
  /* padding-bottom: 50px !important; */
  float: left;
  width: 100%;
}

#desk .board.multiple_boxes {
  background: transparent;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
}

#desk .board.multiple_boxes .page {
  display: inline-block;
  background: #fff;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border: 2px solid #d7d7d9;
  margin: 0 20px 0 0;
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column;
}

#desk .board.multiple_boxes.subscription_plans {
  border-top: 1px solid #e8e8e9;
  padding-top: 20px;
  text-align: center;
}

#desk .board.multiple_boxes.subscription_plans .page.current {
  border-color: #333;
}

#desk .board.multiple_boxes.subscription_plans .page .header {
  border-bottom: 0 solid #d7d7d9 !important;
  padding: 15px 20px 0;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  float: none;
}

#desk .board.multiple_boxes.subscription_plans .page .header:before {
  font-family: "Linearicons";
  margin-right: 10px;
  margin-top: -5px;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
  display: inline-block;
  font-size: 27px;
  vertical-align: middle;
  color: #c7c7c9;
}

#desk .board.multiple_boxes.subscription_plans .page.current .header:before {
  color: #333;
}

#desk .board.multiple_boxes.subscription_plans .page.free .header:before {
  content: "\e7c6";
}

#desk .board.multiple_boxes.subscription_plans .page.basic .header:before {
  content: "\e7c9";
}

#desk
  .board.multiple_boxes.subscription_plans
  .page.professional
  .header:before {
  content: "\e7ca";
}

#desk .board.multiple_boxes.subscription_plans .page.enterprise .header:before {
  content: "\e7d2";
}

#desk .board.multiple_boxes.subscription_plans .page .stretch {
  height: 480px;
  /* requested by andreas @ticket #223 */
}

#desk .board.multiple_boxes .page:last-of-type {
  margin-right: 0 !important;
}

#desk .board.multiple_boxes.subscription_plans .page.highlighted section.basic {
  border-color: #e8e8e9;
}

#desk
  .board.multiple_boxes.subscription_plans
  .page.highlighted
  section.professional {
  border-bottom: 1px solid;
}

#desk .board.multiple_boxes.subscription_plans .page.highlighted {
  background: #eee;
  background: -moz-linear-gradient(top, #fff 10%, #d9d9d9 100%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(10%, #fff),
    color-stop(100%, #d9d9d9)
  );
  background: -webkit-linear-gradient(top, #fff 10%, #d9d9d9 100%);
  background: -o-linear-gradient(top, #fff 10%, #d9d9d9 100%);
  background: -ms-linear-gradient(top, #fff 10%, #d9d9d9 100%);
  background: linear-gradient(to bottom, #fff 10%, #e9e9e9 100%);
}

#desk .board.multiple_boxes.subscription_plans .page.highlighted .action a {
  background: #3da07b;
  border-color: #3da07b !important;
  color: #fff;
}

#desk .board.multiple_boxes.subscription_plans .page.highlighted section {
  border-color: #d8d8d9 !important;
}

#desk .board.multiple_boxes.subscription_plans .page .action {
  padding: 10px;
}

#desk .board.multiple_boxes.subscription_plans .page .action a {
  font-size: 14px;
  text-align: center;
  margin: 0 auto;
  width: 100%;
  display: block;
  color: #000;
  border: 1px solid #d7d7d9 !important;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  padding: 7px 0;
}

#desk .board.multiple_boxes.subscription_plans .page .action a.disabled {
  border-color: rgba(0, 0, 0, 0) !important;
  cursor: default;
  pointer-events: none;
  background: inherit;
  color: inherit !important;
}

#desk .board.multiple_boxes.subscription_plans .page ul.features {
  margin: 0;
  list-style: none;
  padding: 0;
  text-align: center;
}

#desk
  .board.multiple_boxes.subscription_plans
  .page
  section.expandable
  ul.features {
  display: none;
}

#desk .board.multiple_boxes.subscription_plans .page ul.features li {
  padding: 4px 0;
  margin-left: 10px;
  text-align: left;
}

#desk .board.multiple_boxes.subscription_plans .page ul.features li:before {
  content: "+";
  padding-right: 10px;
  font-weight: 700;
  font-size: 15px;
}

#desk
  .board.multiple_boxes.subscription_plans
  .page.highlighted
  ul.features
  li:before {
  color: #3da07b;
}

#desk
  .board.multiple_boxes.subscription_plans
  .page
  ul.features
  li:last-of-type {
  border-bottom: none;
  padding-bottom: 0;
}

#desk
  .board.multiple_boxes.subscription_plans
  .page
  ul.features
  li:first-of-type {
  padding-top: 0;
}

#desk .board.multiple_boxes.subscription_plans .page .pricing {
  text-align: center;
  font-size: 16px;
}

#desk .board.multiple_boxes.subscription_plans .page .pricing span.monthly {
  background: #e3f5ee;
  color: #3da07b;
  border: 1px solid #b8e5d4;
  font-weight: 400;
  font-size: 16px;
  display: inline-block;
  margin: 0 auto 10px;
  padding: 8px 10px 6px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
}

#desk .board.multiple_boxes.subscription_plans .page .pricing span.yearly {
  font-size: 14px;
  display: none;
  color: #a1a1a1;
}

#desk
  .board.multiple_boxes.subscription_plans
  .page.highlighted
  .pricing
  span.monthly {
  background: #3da07b;
  color: #fff;
  border-color: #3da07b;
}

#desk section.plan_summary ul {
  padding: 0;
  list-style: none;
  margin-bottom: 0;
}

#desk section.plan_summary ul li {
  color: #8c8c91;
  font-size: 13px;
  font-weight: 400;
}

#desk section.plan_summary ul li:before {
  content: "+ ";
}

#desk section.invoices ul li {
  border-bottom: 1px solid #e8e8e9;
  padding: 15px 0;
  height: 50px;
}

#desk section.invoices ul li .status {
  color: #fff;
  background: #3da07b;
  padding: 5px;
  border-radius: 2px;
  font-size: 13px;
  margin-right: 10px;
}

#desk section.invoices ul li .status.due {
  background: #e35256;
}

#desk section.invoices ul li .date {
  font-weight: 700;
}

#desk section.invoices ul li a {
  padding: 8px;
  background: #f5f5f5;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  font-size: 13px !important;
  border: 1px solid #d7d7d9;
  color: #444;
}

#desk section.invoices ul li a.pay {
  margin-right: 10px;
  background: #e35256;
  color: #fff;
  border-color: #e35256;
}

#desk section.payment_methods ul li {
  border-bottom: 1px solid #e8e8e9;
  padding: 10px 0;
}

#desk section.payment_methods ul li:first-of-type,
#desk section.invoices ul li:first-of-type {
  padding-top: 0;
}

#desk section.invoices ul li:first-of-type,
#desk section.invoices ul li:last-of-type {
  height: 35px;
}

#desk section.invoices ul li:first-of-type {
  margin-top: 5px;
}

#desk section.invoices ul li:last-of-type {
  padding-bottom: 25px !important;
}

#desk section.payment_methods ul li:last-of-type,
#desk section.invoices ul li:last-of-type {
  border-bottom: 0;
  padding-bottom: 0;
}

#desk section.payment_methods ul li input,
#desk section.payment_methods ul li label {
  display: inline-block !important;
}

#desk section.payment_methods ul li input {
  margin-right: 10px;
}

#desk section.payment_methods ul li label {
  margin-bottom: 0 !important;
  color: inherit !important;
}

#desk section.payment_methods ul li label:before {
  margin-right: 10px;
  content: "";
  background-size: 35px !important;
  width: 35px;
  height: 22px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 2px;
}

#desk section.payment_methods ul li label.visa:before {
  background: url(data:image/svg+xml;base64,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)
    no-repeat;
}

#desk section.payment_methods ul li label.mastercard:before {
  background: url(data:image/svg+xml;base64,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)
    no-repeat;
}

#desk section.payment_methods ul li label.diners:before {
  background: url(data:image/svg+xml;base64,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)
    no-repeat;
}

#desk section.payment_methods ul li label.discover:before {
  background: url(data:image/svg+xml;base64,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)
    no-repeat;
}

#desk section.payment_methods ul li label.paypal:before {
  background: url(data:image/svg+xml;base64,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)
    no-repeat;
}

#desk.free .board .page {
  padding: 0 !important;
  background: transparent;
}

#desk.settings .board .page {
  padding: 0 !important;
}

#desk.free .board {
  background: transparent;
  border: none !important;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

#desk.settings .board .page section {
  padding: 15px 20px;
  border-bottom: 1px solid #e8e8e9;
}

#desk.settings .board .page section.pricing_main_features span {
  display: block;
  width: 150px;
  margin: 0 auto;
}

#desk.settings .board .page section.pricing_main_features span:nth-child(1) {
  margin-bottom: 7px;
}

#desk.settings .board .page section.custom_domain a.submit,
#desk.settings .board .page label.button,
#desk.settings .board .page section.upload_branding a.remove,
#desk.settings .board .page a.submit.button {
  background: #747d9d;
  color: #fff;
  width: 115px;
  text-align: center;
  padding-top: 8px;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  height: 35px;
  margin: 0;
  cursor: pointer;
  font-weight: 300;
  display: inline-block;
  font-size: 14px;
  border: 0;
}

#desk.settings .board.coupon_code .page input {
  max-width: 340px;
}

#desk.settings .board.coupon_code .page a.submit {
  width: 95px;
  margin-left: 5px;
}

#desk.settings .board .page label.button.upload {
  width: 100px;
  vertical-align: bottom;
  margin-left: 10px;
  position: relative;
}

#desk.settings .board .page section.upload_branding a.remove {
  background: #e35256;
  width: 100px;
  vertical-align: bottom;
  margin-left: 10px;
}

#desk.settings .board .page section.custom_domain span.status:before {
  font-family: "Ionicons";
  font-size: 19px;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  float: right;
  margin-top: -27px;
  margin-right: 10px;
  position: relative;
}

#desk.settings .board .page section.custom_domain span.status.success:before {
  content: "\f120";
  color: #59c08c;
}

#desk.settings .board .page section.custom_domain span.status.error:before {
  content: "\f128";
  color: #e35256;
}

#desk.settings .board .page section .contain_inputs {
  max-width: 250px;
}

#desk.settings .board .page section .contain_inputs.inline {
  width: 250px;
  margin-right: 5px;
}

#desk.settings .board .page section.upload_branding small {
  display: block;
  margin-top: 10px;
  font-size: 13px;
  opacity: 0.6;
}

#desk.settings .board .page section.radio_checkbox .form_row label {
  display: inline-block;
  color: #333333;
  padding-left: 10px;
}

#desk.settings .board .page section.reminder_timer .inputs {
  display: inline-block;
}

#desk.settings .board .page section.reminder_timer .inputs input {
  display: inline-block;
  width: 100px;
}

#desk.settings .board .page section.reminder_timer .inputs .select {
  display: inline-block;
  width: 85px;
  margin-left: 5px;
  margin-right: 10px;
}

#desk.settings .board .page section.radio_checkbox .form_row {
  margin-bottom: 10px;
}

#desk.settings .board .page section.radio_checkbox .form_row.less_mb {
  margin-bottom: 5px;
}

#desk.settings .board .page section.radio_checkbox .form_row:last-of-type {
  margin-bottom: 0;
}

#desk.settings .board .page section:last-of-type {
  border-bottom: none;
}

#desk.settings .board .page section.border_top {
  border-top: 1px solid #e8e8e9;
}

#desk.settings .board .page section p {
  margin-bottom: 0;
  margin-top: 5px;
}

#desk.settings .board .page.settings section {
  padding: 0;
}

#desk.settings .board .page.settings section a {
  padding: 15px 20px;
  display: block;
}

#desk.settings .board .page.settings section a:before {
  font-family: "Linearicons";
  font-size: 20px;
  margin-right: 10px;
  margin-top: -3px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
}

#desk.settings
  .board
  .page.settings
  section
  a.settings_edit_business_info:before {
  content: "\e613";
}

#desk.settings
  .board
  .page.settings
  section
  a.settings_system_preferences:before {
  content: "\e673";
}

#desk.settings
  .board
  .page.settings
  section
  a.settings_statement_preferences:before {
  content: "\e6b5";
}

#desk.settings
  .board
  .page.settings
  section
  a.settings_payment_integrations:before {
  content: "\e750";
}

#desk.settings .board .page.settings section a.settings_team:before {
  content: "\e722";
}

#desk.settings .board .page.settings section a.settings_tds:before {
  content: "\e757";
}

#desk.settings .board .page.settings section a.settings_saved_items:before {
  content: "\e6cc";
}

#desk.settings .board .page.settings section a.settings_customizations:before {
  content: "\e627";
}

#desk.settings .board .page.settings section a.settings_subscription:before {
  content: "\e68d";
}

#desk.settings .board .page.settings section a.settings_account:before {
  content: "\e66b";
}

#desk.settings .board .page.settings section a.settings_billing:before {
  content: "\e759";
}

#desk.settings .board .page.settings section a.settings_delete_account:before {
  content: "\e92a";
}

#desk.settings .board .page.settings section a.settings_files:before {
  content: "\e6b8";
}

#desk.settings .board .page.settings section a.settings_trash:before {
  content: "\e681";
}

#desk.settings .board .page.settings section a:hover {
  background: rgba(0, 0, 0, 0.05);
}

#desk.settings .board .page.settings section a span.right {
  color: #999;
  font-size: 14px;
  margin-top: 3px;
}

#desk.settings .board .page section.explanation p {
  margin-bottom: 0;
  margin-top: 0;
}

#desk.settings .board .page section.warning p {
  color: #e35256;
}

#desk.settings .board .page section.reset_cancel .submit {
  background: #e35256;
  margin-top: 15px;
  color: #fff;
  text-align: center;
  padding: 0 10px;
  border: none;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  height: 36px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  line-height: 36px;
}

#desk.settings .board .page section p.sub_notice {
  margin-bottom: 0;
  margin-top: 10px;
}

#desk.settings .board .page section:not(.payment_methods) a {
  font-size: 15px;
}

#desk.settings .board .page section a.new_item {
  width: auto;
}

#desk.settings .board .page section .sub_notice a {
  font-size: 14px;
}

#desk.settings .board label:not(.filter-container) {
  color: #8c8c91;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
}

#desk.settings .board input {
  background: #fff;
}

#desk.settings.dashboard .board input {
  background: transparent;
}

#desk.settings.dashboard .board input:focus {
  background: #fff;
}

#desk.settings .board form .page section.vanity_url input {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  padding-left: 10px;
  width: auto;
  height: 36px;
}

#desk.settings .board form .page section.vanity_url .input_addon {
  width: auto;
  padding-right: 10px;
  padding-left: 10px;
}

#desk.settings .board form .page section.vanity_url .input_addon.on-right {
  border-right: 1px solid #d7d7d9 !important;
  border-left: 0 !important;
  display: inline-block;
  vertical-align: bottom;
  margin-left: -4px;
}

#desk.editor .board .page section.placeholders ul {
  padding: 0;
  margin-bottom: 0;
}

#desk.editor .board .page section.placeholders ul li {
  display: inline-block;
  margin-right: 30px;
  margin-bottom: 14px;
  border: 1px solid #e1e1e1;
  padding: 2px 7px;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  cursor: pointer;
}

#desk.editor .board .page section.placeholders ul li:hover {
  background: #f7f7f7;
}

#desk.settings .board form .page section .input_addon {
  font-size: 14px;
  height: 36px;
  padding-top: 7px;
  padding-bottom: 0;
}

#desk.settings .board .page label[for="submit"],
#desk.settings .board .page [form="business_settings"].short,
.button.help_center,
#desk.settings .board .page [form="switch_payment_method"].short,
#desk.settings .board .page button.short,
#desk.settings .board .page button.submit,
.x_content .board .page section button.submit {
  color: #fff;
  text-align: center;
  padding: 0 10px;
  border: none;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  height: 36px;
  margin: 0;
  cursor: pointer;
  position: relative;
}

.button.help_center {
  background: rgba(0, 0, 0, 0.47);
  color: #fff;
  padding: 5px 10px;
  display: inline-block;
  margin-top: 10px;
}

.button.help_center:after {
  font-family: "Ionicons";
  font-size: 20px;
  margin-left: 10px;
  margin-top: -2px;
  vertical-align: middle;
  display: inline-block;
  color: #fff !important;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
  content: "\f385";
}

#desk.settings .board .page label[for="submit"] {
  padding-top: 9px;
}

#desk.settings .board .page label[for="submit"].short,
#desk.settings .board .page button.short {
  width: 130px;
}

#desk.settings .board .page button.short.add_card_pay_now {
  width: 200px;
}

#desk.statement .page {
  padding: 50px 50px 100px;
}

#desk.statement .board .page.recurring,
#desk.statement .board .page.statement_info,
#desk.statement .board .page.extra {
  background: #f3f3f4;
  border-bottom: 2px solid #d7d7d9;
}

#desk.statement .board .page.extra.account_statement {
  padding-top: 0 !important;
  padding-bottom: 10px !important;
}

#desk.statement .board .page.extra button {
  color: #fff;
  border: none;
  width: 75px !important;
  height: 35px;
  vertical-align: middle;
}

#desk.statement .board .page.extra .form_row.custom_period {
  padding-right: 20px;
}

#desk.statement
  .board
  .page.extra.account_statement
  .form_row
  input.datepicker {
  width: 100px;
}

.board.report_builder .form_row input.datepicker {
  width: 125px;
}

.report_builder_section {
  padding-bottom: 0;
}

#desk.statement .board .page.recurring .form_row.frequency,
#desk.statement .board .page.extra .form_row {
  width: 178px;
}

#desk.statement .board .page.extra .form_row.custom_period {
  width: auto;
}

#desk.statement .board .page.recurring .form_row.custom_frequency {
  width: 189px;
  display: none;
}

#desk.statement .board .page.recurring .form_row.custom_frequency input {
  width: 60px;
}

#desk.statement .board .page.recurring .form_row.custom_frequency select {
  width: 100px;
  margin-left: 5px;
}

#desk.statement .board .page.recurring .radio_checkbox .form_row label,
#desk.statement
  .board
  .page.statement_settings
  .radio_checkbox
  .form_row
  label {
  padding-left: 10px;
}

.x_page .x_content .form_row .radio_checkbox label {
  padding-left: 5px;
}

#desk.statement .board .page.recurring .form_row,
#desk.statement .board .page.statement_settings .form_row {
  margin-top: 15px;
  margin-bottom: 0;
}

#desk.statement .board .page.statement_settings .form_row.hr {
  border-top: 2px solid #e7e7e7;
  padding-top: 15px;
}

#desk.statement .page.statement_settings textarea,
#desk.send_statement .page textarea {
  background: #fff;
  width: 100%;
  height: 330px;
}

#desk.statement .page section.editor label {
  color: #8c8c91;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
  margin-top: 15px;
}

#desk.statement .board .page.extra .form_row input,
#desk.statement
  .board
  .page.extra
  textarea
  #desk.statement
  .board
  .page.recurring
  .form_row
  input,
#desk.statement .board .page.statement_settings input,
#desk.statement .board .page.statement_settings textarea {
  background: #fff;
}

#options-strip .button:not(.select-all-none):not(.table_sorting) {
  opacity: 0.5;
  pointer-events: none;
}

#option-strip .left,
#options-strip .right {
  position: relative;
}

#options-strip select {
  background: #e8e8e9;
  padding-right: 25px;
}

#options-strip .button.active {
  opacity: 1 !important;
  pointer-events: auto !important;
}

#options-strip {
  margin-bottom: 20px;
}

#options-strip.tabs-above {
  margin-bottom: 50px;
}

#options-strip .client_selector {
  max-width: 184px;
  margin-right: 17px;
}

#options-strip .search:before {
  color: #9d9d9d;
  font-family: "Ionicons";
  content: "\f2f5";
  font-size: 17px;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  left: 10px;
  top: 8px;
}

#options-strip .search input {
  display: block;
  width: 120px;
  display: block;
  width: 200px;
  float: right;
  padding: 4px 8px 4px 30px;
  outline: none;
  font-weight: 400;
  font-weight: 300;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  background: transparent;
  border: 2px solid #d7d7d9;
}

#options-strip .search input:focus {
  background: #fff;
}

#options-strip .meta {
  display: inline;
  padding: 8px;
  margin-right: 0;
  float: left;
}

.table_tabs .meta {
  position: absolute;
  left: 0;
  font-size: 13px;
}

#options-strip .clearfix {
  clear: both;
}

#options-strip .button.select-all-none:before {
  content: "";
}

#options-strip .button:first-of-type {
  float: left;
}

#options-strip .button {
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  cursor: default;
  white-space: nowrap;
  margin-right: 16px;
  line-height: 27px;
  min-width: 54px;
  outline: 0;
  padding: 2px 8px 0;
  height: 35px;
  display: inline-block;
  margin-top: 0;
}

#options-strip .button:active {
  background: #d7d7d9 !important;
}

.button {
  cursor: pointer !important;
  text-align: center;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: #e8e8e9;
  border: 2px solid #d7d7d9;
  color: #444;
}

#options-strip .button .tipr_container_bottom {
  margin-top: 10px !important;
}

#options-strip .button.default .tipr_container_bottom,
#options-strip .button.convert .tipr_container_bottom {
  margin-top: 42px !important;
}

#options-strip .double-buttons {
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline-block;
}

#options-strip .double-buttons .button {
  display: inline-block;
}

#options-strip .double-buttons li:first-child .button {
  display: inline-block;
  margin-right: 0;
  border-radius: 2px 0 0 2px;
  -webkit-border-radius: 2px 0 0 2px;
  -moz-border-radius: 2px 0 0 2px;
  border-right: none;
}

#options-strip .double-buttons li:last-child .button {
  display: inline-block;
  border-radius: 0 2px 2px 0;
  -webkit-border-radius: 0 2px 2px 0;
  -moz-border-radius: 0 2px 2px 0;
}

#options-strip .button.download {
  background: #e8e8e9;
}

#options-strip .button.download:before {
  margin-top: 5px;
}

.page .double-buttons {
  float: left;
}

.header .double-buttons {
  margin-right: 0;
}

.double-buttons > li {
  margin: 0;
  float: left;
}

.button.dropdown-toggle {
  position: relative;
}

.button.dropdown-toggle:before {
  left: 4px;
  top: 0;
  position: absolute;
}

.button.default.dropdown-toggle:before {
  left: 12px;
  top: 2px;
  position: absolute;
}

.button.dropdown-toggle:after {
  position: absolute;
  right: 12px;
  top: -4px;
}

#options-strip .button.dropdown-toggle:after {
  top: -2px;
}

.board .page .box_header .button.dropdown-toggle {
  width: 45px;
  height: 30px;
  margin-top: -5px;
}

.board .page .box_header .button.dropdown-toggle:before {
  left: 8px;
}

.board .page .box_header .button.dropdown-toggle:after {
  right: 7px;
}

.board .page .box_header .dropdown-menu {
  top: 33px;
  right: 20px;
  float: none;
  left: inherit;
  padding: 10px;
}

.board .page .box_header .dropdown-menu li.heading {
  margin-bottom: 5px;
  margin-top: 10px;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.board .page .box_header .dropdown-menu li.heading:first-of-type {
  margin-top: 0;
}

.board .page .box_header .dropdown-menu li.heading:hover {
  background: inherit;
}

.board .page .box_header .dropdown-menu li.submit {
  margin-top: 15px;
}

.board .page .box_header .dropdown-menu li.submit button {
  color: #fff;
  border: none;
  width: 50% !important;
  float: left;
  font-weight: 400;
  height: 30px;
}

.board.chart .page .box_header .dropdown-menu {
  width: 250px;
}

.double-buttons > li:first-child button {
  margin-right: -2px;
}

.double-buttons li:first-child:hover button {
  z-index: 1;
}

a.disabled,
button.disabled {
  color: #fff !important;
  background: #cccccf;
}

.headline_main_button .close:before {
  content: "\e04f";
  font-size: 24px;
  margin: 0;
  line-height: 38px;
}

.headline_main_button {
  margin-top: 14px;
}

.headline_main_button .main_button,
.headline_main_button .save-button {
  font-weight: 400;
  min-width: 135px !important;
  padding: 11px 16px;
  font-size: 15px;
  text-align: center;
  outline: none;
  line-height: 1;
  text-decoration: none;
  display: inline-block;
  color: #fff;
  font-weight: normal;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border: none;
  margin-left: 10px;
  cursor: pointer;
  position: relative;
}

.main_button.loading,
.save_button.loading,
.save-button.loading,
.attach_button.loading {
  color: rgba(0, 0, 0, 0) !important;
  pointer-events: none;
  cursor: default;
}

.main_button.loading:before,
.save-button.loading:before,
.save_button.loading:before,
.attach_button.loading:before {
  display: block;
  z-index: 2000;
  position: absolute;
  content: "" !important;
  left: 57px;
  top: 8px;
  width: 20px;
  height: 20px;
  border: solid 2px transparent;
  border-top-color: #fff;
  border-left-color: #fff;
  border-radius: 999px;
  -webkit-animation: pace-spinner 600ms linear infinite;
  -moz-animation: pace-spinner 600ms linear infinite;
  -ms-animation: pace-spinner 600ms linear infinite;
  -o-animation: pace-spinner 600ms linear infinite;
  animation: pace-spinner 600ms linear infinite;
}

.save_start_profile.loading:before {
  left: 68px;
}

.save_as_draft.loading:before {
  left: 49px;
}

.attach_button.loading:before {
  border-top-color: #999;
  border-left-color: #999;
  top: 1px;
  left: 8px;
}

@media screen and (min-width: 801px) {
  .attach_button.loading:before {
    top: 1px;
    left: 15px;
  }
}

.x_page .save_button.loading:before {
  left: 50px;
  top: 7px;
}

.x_window .x_content.confirmation .x_form .save_button.loading:before {
  left: 60px;
}

.x_content.upgrade_popup a.upgrade {
  background: #f63;
  color: #fff;
  text-align: center;
  padding: 10px;
  border: none;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  margin: 0;
  cursor: pointer;
  font-weight: 300;
  position: relative;
  display: inline-block;
}

.x_content.upgrade_popup ul {
  padding: 0;
  margin: 0;
  list-style: none;
  margin-top: 20px;
  margin-bottom: 10px;
}

.x_content.upgrade_popup ul li {
  margin-bottom: 5px;
}

.x_content.upgrade_popup ul li:before {
  font-family: "Linearicons";
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  margin-right: 10px;
  font-size: 20px;
  margin-top: -2px;
  vertical-align: middle;
}

.x_content.upgrade_popup ul li.team_members:before {
  content: "\e723";
}

.x_content.upgrade_popup ul li.estimates:before {
  content: "\e6b5";
}

.x_content.upgrade_popup ul li.recinvoices:before {
  content: "\e8da";
}

.x_content.upgrade_popup ul li.cc_payments:before {
  content: "\e759";
}

.x_content.upgrade_popup ul li.track:before {
  content: "\e8ea";
}

.x_content.upgrade_popup ul li.branding:before {
  content: "\e627";
}

#desk.settings button.short.loading:before {
  left: 55px;
}

#desk.settings button.short.add_card_pay_now.loading:before {
  left: 90px;
}

.headline_main_button .main_button.help,
.headline_main_button .main_button.more,
.headline_main_button .main_button.edit {
  min-width: 0 !important;
  width: 100px;
}

.headline_main_button .save_as_draft {
  min-width: 0 !important;
  width: 115px;
}

.headline_main_button .main_button.help,
.headline_main_button .save_as_draft {
  background: rgba(0, 0, 0, 0.27);
}

.headline_main_button .main_button.edit {
  width: 75px;
}

.headline_main_button .main_button.help:hover {
  background: rgba(0, 0, 0, 0.47);
}

.headline_main_button .dropdown-toggle:after {
  color: inherit;
  font-family: "Ionicons";
  content: "\f35f";
  font-size: 18px;
  margin-left: 5px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 0;
  -webkit-font-smoothing: antialiased;
}

.headline_main_button .dropdown-menu {
  min-width: 135px !important;
  right: 0;
  left: inherit;
  float: none !important;
}

h3,
h4 {
  font-style: normal;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.statement_section {
  margin-bottom: 30px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  float: left;
  width: 100%;
  height: auto;
  padding-bottom: 15px;
}

.statement_section h1 {
  margin: 0 0 50px;
  position: absolute;
  right: 0;
  top: 0;
}

.statement_logo_container {
  text-align: center;
  line-height: 1;
}

.statement_section .statement_logo_container {
  top: -15px;
}

#desk.receipt .statement_section .statement_logo_container {
  top: -10px;
}

.statement_logo_container:before {
  color: #fff;
  font-size: 14px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-weight: 400;
  font-weight: normal;
  font-style: normal;
}

.statement_logo_container a {
  display: block;
  padding: 10px;
  border: 2px dotted transparent;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  position: relative;
  display: block;
  width: 225px;
  height: 125px;
  float: right;
}

.statement_logo_container img {
  max-width: 100%;
  max-height: 100%;
  float: right;
}

.statement_logo_container a:hover {
  border: 2px dashed #d7d7d9;
}

.title {
  margin: 0;
  line-height: 1;
  font-weight: normal;
}

#desk.statement .board .page.statement_settings .title {
  line-height: 2;
}

.subtitle {
  font-size: 18px;
}

#desk.statement .board .page.statement_settings .subtitle {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e7e7e7;
  font-weight: normal;
}

#desk.statement .board .page.statement_settings .subtitle a {
  font-weight: normal;
}

#desk.statement .board .page.account_statement h2 .right {
  font-size: 16px;
  display: inline-block;
}

.statement_contacts .form_row,
.statement_contacts .form_row {
  margin: 0 0 15px;
  padding: 0;
}

.statement_section .form_heading,
#desk.statement .page.recurring .form_row .form_heading,
#desk.statement .page.extra .form_row .form_heading {
  margin: 0 0 5px;
  padding: 0;
}

.form_row.address_from .form_heading,
.form_row.address_to .form_heading {
  margin: 0 0 10px;
}

.statement_section .form_heading label {
  margin: 0;
  line-height: 1;
}

.x_form .form_heading {
  margin: 0 0 5px !important;
}

.statement_details .form_row {
  margin: 0;
}

.statement_details .form_heading {
  margin: 0 0 5px;
}

#desk.statement input.due_days {
  margin-top: 10px;
  width: 75px;
}

.statement_contacts p {
  margin: 0;
}

.address_from {
  min-height: 104px;
}

.statement_details {
  width: 35%;
  float: right;
}

.item_rows {
  margin: 0;
  padding: 0;
  list-style: none;
  clear: both;
  position: relative;
}

.one_item_line {
  margin: 0;
  padding: 0;
  width: 100%;
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: left;
}

.item_row {
  margin: 0;
  padding: 0;
  list-style: none;
  display: table-row;
  border-collapse: collapse;
}

.item_column {
  margin: 0;
  padding: 0;
  display: table-cell;
  border-collapse: collapse;
  vertical-align: top;
  height: 35px;
}

.item_column_heading {
  margin: 0;
  padding: 0 10px;
  /* padding-bottom: 5px; */
  /* border-bottom: 2px solid #e7e7e7; */
  font-size: 14px;
  color: #333;
  display: none;
  background: #ffffff;
  white-space: nowrap;
  font-weight: normal;
}

.item_column_heading.first {
  padding: 0 10px 5px 0;
}

.one_item_line:first-child .item_column_heading {
  display: block;
}

.item_column .inner {
  /* padding: 10px;
   */
}

#desk.receipt .item_column .inner {
  padding: 5px 10px;
}

.item_column.action .inner .relative {
  width: 38px;
}

.item_column.action .inner .relative ul.dropdown-menu {
  right: 0;
  left: auto;
}

.item_column .inner.first {
  padding: 10px 10px 10px 0;
}

.item_textarea {
  overflow: hidden;
  height: 55px;
}

.item_textarea p {
  margin: 0 0 10px !important;
}

.view_statement_textarea_replacement {
  height: auto;
  min-height: 34px;
  margin: 0;
}

#desk.statement .item_rows .item_column h2 {
  padding-left: 5px;
  text-align: right;
}

#desk.statement .item_rows .name_description h2 {
  padding-left: 0;
  text-align: left;
}

#desk.statement h3 {
  font-size: 14px;
  font-weight: inherit;
}

#desk.statement header {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e7e7e7;
}

.item_column.quantity {
  width: 85px;
}

.item_column.quantity .inner {
  /* padding: 10px 5px; */
}

.item_column.unit {
  width: 95px;
}

.item_column.unit .inner {
  padding: 10px 5px;
}

.item_column.amount {
  width: 140px;
}

.item_column.amount .inner {
  padding: 10px 5px;
}

.item_column.action {
  width: 45px;
}

.item_column.action .button {
  padding: 0;
  height: 35px;
  width: 38px;
  display: block;
  background: #f3f3f4;
}

.item_column.action .button.dropdown-toggle:before {
  left: 5px;
  top: 3px;
}

.item_column.action .button.dropdown-toggle:after {
  right: 5px;
  top: -1px;
}

.item_column.action .inner {
  padding: 10px 5px;
}

.item_textarea_container textarea {
  line-height: 130%;
  resize: vertical;
  overflow: hidden;
  width: 100%;
  border: 0;
  background: #fff;
}

#desk.files .files_area {
  margin-bottom: 25px;
}

.item_textarea_container .files_area {
  width: 100%;
  /*overflow-x: scroll*/
}

.textarea_actions .restrainer {
  display: inline-block;
  position: relative;
}

/*.textarea_actions.right .restrainer {
    width: 100%
}*/
.item_textarea_container label {
  position: absolute;
  right: 4px;
  top: 3px;
  z-index: 1;
}

.item_textarea {
  display: block;
}

.item_textarea_container {
  width: 100%;
  float: left;
  border: 2px solid #d7d7d9;
  outline: none;
  position: relative;
  z-index: 9;
  border-radius: 2px 2px 0 0;
  -webkit-border-radius: 2px 2px 0 0;
  -moz-border-radius: 2px 2px 0 0;
  padding-bottom: 3px;
}

.x_page .item_textarea_container {
  float: none;
}

.button_row {
  margin: 0;
  padding: 0;
  display: none;
  list-style: none;
  position: relative;
  top: -1px;
  float: left;
}

.button_row.tax_discount_shipping {
  width: 100%;
  margin-top: 10px;
}

.button_row {
  display: block;
}

.button_row li {
  float: left;
  margin-left: 6px;
}

.button_row li.link {
  margin-top: 12px;
  margin-right: 10px;
}

.attach_button {
  background: #f3f3f4;
  width: 39px;
  height: 35px;
  border: 0;
  line-height: 25px;
  padding: 0 10px;
  color: #666;
  display: inline-block;
  cursor: pointer;
  padding-top: 3px;
  position: relative;
  border-radius: 999px;
  margin-top: 4px;
  text-align: center;
  position: relative;
  border: 2px solid #d7d7d9;
}

.textarea_actions.right .restrainer.disabled {
  visibility: hidden;
  cursor: default;
  pointer-events: none;
}

.attach_button.extra {
  margin-right: 2px;
}

.attach_button:hover {
  color: #333;
  background: #d7d7d9;
}

.attach_button:hover:before {
  color: #333;
}

.textarea_actions.right .attach_button {
  float: left;
  margin-left: 2px;
}

.attach_button:before {
  font-family: "Linearicons";
  font-size: 16px;
  margin-bottom: 0px;
  margin-top: 4px;
  margin-left: 0px;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  color: #666;
  line-height: 1;
}

@media screen and (min-width: 801px) {
  .attach_button:before {
    margin-left: -8.5px;
    position: absolute;
    width: 18px;
  }
}

.textarea_actions .attach_button.date {
  margin-left: -1px;
}

.textarea_actions .attach_button.uploadify:before {
  content: "\e6b8";
}

.textarea_actions .attach_button.date:before {
  content: "\e789";
}

.textarea_actions .attach_button.links:before {
  content: "\e915";
}

.textarea_actions .attach_button.tags:before {
  content: "\e755";
}

.attach_button.tax:before {
  content: "\e757";
}

.attach_button.discount:before {
  content: "\e990";
}

.attach_button.shipping:before {
  content: "\e69f";
}

.page {
  padding: 50px 50px 100px;
}

a img {
  border: none;
}

body {
  line-height: 1.4;
  font-size: 12px;
}

.page {
  padding: 0 !important;
  background: transparent;
}

#container {
  padding: 0;
  padding-top: 96px;
}

.header.app_board_header {
  position: fixed;
  left: 210px;
  top: 0;
  right: 0;
  padding-left: 30px !important;
  padding-right: 30px !important;
  border-bottom: 1px solid #e1e1e1 !important;
  background: #fff !important;
  box-shadow: 0 1px 0 0 #e8e8e9;
  z-index: 999999;
}

.header.app_board_header h1 {
  display: inline-block;
}

.statement_section h1 {
  width: 180px;
}

body,
body main {
  background: #f3f3f4;
}

.sidebar_menu .upper {
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  -webkit-box-flex: 0;
  flex: 0 0 auto;
  margin-bottom: 25px;
}

.sidebar_menu .upper .logo {
  display: block;
  width: 143px;
  height: 34px;
  margin: 60px auto 0;

  background-size: auto 34px;
}

.sidebar_menu .upper .upgrade {
  display: block;
  color: #fff;
  text-align: center;
  width: 80%;
  margin: 35px auto;
  padding: 10px 0;
  font-size: 14px;
  border-radius: 2px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);
}

.sidebar_menu .upper .frame .select_business {
  color: #fff;
  cursor: default;
  display: block;
  height: 35px;
  line-height: 35px;
  position: relative;
  text-align: center;
  z-index: 2;
}

.sidebar_menu .upper .frame .select_business .business {
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  cursor: pointer;
  font-weight: inherit;
  font-size: 14px;
  color: #fff;
  background: rgba(0, 0, 0, 0.25) !important;
  overflow: hidden;
  position: absolute;
  top: 0;
  padding: 15px;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.sidebar_menu .upper .frame .select_business .business.dropdown-toggle:after {
  color: inherit;
  font-family: "Ionicons";
  content: "\f35f";
  font-size: 18px;
  margin-left: 8px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 0;
  -webkit-font-smoothing: antialiased;
  margin-top: -2px;
}

.sidebar_menu .upper .frame .select_business ul.dropdown-menu {
  border-radius: 0;
  width: 100%;
  border: 0;
  margin-top: 30px;
  position: absolute;
  box-shadow: 1px 0 0 0 #e8e8e9;
  margin-bottom: 59px;
  background: #e1e1e2;
  color: #333333;
  box-shadow: 0 10px 16px -6px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 10px 16px -6px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 10px 16px -6px rgba(0, 0, 0, 0.2);
}

.sidebar_menu .upper .frame .select_business ul.dropdown-menu li a {
  padding: 14px 22px 4px;
  cursor: pointer;
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li:not(.logout)
  a {
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.sidebar_menu .upper .frame .select_business ul.dropdown-menu li.logout a {
  padding-top: 13px;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li:not(.settings)
  a {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.sidebar_menu .upper .frame .select_business ul.dropdown-menu li a {
  color: #333333;
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li:last-of-type
  a {
  border-bottom: 2px solid rgba(0, 0, 0, 0.2) !important;
}

.sidebar_menu .upper .frame .select_business ul.dropdown-menu a:before {
  -webkit-font-smoothing: auto;
  font-family: "Linearicons";
  margin-right: 13px;
  font-size: 20px;
  float: left;
  margin-top: -6px;
  color: #333333;
  width: 18px;
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.settings
  a:before {
  content: "\e673";
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.billing
  a:before {
  content: "\e759";
  margin-top: -5px;
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.profile
  a:before {
  content: "\e728";
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.account
  a:before {
  content: "\e66b";
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.subscription
  a:before {
  content: "\e68d";
}

html.user
  .sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.switch_business {
  display: none;
}

html.admin
  .sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.switch_business {
  display: block;
  text-align: center;
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.switch_business {
  border-bottom-width: 0 !important;
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.logout
  a:before {
  content: "\e7b8";
  color: #fff;
  font-size: 20px;
  margin-top: -6px;
}

.sidebar_menu .upper .frame .select_business ul.dropdown-menu li.heading {
  font-size: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 22px;
  background: rgba(0, 0, 0, 0.05);
}

.sidebar_menu .upper .frame .select_business ul.dropdown-menu li.logout a {
  border-top-color: #e35256;
  background: #e35256;
  color: #fff;
}

.sidebar_menu .upper .frame .select_business ul.dropdown-menu li.logout:hover a,
.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li.logout.selected
  a {
  border-top-color: #de3136;
  background: #de3136;
}

.sidebar_menu
  .upper
  .frame
  .select_business
  ul.dropdown-menu
  li:not(.heading):not(.logout):not(.selected):hover {
  background: rgba(0, 0, 0, 0.05);
}

.sidebar_menu .upper .frame .select_business .business img {
  margin-right: 5px;
  margin-top: -2px;
  margin-left: 0;
}

.select_arrows:after {
  display: block;
  position: relative;
  right: 5px;
  margin-top: -17px;
  float: right;
  font-size: 14px;
  width: 20px;
  line-height: 1px;
  text-align: center;
  font-style: normal;
  font-family: "Ionicons";
  content: "\f104";
  color: #848b88;
  pointer-events: none;
}

.x_page {
  display: none;
  opacity: 1;
  z-index: 999999999;
  position: absolute;
  width: 100%;
  height: 100%;
}

.x_page.overlay {
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
}

.x_window {
  background: #fff;
  width: 30%;
  width: 450px;
  margin: 97px auto;
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.9);
  /*overflow: hidden*/
}

.x_window header {
  background: #fafafa;
  padding: 1px 0 1px 20px;
  border-bottom: 1px solid #e7e7e7;
  padding: 1px 0 1px 20px;
  border-bottom: 1px solid #e7e7e7;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.x_window .explanation.gray {
  background: #fafafa;
}

.x_window .x_content.confirmation header h1 {
  margin: 0;
  font-size: 18px;
  padding: 10px 0;
}

.x_window .x_content.confirmation header .x_close:after {
  margin-top: -24px;
}

.x_window header .x_close:after {
  display: block;
  position: relative;
  right: 16px;
  margin-top: -34px;
  float: right;
  font-size: 20px;
  width: 20px;
  height: 38px;
  line-height: 1px;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  font-style: normal;
  font-family: "Ionicons";
  content: "\f2d7";
  color: #848b88;
}

.close_x {
  cursor: pointer;
}

.x_form fieldset {
  padding: 15px;
  margin: 5px auto;
  width: 90%;
  display: block;
  position: relative;
  font-size: 14px;
}

.x_window .x_content.confirmation .x_form fieldset {
  margin: 0 auto;
  padding: 0 21px;
  width: 100%;
  margin-bottom: 0;
}

.x_window .x_content.confirmation .x_form fieldset p {
  margin: 0;
  margin-top: 10px;
}

.x_window .x_content.confirmation .x_form fieldset .form_row {
  margin-top: 20px;
  margin-bottom: 10px;
}

.x_form .info_strip {
  background: rgba(0, 0, 0, 0.47);
  color: #fff;
  font-size: 14px;
  padding: 12px 7px 12px 20px;
}

.x_form .info_strip.error {
  background: #e35256;
}

.x_form .info_strip.success {
  background: #3da07b;
}

.x_form .info_strip .message {
  display: inline-block;
}

.x_form .info_strip:before {
  -webkit-font-smoothing: antialiased;
  font-family: "Ionicons";
  content: "\f149";
  color: #fff;
  margin-right: 10px;
  font-size: 19px;
  float: left;
  margin-top: -5.1px;
}

.x_form .info_strip.error:before {
  content: "\f35b";
}

.x_form .info_strip.success:before {
  content: "\f375";
}

.x_form fieldset .form_container.with_margin {
  margin-top: 100px;
}

.x_form fieldset .form_container aside {
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 0 20px 5px;
}

.x_form fieldset .form_container aside input {
  background: #fff;
}

.board .client_image_container {
  display: inline-block;
}

.x_form .board .client_type_define {
  float: right;
  margin-top: 7px;
  width: 100%;
  width: 275px;
}

.board .client_type_define {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
  width: 250px;
}

.client_type_define label {
  cursor: pointer;
}

.custom_radio_label {
  display: block;
  width: 85%;
  background: #f3f3f4;
  border: 2px solid #d7d7d9;
  font-size: 14px;
  padding: 5px 20px 5px 10px;
  float: left;
  color: #333333;
}

.client_type_label:first-of-type .custom_radio_label {
  border-top-left-radius: 2px;
}

.client_type_label:first-of-type .custom_label_addon {
  border-top-right-radius: 2px;
}

.client_type_label:last-of-type .custom_radio_label {
  border-bottom-left-radius: 2px;
  border-top: none;
}

.client_type_label:last-of-type .custom_label_addon {
  border-bottom-right-radius: 2px;
}

.custom_label_addon {
  padding: 5px 10px;
  display: inline-block;
  float: right;
  border: 2px solid #d7d7d9;
  width: 15%;
  border-left: none;
  height: 33px;
}

.custom_label_addon.organization {
  margin-top: -2px;
}

.dark_tick:after {
  -webkit-font-smoothing: antialiased;
  text-align: center;
  font-family: "Ionicons";
  content: "\f122";
  color: #555;
  display: block;
  margin-left: 0;
  margin-top: -3px;
  font-size: 18px;
}

.double_input {
  width: 49% !important;
  display: inline-block;
}

.custom_field_container.tds .double_input {
  width: 250px !important;
}

.custom_field_container.tds .double_input.second {
  float: none;
  margin-left: 5px;
  width: 150px !important;
}

.custom_field_container.tds .remove_custom_field_button {
  display: inline-block;
  margin-left: 10px;
  width: auto;
  height: 35px;
  padding: 0 10px;
  background: #f5f5f5;
  cursor: pointer !important;
  text-align: center;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: #e8e8e9;
  border: 2px solid #d7d7d9;
  color: #444;
  padding-top: 6px;
}

.custom_field_container .set_default,
.custom_field_container .set_default input,
.custom_field_container .set_default label {
  display: inline-block !important;
}

.custom_field_container .set_default label {
  color: #333 !important;
}

.custom_field_container .set_default input {
  margin-left: 10px;
  margin-right: 5px;
}

.form_heading.double_input {
  display: inline-block;
}

.double_input.second {
  float: right;
}

.sub_notice {
  display: block;
  margin-top: 10px;
  font-size: 14px;
}

.mt10 {
  margin-top: 10px !important;
}

.mt15 {
  margin-top: 15px !important;
}

.triple_input {
  width: 32% !important;
  display: inline-block;
}

.triple_input.one {
  float: left;
}

.triple_input.two {
  margin: 0 auto;
  margin-top: 10px;
  margin-left: 2%;
}

.triple_input.three {
  float: right;
}

.x_form .save_button {
  padding: 0 15px;
  height: 35px;
  border: none;
  color: #fff;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  cursor: pointer;
  position: relative;
}

.x_form .dropdown-menu .save_button {
  padding: 6px 10px 0;
  height: 30px;
  margin: 0;
}

.x_window .x_content.confirmation .x_form .save_button {
  padding: 0 15px;
  width: 140px;
}

.x_form .cancel_button {
  margin-left: 14px;
  color: #222;
}

.x_form .form_row.organization {
  display: none;
}

.x_form .form_row:first-of-type {
  margin-top: 0 !important;
}

.x_form ul.dropdown-menu .new_tag_item_form .form_row:first-of-type {
  margin-top: 11px;
}

.x_form .form_row:last-of-type {
  margin-bottom: 0 !important;
}

.x_form .form_row textarea,
.x_form .form_row select {
  width: 100%;
}

.x_form .form_row.with_margin {
  margin-top: 30px;
}

a.remove_custom_field_button {
  width: 100%;
  display: block;
  margin-top: 5px;
  text-align: right;
  font-size: 13px !important;
  cursor: pointer;
}

.ghost_drag_item {
  opacity: 0.5;
}

.new_tag_item_rate_input {
  margin-top: 10px;
}

.one_item_line input.datepicker {
  margin-left: -56px;
}

input.no_input {
  border: none !important;
  background: transparent !important;
  color: inherit !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  width: 70% !important;
  text-align: right;
}

@-webkit-keyframes pace-spinner {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes pace-spinner {
  0% {
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes pace-spinner {
  0% {
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-ms-keyframes pace-spinner {
  0% {
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes pace-spinner {
  0% {
    transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.popup_load_spinner {
  display: block;
  z-index: 2000;
  position: relative;
  margin: 0 auto;
  /*margin-top: -85px;*/
  top: 85px;
  width: 30px;
  height: 30px;
  border: solid 3px transparent;
  border-top-color: #999;
  border-left-color: #999;
  border-radius: 50px;
  -webkit-animation: pace-spinner 600ms linear infinite;
  -moz-animation: pace-spinner 600ms linear infinite;
  -ms-animation: pace-spinner 600ms linear infinite;
  -o-animation: pace-spinner 600ms linear infinite;
  animation: pace-spinner 600ms linear infinite;
}

#desk.settings .uploadifive-button.loading:before {
  display: block;
  z-index: 2000;
  position: absolute;
  content: "";
  left: 40px;
  top: 7px;
  width: 20px;
  height: 20px;
  border: solid 2px transparent;
  border-top-color: #fff;
  border-left-color: #fff;
  border-radius: 999px;
  -webkit-animation: pace-spinner 600ms linear infinite;
  -moz-animation: pace-spinner 600ms linear infinite;
  -ms-animation: pace-spinner 600ms linear infinite;
  -o-animation: pace-spinner 600ms linear infinite;
  animation: pace-spinner 600ms linear infinite;
}

#desk.settings .uploadifive-button.loading {
  color: rgba(0, 0, 0, 0) !important;
  cursor: default;
  pointer-events: none;
}

.autocomplete-suggestions {
  border: 2px solid #c7c7c7;
  cursor: default;
  overflow: auto;
  position: absolute;
  max-height: 150px;
  z-index: 999999999999 !important;
  display: block;
  box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.2);
  -webkit-box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.2);
  -moz-box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.2);
  font-size: 13px;
  list-style: none;
  padding: 5px;
  margin: 0;
  background: #f3f3f4;
}

.autocomplete-suggestions.item_autocomplete {
  margin-left: -2px;
  margin-top: 3px;
  width: auto !important;
  min-width: 200px;
  max-width: 506px;
}

.autocomplete-suggestions.connection_autocomplete {
  margin-left: 0;
  margin-top: -2px;
  /*width: 200px!important*/
}

.autocomplete-suggestion {
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  padding: 11px 20px 28px;
  margin-top: 5px;
}

.autocomplete-suggestion .left {
  max-width: 85%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  float: left;
}

.autocomplete-suggestion .left {
  white-space: nowrap;
}

.item_autocomplete .autocomplete-suggestion .left {
  max-width: 75%;
  white-space: nowrap;
}

.autocomplete-suggestion:first-of-type {
  margin-top: 0;
}

.autocomplete-suggestion:hover,
.item_autocomplete.autocomplete-selected,
.autocomplete-suggestion.autocomplete-selected {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.05);
}

.autocomplete-suggestions strong {
  font-weight: 700;
  color: #000;
}

.autocomplete-group {
  padding: 2px 5px;
}

.autocomplete-group strong {
  font-weight: 700;
  font-size: 16px;
  color: #000;
  display: block;
  border-bottom: 1px solid #000;
}

.autocomplete_card {
  padding: 6px;
  border: 2px solid #d7d7d9;
  background: #f3f3f4;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
}

.autocomplete_card p {
  margin: 0;
}

.autocomplete_card .close_icon:after {
  display: block;
  position: relative;
  margin-top: -1px;
  float: right;
  width: 18px;
  font-size: 18px;
  line-height: 18px;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  font-style: normal;
  font-family: "Ionicons";
  content: "\f2d7";
  color: #848b88;
  cursor: pointer;
}

[data-currency="code"] {
  cursor: pointer;
}

@keyframes shakeInput {
  0% {
    margin-left: 4px;
  }

  10% {
    margin-left: -4px;
  }

  30% {
    margin-left: 4px;
  }

  60% {
    margin-left: -4px;
  }

  100% {
    margin-left: 0;
  }
}

@-webkit-keyframes shakeInput {
  0% {
    margin-left: 4px;
  }

  10% {
    margin-left: -4px;
  }

  30% {
    margin-left: 4px;
  }

  60% {
    margin-left: -4px;
  }

  100% {
    margin-left: 0;
  }
}

.shakeInput {
  animation: shakeInput 0.5s;
  -webkit-animation: shakeInput 0.5s;
  border-color: #8c8c91;
}

table.standard-table {
  width: 100% !important;
  text-align: left;
  font-size: 14px;
  border-collapse: separate;
  border: 2px solid #d7d7d9;
}

table.standard-table.updating td {
  opacity: 0.5;
  pointer-events: none;
}

table.free {
  width: 100% !important;
  text-align: left;
  font-size: 14px;
}

table.free thead {
  border-bottom: 2px solid #e7e7e7;
}

table.free thead.gray {
  background: rgba(0, 0, 0, 0.05);
}

table.free td,
table.free th {
  padding: 7px 5px;
}

table.free tr.large td {
  padding: 10px 5px;
}

table tr.red_backlight,
table td.red_backlight {
  background: #fadfe0;
}

table.free td.text_right,
table.free th.text_right {
  text-align: right;
}

table.free tr.border_bottom {
  border-bottom: 1px solid #e7e7e7;
}

table.standard-table tr {
  background: rgba(243, 243, 243, 0);
  color: #222;
  height: 80px;
}

table.medium {
  max-width: 980px;
}

table.standard-table td {
  border-top: 1px solid #d7d7d9;
}

table.standard-table tr:first-of-type td {
  border-top: 0;
}

table.standard-table.track td,
table.standard-table.team td {
  padding-top: 15px;
  padding-bottom: 15px;
  cursor: default;
}

table td.blank {
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.2);
  cursor: default;
}

table td.blank.loading:before {
  margin: 0 auto;
  right: 0;
  top: 1px;
  position: relative;
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: pace-spinner 0.6s infinite linear;
  animation: pace-spinner 0.6s infinite linear;
  border-top: 2px solid rgba(104, 129, 169, 0);
  border-right: 2px solid rgba(0, 0, 0, 0);
  border-bottom: 2px solid rgb(179, 179, 179);
  border-left: 2px solid rgb(179, 179, 179);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: block;
  content: "";
  top: 0;
}

.button.start-timer {
  padding: 9px 0;
  margin-right: 10px;
  background: #747d9d;
  color: #fff;
  width: 89px;
  height: 39px;
  display: inline-block;
  vertical-align: middle;
  border-color: #747d9d;
}

[data-timer="off"] [data-timer-elements="on"] {
  display: none;
}

[data-timer="on"] [data-timer-elements="off"] {
  display: none;
}

table.standard-table th {
  padding: 10px;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}

table.standard-table th:first-child {
  border-left: 2px solid rgba(0, 0, 0, 0.1);
}

table.standard-table th:last-child {
  border-right: 2px solid rgba(0, 0, 0, 0.1);
}

table.standard-table td section {
  max-height: 50px;
}

table.standard-table.track td section {
  max-height: 100px;
}

.payments_made table.standard-table th {
  border: 0 !important;
}

.payments_made table.standard-table tbody tr {
  height: 50px;
}

.payments_made table.standard-table tbody td {
  padding: 10px;
}

table.report td,
table.report th {
  width: auto !important;
  text-align: left !important;
  padding: 10px 20px !important;
}

table.report td section {
  padding: 0 !important;
}

table.track tr td:nth-child(1),
table.clients tr td:nth-child(1),
table.files tr td:nth-child(1),
table.trash tr td:nth-child(1),
table.team tr td:nth-child(1),
table.invoices tr td:nth-child(1),
table.bills tr td:nth-child(1),
table.estimates tr td:nth-child(1),
table.items tr td:nth-child(1),
table.tasks tr td:nth-child(1),
table.expenses tr td:nth-child(1),
table.trips tr td:nth-child(1),
table.tags tr td:nth-child(1) {
  width: 5%;
  text-align: center;
}

table.track tr td:nth-child(2),
table.files tr td:nth-child(6),
table.languages tr td:nth-child(2) {
  width: 20%;
}

table.track tr td:nth-child(6),
table.clients tr td:nth-child(2),
table.clients tr td:nth-child(4) {
  width: 25%;
}

table.invoices tr th:nth-child(4),
table.bills tr th:nth-child(4),
table.estimates tr th:nth-child(4),
table.invoices tr td:nth-child(4),
table.bills tr td:nth-child(4),
table.estimates tr td:nth-child(4) {
  width: 250px !important;
}

table.invoices tr th:nth-child(5),
table.bills tr th:nth-child(5),
table.estimates tr th:nth-child(5),
table.invoices tr td:nth-child(5),
table.bills tr td:nth-child(5),
table.estimates tr td:nth-child(5) {
  width: 200px !important;
}

table.track tr td:nth-child(3) {
  width: 40%;
}

table.clients tr td:nth-child(3) {
  width: 15%;
}

table.track tr td:nth-child(3) input {
  background: #fff;
}

table.track tr td:nth-child(4),
table.clients tr td:nth-child(6),
table.team tr td:nth-child(6),
table.items tr td:nth-child(6),
table.tasks tr td:nth-child(6),
table.expenses tr td:nth-child(6),
table.trips tr td:nth-child(6),
table.tags tr td:nth-child(6),
table.modify_language tr td:nth-child(4) {
  width: 10%;
}

table.track tr td:nth-child(6),
table.clients tr td:nth-child(6),
table.files tr td:nth-child(6),
table.team tr td:nth-child(6),
table.items tr td:nth-child(6),
table.tasks tr td:nth-child(6),
table.expenses tr td:nth-child(6),
table.trips tr td:nth-child(6),
table.tags tr td:nth-child(6),
table.languages tr td:nth-child(2),
table.modify_language tr td:nth-child(4),
table.colors tr td:nth-child(5) {
  text-align: right;
  padding-right: 25px;
}

table.clients tr td:nth-child(2) img,
table.team tr td:nth-child(2) img,
table.invoices tr td:nth-child(4) img,
table.bills tr td:nth-child(4) img,
table.estimates tr td:nth-child(4) img {
  margin-right: 5px;
}

table.standard-table th {
  pointer-events: none !important;
  cursor: default !important;
  width: auto !important;
}

table.standard-table th.sorting_enabled {
  pointer-events: auto !important;
  cursor: pointer !important;
}

table.languages td:first-of-type,
table.languages th:first-of-type,
table.colors td:first-of-type,
table.colors th:first-of-type {
  padding-left: 15px;
}

table.standard-table td section span.star {
  display: inline-block;
  width: 19px;
}

table.standard-table td section span.star:before {
  font-family: "Ionicons";
  content: "\f2fc";
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  position: relative;
  font-size: 20px;
  display: inline-block;
  color: #fa3;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

table.languages td section span.star:before {
  font-size: 25px;
  content: "\f3ae";
  color: #c1c1c1;
  cursor: pointer;
}

table.languages td section span.star.active:before {
  font-size: 25px;
  content: "\f2fc";
  color: #fa3;
}

table.standard-table td:first-child {
}

table.standard-table tr td:first-child {
}

table.standard-table tr.selected td:first-child {
  background: #ffc;
}

table.standard-table tr:last-child td {
}

table.standard-table tr.selected {
  background: #ffc !important;
}

table.standard-table p.description {
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 400px;
  overflow: hidden;
  line-height: normal;
}

table.standard-table p.meta {
  font-size: 13px;
  color: #999;
  font-weight: 300;
  margin-bottom: 0;
}

table.standard-table .autocomplete_card {
  height: 35px;
  width: 65%;
  position: relative;
  float: left;
  display: inline-block;
  padding: 7px;
}

table.standard-table .autocomplete_card p {
  margin: 0;
  margin-top: 1px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

table.standard-table a.new {
  line-height: 35px;
  display: inline-block;
  margin-left: 10px;
  position: absolute;
}

table.standard-table input[type="text"] {
  padding: 0 5px;
  outline: none;
  font-weight: 400;
  line-height: 35px;
  height: 35px;
  color: #333333;
  -webkit-appearance: none;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  border: 2px solid #d7d7d9;
}

table.standard-table small {
  font-size: 13px;
}

table.standard-table small.st_descr {
  margin-left: 0px;
  display: block;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #a7a7a9;
  font-size: 14px;
}

span.st_descr {
  white-space: nowrap;
  width: 150px;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: top;
}

table.standard-table .fade {
  color: #a1a1a1;
}

table.standard-table thead tr {
  height: 20px;
  background: #e8e8e9 !important;
}

table.standard-table tr {
  background: #fff;
}

table.standard-table .button.apply {
  padding: 10px 0;
  color: #fff;
  width: 89px;
  height: 39px;
  display: inline-block;
  vertical-align: middle;
  border: 0 !important;
}

/* NEW TABLE STYLING FOR NEW NON-JSON TABLES */
table.min-height td {
  height: 53px;
}

table td.statement_hash,
table td.connection_id,
table td.tracker_id,
table td.checkbox {
  text-align: center;
  width: 50px;
  background: #e8e8e9;
}

table.trash td.kind span.kind {
  color: #222;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  vertical-align: middle;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 16px;
  display: block;
}

table.trash td.date span.date_created {
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

table.trash td.date {
  width: 250px;
}

table td.tracker_amount {
  width: 250px;
}

table.standard-table .statement_id span.date,
table.standard-table .statement_recurring_profile_name span.date,
table.standard-table .tds_name span.date,
table.standard-table .name span.date,
table.statement_comments td.comment span.date {
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  color: rgba(0, 0, 0, 0.3);
  background: #e8e8e9;
  font-size: 12px;
  padding: 3px 4px 2px 4px;
  min-width: 70px;
  display: inline-block;
  text-align: center;
  border-radius: 2px;
  margin-right: 8px;
  vertical-align: middle;
  margin-top: -2px;
}

table.standard-table .name span.filename {
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

table.standard-table .name span.uploader {
  display: block;
  font-size: 13px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  margin-top: 5px;
  position: relative;
  bottom: -3px;
}

table.standard-table .item_name span.name {
  display: block;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

table.standard-table .item_name span.item_description {
  display: block;
  font-size: 13px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  margin-top: 0px;
  position: relative;
  bottom: -3px;
}

table.standard-table.categories .price {
  width: 225px;
}

table.standard-table .statement_id a.title,
table.standard-table .statement_recurring_profile_name a.title {
  color: #222;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  vertical-align: middle;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 16px;
  position: relative;
  z-index: 1;
}

table.standard-table .tds_name span.name {
  color: #222;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  vertical-align: middle;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 16px;
}

table.standard-table .statement_id span.title_meta,
table.standard-table .statement_recurring_profile_name span.title_meta,
table.standard-table span.description_meta,
table.standard-table .tds_name span.client {
  display: block;
  font-size: 13px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  margin-top: 5px;
  position: relative;
  bottom: -3px;
}

table.standard-table span.description_meta.filled {
  margin-bottom: -5px;
  display: block;
}

table.standard-table span.description_meta {
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  display: none;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

table.standard-table .tds_name span.client {
  margin-top: 2px;
  bottom: -1px;
  width: 125px !important;
}

table.standard-table .statement_id span.title_meta a,
table.standard-table .statement_recurring_profile_name span.title_meta a,
table.standard-table .tds_name span.client a {
  color: #222;
}

table.standard-table .tds_name span.client a:hover {
  color: #2676a5;
}

table.standard-table td span.tag_meta {
  display: inline-block;
  font-size: 13px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  position: relative;
  margin-left: 15px;
  min-width: 125px;
  text-align: left;
}

table.standard-table .statement_id a.title:hover,
table.standard-table .statement_id span.title_meta a:hover,
table.standard-table .statement_recurring_profile_name a.title:hover,
table.standard-table .statement_recurring_profile_name span.title_meta a:hover {
  color: #2676a5;
}

table.new_clients_table tr .connection_id:last-of-type {
  text-align: right;
  width: 200px;
}

table.new_clients_table tr td.connection_id:first-of-type {
  text-align: center;
}

table .statement_date,
table .statement_due_date,
table .statement_expiration_date,
table .statement_creation_ts,
table .tracker_date {
  width: 100px;
}

table .phone_number {
  width: 150px;
}

table .effective_statement_status {
  text-align: right;
}

table .sumdata_statement_total {
  text-align: right;
  width: 200px;
  padding: 10px 10px 10px 0;
}

table th.sumdata_statement_total {
  padding-right: 25px;
}

table .statement_id {
}

table .tds_name {
  max-width: 250px;
  min-width: 150px;
}

table .tracker_actions {
  width: 180px;
  text-align: right;
}

table .statement_id strong,
table .statement_recurring_profile_name strong {
  vertical-align: top;
}

table .connection_details {
  width: 175px;
}

table td.connection_details a {
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 85%;
  overflow: hidden;
  display: block;
}

table td.connection_name {
  font-size: 16px;
}

table.statement_payments td.payment_info span.date {
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  color: rgba(0, 0, 0, 0.3);
  background: #e8e8e9;
  font-size: 12px;
  padding: 3px 4px 2px 4px;
  min-width: 70px;
  display: inline-block;
  text-align: center;
  border-radius: 2px;
  margin-right: 10px;
  vertical-align: middle;
  margin-top: -2px;
}

table.statement_payments td.payment_info span.amount {
  color: #222;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  vertical-align: middle;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 16px;
}

table.statement_payments td.payment_info span.details {
  display: block;
  font-size: 13px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  margin-top: 5px;
  position: relative;
  bottom: -3px;
}

table.statement_activity td.date {
  width: 200px;
}

table.statement_payments td.actions {
  width: 75px;
}

table.statement_payments td.status {
  width: 150px;
}

table.statement_payments td.details {
  width: 200px;
}

table.statement_activity td.activity {
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

table td.connection_actions {
  width: 125px;
}

table td.actions {
  width: 175px;
}

table.categories td.actions,
table.team td.actions,
table.connection_contacts td.actions,
table.statement_comments td.actions {
  width: 75px;
}

table td.size {
  width: 150px;
}

table.team td.member span.name {
  color: #222;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  vertical-align: middle;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 16px;
  display: block;
}

table.statement_comments td.comment span.name {
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

table.statement_comments td.comment span.comment {
  color: #222;
  overflow: hidden;
  vertical-align: middle;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  display: block;
  margin-top: 3px;
  position: relative;
  bottom: -3px;
  max-width: 500px;
  display: block;
  line-height: normal;
}

table.team td.member span.role {
  font-size: 12px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  margin-top: 5px;
}

table.team td.status {
  width: 400px;
}

table.team td.status span.last_logged_in {
  margin-left: 10px;
}

table td.connection_name a,
table.connection_contacts td.contact span.name {
  color: #222;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  vertical-align: middle;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 16px;
}

table td.connection_name a:hover {
  color: #2676a5;
}

table.connection_contacts td.contact span.name {
  display: block;
}

table td.connection_name span,
table.connection_contacts td.contact span.email,
table.connection_contacts td.contact span.tel {
  display: block;
  font-size: 12px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  margin-top: 1px;
}

table td.connection_name span:before,
table.connection_contacts td.contact span.email:before,
table.connection_contacts td.contact span.tel:before {
  font-family: "Linearicons";
  font-size: 15px;
  margin-right: 10px;
  margin-top: -1px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
}

table td.connection_name span.email:before,
table.connection_contacts td.contact span.email:before {
  content: "\e697";
}

table td.connection_name span.tel:before,
table.connection_contacts td.contact span.tel:before {
  content: "\e76a";
}

/* NEW TABLE STYLING FOR NEW NON-JSON TABLES */

.tag.clean {
  padding: 10px;
  text-align: center;
  width: 85px;
  color: #fff;
  border: 0;
  min-width: 0;
  text-transform: capitalize !important;
  height: auto;
  margin: 0 !important;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 13px;
}

td .tag.clean.green {
  background: #3da07b;
  color: #ffffff !important;
}

.tag.clean.archived {
  color: inherit;
  background: #e8e8e8;
}

.tag.clean.for-date {
  width: 85%;
}

#show-per-page-strip {
  margin-top: 50px;
  height: 100px;
}

#show-per-page-strip select {
  width: 60px;
  margin-left: 10px;
  background: #e8e8e9;
}

ul.tabs {
  width: 100%;
  list-style: none;
  padding: 0;
  margin-top: 50px;
  margin-bottom: 0;
}

ul.tabs.general {
  margin-bottom: 30px;
  margin-top: 0;
  border-bottom: 2px solid #e8e8e9;
  padding-bottom: 30px;
}

@media screen and (min-width: 801px) {
  ul.tabs li {
    width: 175px;
    display: inline-block;
    padding: 15px;
    margin-left: 5px;
    border: 2px solid #d7d7d9;
    background: #e8e8e9;
    color: #444;
    border-radius: 2px;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
  }

  ul.tabs a:first-child li {
    margin-left: 0;
  }
}

ul.tabs li.current {
  background: #fff;
}

ul.tabs li:before {
  font-family: "Ionicons";
  font-weight: 100;
  font-size: 21px;
  font-variant: normal;
  text-transform: none;
  margin-top: 0;
  color: #777;
  vertical-align: bottom;
  margin-right: 10px;
  cursor: pointer;
  margin-left: 0;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

ul.tabs li.current:before {
  color: #333;
}

ul.tabs li.all:before {
  content: "\f229";
}

ul.tabs li.recurring:before {
  content: "\f3a8";
}

ul.tabs li.non-recurring:before {
  content: "\f29e";
}

ul.tabs li.times:before {
  font-family: "Linearicons";
  font-weight: 100;
  font-size: 21px;
  font-variant: normal;
  text-transform: none;
  margin-top: 0;
  color: #777;
  vertical-align: bottom;
  margin-right: 10px;
  cursor: pointer;
  margin-left: 0;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  content: "\e8f1";
}

ul.tabs li.expenses:before {
  font-family: "Linearicons";
  font-weight: 100;
  font-size: 21px;
  font-variant: normal;
  text-transform: none;
  margin-top: 0;
  color: #777;
  vertical-align: bottom;
  margin-right: 10px;
  cursor: pointer;
  margin-left: 0;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  content: "\e750";
}

ul.tabs li.mileages:before {
  font-family: "Linearicons";
  font-weight: 100;
  font-size: 21px;
  font-variant: normal;
  text-transform: none;
  margin-top: 0;
  color: #777;
  vertical-align: bottom;
  margin-right: 10px;
  cursor: pointer;
  margin-left: 0;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  content: "\e842";
}

ul.tabs li.general_preferences:before {
  content: "\f2f7";
}

ul.tabs li.statement_preferences:before {
  content: "\f391";
}

#desk:not(.send_statement) section.disabled input,
#desk:not(.send_statement) section.disabled textarea {
  cursor: default;
  pointer-events: none;
  opacity: 0.7;
  background: rgba(0, 0, 0, 0.05) !important;
}

section.disabled .new_item {
  background: rgba(0, 0, 0, 0.2) !important;
  cursor: default;
  pointer-events: none;
}

section.disabled a.remove_custom_field_button {
  color: #bbb !important;
  cursor: default;
  pointer-events: none;
}

@-webkit-keyframes move {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 50px 50px;
  }
}

@-moz-keyframes move {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 50px 50px;
  }
}

@keyframes move {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 50px 50px;
  }
}

.uploadifive-queue-item,
.tag {
  background: #f4f4f4;
  border: 0 solid #d5d5d5;
  font: 12px Arial, Helvetica, Sans-serif;
  display: inline-block;
  text-align: left;
  padding: 6px 17px 0 7px;
  height: 30px;
  width: auto;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  position: relative;
}

#desk:not(.files) .uploadifive-queue-item.complete {
  max-height: 30px;
}

.uploadifive-queue-item .inside {
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 75%;
  max-width: none;
}

#desk.files .uploadifive-queue-item .inside {
  width: 100%;
}

.x_page .uploadifive-queue-item,
#desk.statement .uploadifive-queue-item {
  background: #e7e7e7;
  border: 0;
  padding: 7px 15px 8px 10px;
  max-width: 200px;
  min-width: 150px;
  min-height: 30px;
  position: relative;
  height: auto;
}

a.download_item:before {
  font-family: "Ionicons";
  content: "\f2dd";
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  position: relative;
  margin-top: 0;
  font-size: 15px;
  float: right;
  max-width: 200px;
  left: 0;
  text-align: right;
  display: inline-block;
  color: #9d9d9d;
  cursor: pointer;
  line-height: 1;
  -webkit-font-smoothing: auto;
  margin-right: 15px;
}

#desk.files a.download_item,
#desk.files a.download_item:before {
  display: none;
}

#desk.files .uploadifive-queue-item .success_tick:before {
  display: none;
  font-family: "Ionicons";
  content: "\f122";
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  position: relative;
  text-align: right;
  color: #3da07b;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  float: right;
}

#desk.files .uploadifive-queue-item.complete .success_tick:before {
  display: inline-block;
}

#desk.files .uploadifive-queue-item {
  width: 250px;
  max-width: none;
  background: #fff;
  margin: 0;
  border: 2px solid #d7d7d9;
  font-size: 14px;
  padding: 10px 20px;
  height: auto;
  position: relative;
  margin-right: 15px !important;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  margin-bottom: 15px !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
}

#desk.files .uploadifive-queue-item:last-of-type {
  margin-right: 0;
}

.uploadifive-queue-item .close_item:after,
.tag .close_item:after {
  font-family: "Ionicons";
  content: "\f128";
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  position: relative;
  margin-top: 1.4px;
  float: right;
  max-width: 200px;
  right: -10px;
  text-align: right;
  display: inline-block;
  color: #9d9d9d;
  cursor: pointer;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.uploadifive-queue-item .close_item:hover:after,
.uploadifive-queue-item .download_item:hover:before,
.tag .close_item:hover:after {
  color: #333333;
}

#desk.files .uploadifive-queue-item .close_item:after {
  font-size: 16px;
  position: absolute;
  right: 20px;
  top: 9px;
}

.x_page .uploadifive-queue-item .close_item:after,
#desk.statement .uploadifive-queue-item .close_item:after,
.tag .close_item:after {
  position: absolute;
  right: 10px;
}

#desk.files .uploadifive-queue-item .filename,
.x_page .uploadifive-queue-item .filename,
#desk.statement .uploadifive-queue-item .filename {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#desk.files .uploadifive-queue-item .filename {
  max-width: 90%;
}

.uploadifive-queue-item .progress {
  border: 1px solid #d0d0d0;
  height: 5px;
  margin-top: 5px;
  width: 100%;
}

.x_page .uploadifive-queue-item .progress,
#desk.statement .uploadifive-queue-item .progress {
  border: 0;
}

.uploadifive-queue-item .progress-bar {
  background: #0072bc;
  height: 3px;
  width: 0;
}

#desk.files .uploadifive-queue-item .progress {
  border: 0;
  margin-top: 10px;
  height: auto;
  display: block !important;
}

#desk.files .uploadifive-queue-item .progress-bar {
  background: #999;
  height: 15px;
  width: 0;
  content: "";
  background-image: -webkit-gradient(
    linear,
    0 0,
    100% 100%,
    color-stop(0.25, rgba(255, 255, 255, 0.2)),
    color-stop(0.25, transparent),
    color-stop(0.5, transparent),
    color-stop(0.5, rgba(255, 255, 255, 0.2)),
    color-stop(0.75, rgba(255, 255, 255, 0.2)),
    color-stop(0.75, transparent),
    to(transparent)
  );
  background-image: -moz-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  z-index: 1;
  -webkit-background-size: 50px 50px;
  -moz-background-size: 50px 50px;
  background-size: 50px 50px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-animation: move 2s linear infinite;
  -moz-animation: move 2s linear infinite;
  animation: move 2s linear infinite;
}

#desk.files .uploadifive-queue-item.complete .progress-bar {
  -webkit-animation: none;
  -moz-animation: none;
  animation: none;
  background: #3da07b;
  background-image: none;
}

.x_page .uploadifive-queue-item .progress-bar,
#desk.statement .uploadifive-queue-item .progress-bar {
  height: 4px;
}

.tag {
  padding: 7px 30px 0 7px;
  margin: 3px 0 0 3px !important;
  min-width: 100px;
}

table .tag.classic {
  margin: 0 !important;
}

.tag.date {
  display: none;
  background: rgba(43, 161, 225, 0.95);
  border: 1px solid #2ba1e1;
  min-width: 100px;
}

.tag.classic {
  background: #ff8000;
}

.tag .filename {
  white-space: nowrap;
}

.tag.date .close_item:after,
.tag.classic .close_item:after,
.tag.date .filename,
.tag.classic .filename {
  color: #fff;
}

.tag.classic .inside {
  color: #fff;
}

.tipr_content {
  font-size: 12px;
  color: #fff;
  background: #333;
  padding: 0 10px;
}

.tipr_container_bottom {
  display: none;
  position: absolute;
  margin-top: 8px;
  z-index: 9999999999;
  border: 1px solid #333;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  width: auto;
}

@media screen and (min-width: 801px) {
  .attach_button .tipr_container_bottom {
    margin-top: 40px;
    z-index: 999;
  }
}

table .tipr_container_bottom {
  margin-top: 13px;
}

table .tipr_content {
  padding: 5px;
}

.tipr_container_top {
  display: none;
  position: absolute;
  z-index: 9999999999;
  max-width: 300px;
  border-color: #333;
  background: #333;
  margin: 0;
  border: 1px solid #333;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
}

.tiprtop.four .tipr_container_top {
  margin-top: -125px;
}

.tiprtop.three .tipr_container_top {
  margin-top: -105px;
}

.tiprtop.two .tipr_container_top {
  margin-top: -87px;
}

.tiprtop.one .tipr_container_top {
  margin-top: -69px;
}

.tipr_container_top .tipr_content {
  padding: 10px;
  font-size: 13px;
}

.tipr_point_top,
.tipr_point_bottom {
  position: relative;
  background: #333;
}

.tipr_point_top:after,
.tipr_point_top:before {
  position: absolute;
  pointer-events: none;
  border: solid transparent;
  top: 100%;
  content: "";
  height: 0;
  width: 0;
}

.tipr_point_top:after {
  border-top-color: #333;
  border-width: 8px;
  left: 50%;
  margin-left: -8px;
}

.tipr_point_top:before {
  border-top-color: #333;
  border-width: 9px;
  left: 50%;
  margin-left: -9px;
}

.tipr_point_bottom:after,
.tipr_point_bottom:before {
  position: absolute;
  pointer-events: none;
  border: solid transparent;
  bottom: 100%;
  content: "";
  height: 0;
  width: 0;
}

.tipr_point_bottom:after {
  border-bottom-color: #333;
  border-width: 8px;
  left: 50%;
  margin-left: -8px;
}

.tipr_point_bottom:before {
  border-bottom-color: #333;
  border-width: 9px;
  left: 50%;
  margin-left: -9px;
}

.helptip {
  width: 23px;
  display: inline-block;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.helptip:before {
  font-family: "Ionicons";
  content: "\f142";
  font-weight: 400;
  font-size: 15px;
  font-variant: normal;
  text-transform: none;
  color: #9d9d9d;
  cursor: help;
  margin-left: 5px;
  vertical-align: text-bottom;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

.pika-single {
  display: block;
  position: relative;
  color: #333;
  background: #fff;
  border: 2px solid #d7d7d9;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-bottom-color: #bbb;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  z-index: 999999999999999999999999 !important;
}

.pika-single:before,
.pika-single:after {
  content: " ";
  display: table;
}

.pika-single:after {
  clear: both;
}

/*.pika-single {
    *zoom: 1
}*/
.pika-single.is-hidden {
  display: none;
}

.pika-single.is-bound {
  position: absolute;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
}

.pika-lendar {
  float: left;
  width: 240px;
  margin: 8px;
}

.pika-title {
  position: relative;
  text-align: center;
}

.pika-label {
  display: inline-block;
  /* *display: inline;*/
  position: relative;
  z-index: 9999999999999999;
  overflow: hidden;
  margin: 0;
  padding: 5px 3px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  background: #fff;
}

.pika-title select {
  cursor: pointer;
  position: absolute;
  z-index: 9998;
  margin: 0;
  left: 0;
  top: 5px;
  filter: alpha(opacity=0);
  opacity: 0;
}

.pika-prev,
.pika-next {
  display: block;
  cursor: pointer;
  position: relative;
  outline: none;
  border: 0;
  padding: 0;
  width: 20px;
  height: 30px;
  text-indent: 20px;
  white-space: nowrap;
  overflow: hidden;
  background: transparent;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 75% 75%;
  opacity: 0.5;
  /* *position: absolute;
    *top: 0 */
}

.pika-prev:hover,
.pika-next:hover {
  opacity: 1;
}

.pika-prev,
.is-rtl .pika-next {
  float: left;

  /* *left: 0 */
}

.pika-next,
.is-rtl .pika-prev {
  float: right;

  /* *right: 0 */
}

.pika-prev.is-disabled,
.pika-next.is-disabled {
  cursor: default;
  opacity: 0.2;
}

.pika-select {
  display: inline-block;
  /*  *display: inline */
}

.pika-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 0;
}

.pika-table th,
.pika-table td {
  width: 14.285714285714%;
  padding: 0;
}

.pika-table th {
  color: #999;
  font-size: 12px;
  line-height: 25px;
  font-weight: 700;
  text-align: center;
}

.pika-button {
  cursor: pointer;
  display: block;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  outline: none;
  border: 0;
  margin: 0;
  width: 100%;
  padding: 5px;
  color: #666;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  background: #f5f5f5;
}

.pika-week {
  font-size: 11px;
  color: #999;
}

.is-today .pika-button {
  color: #2c87e5;
  font-weight: 700;
}

.is-selected .pika-button {
  color: #fff;
  font-weight: 700;
  background: #2c87e5;
  box-shadow: inset 0 1px 3px #178fe5;
}

.is-inrange .pika-button {
  background: #d5e9f7;
}

.is-startrange .pika-button {
  color: #fff;
  background: #6cb31d;
  box-shadow: none;
}

.is-endrange .pika-button {
  color: #fff;
  background: #2c87e5;
  box-shadow: none;
}

.is-disabled .pika-button {
  pointer-events: none;
  cursor: default;
  color: #999;
  opacity: 0.3;
}

.pika-button:hover {
  color: #fff;
  background: #ff8000;
  box-shadow: none;
}

.pika-table abbr {
  border-bottom: none;
  cursor: help;
}

@-moz-keyframes timer-loader {
  0% {
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes timer-loader {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes timer-loader {
  0% {
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.timer-loader:not(:required) {
  border: 2px solid #fff;
  -moz-border-radius: 24px;
  -webkit-border-radius: 24px;
  border-radius: 24px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  overflow: hidden;
  position: relative;
  text-indent: -9999px;
  width: 21px;
  height: 21px;
  vertical-align: middle;
  margin-top: -2px;
}

.timer-loader:not(:required)::before {
  -moz-animation: timer-loader 1250ms infinite linear;
  -webkit-animation: timer-loader 1250ms infinite linear;
  animation: timer-loader 3250ms infinite linear;
  -moz-transform-origin: 3px 3px;
  -ms-transform-origin: 3px 3px;
  -webkit-transform-origin: 3px 3px;
  transform-origin: 1px 1px;
  background: #fff;
  -moz-border-radius: 20px;
  -webkit-border-radius: 20px;
  border-radius: 20px;
  content: "";
  display: block;
  position: absolute;
  width: 2px;
  height: 7px;
  left: 8px;
  top: 7.5px;
}

.timer-loader:not(:required)::after {
  -moz-animation: timer-loader 15000ms infinite linear;
  -webkit-animation: timer-loader 15000ms infinite linear;
  animation: timer-loader 15000ms infinite linear;
  -moz-transform-origin: 3px 3px;
  -ms-transform-origin: 3px 3px;
  -webkit-transform-origin: 3px 3px;
  transform-origin: 4px 5px;
  background: #fff;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  content: "";
  display: block;
  position: absolute;
  width: 2px;
  height: 5px;
  left: 5px;
  top: 5px;
  visibility: hidden;
}

.no_border {
  border: 0 !important;
}

.no_pb_pt {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.no_padding {
  padding: 0 !important;
}

.fs14 {
  font-size: 14px !important;
}

.fs15 {
  font-size: 15px !important;
}

.pb10 {
  padding-bottom: 10px !important;
}

.mb15 {
  margin-bottom: 15px !important;
}

.mb20 {
  margin-bottom: 20px !important;
}

.mb25 {
  margin-bottom: 25px !important;
}

.mb30 {
  margin-bottom: 30px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mr20 {
  margin-right: 20px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt35 {
  margin-top: 35px !important;
}

.mt40 {
  margin-top: 40px !important;
}

.ml10 {
  margin-left: 10px !important;
}

.no_mt {
  margin-top: 0 !important;
}

.no_mb {
  margin-bottom: 0 !important;
}

.no_float {
  float: none !important;
}

.max_100 {
  max-width: 100px !important;
}

.max_150 {
  max-width: 150px !important;
}

.bg_white {
  background: #fff !important;
}

.no_border_radius_right {
  border-radius: 2px 0 0 2px !important;
  -webkit-border-radius: 2px 0 0 2px !important;
  -moz-border-radius: 2px 0 0 2px !important;
}

.no_border_radius_left {
  border-radius: 0 2px 2px 0 !important;
  -webkit-border-radius: 0 2px 2px 0 !important;
  -moz-border-radius: 0 2px 2px 0 !important;
}

ul.default {
  padding: 0;
  list-style: none;
  margin: 0;
}

.relative {
  position: relative !important;
}

.flex {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
}

.flex .flex_item {
  width: 100%;
  margin-right: 20px;
}

.flex .flex_item:last-of-type {
  margin-right: 0;
}

.icon_container {
  width: 64px;
  height: 64px;
  box-shadow: inset 0 0 8px #ccc;
  -moz-box-shadow: inset 0 0 10px #ccc;
  display: inline-block;
}

.logo_container {
  width: 225px;
  height: 225px;
  box-shadow: inset 0 0 8px #ccc;
  -moz-box-shadow: inset 0 0 10px #ccc;
  display: inline-block;
}

.logo_statement_container {
  width: 450px;
  height: 225px;

  box-shadow: inset 0 0 8px #ccc;
  -moz-box-shadow: inset 0 0 10px #ccc;
  display: inline-block;
  text-align: right;
}

.alert {
  border-radius: 3px;
  border-width: 1px;
  border-style: solid;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
  overflow: hidden;
  padding: 10px 1pc;
  position: relative;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  -webkit-box-align: start;
  align-items: flex-start;
  margin-bottom: 20px;
}

.alert:first-of-type {
  margin-top: 0;
}

.alert.info {
  background: #e3f3fc;
  border-color: #a8c8db;
  color: #2676a5;
}

.alert.error {
  background: #fce3e4;
  border-color: #f3b9bb;
  color: #e35256;
}

.alert.success {
  background: #e3fcf3;
  border-color: #b1d9ca;
  color: #3da07b;
}

.alert a {
  margin-left: 4px;
  margin-right: 4px;
}

.green {
  color: #3da07b !important;
}

.inline_children p,
.inline_children span:not(.tipr):not(.tiprtop),
.inline_children label,
.inline_children input,
.inline_children a,
.inline_children select {
  display: inline-block !important;
}

.inline_children label {
  width: 150px;
}

.inline_children label.ninety {
  width: 90px;
}

.cc_images {
  display: inline-block;
  text-align: left;
  white-space: nowrap;
}

.cc_images img {
  height: 35px;
  margin: 0 auto;
  margin-left: 5px;
}

.cc_images img:first-of-type {
  margin-left: 0;
}

span.color_preview {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: bottom;
  border-radius: 999px;
  margin-left: 10px;
}

span.hex {
  width: 60px;
  display: inline-block;
}

.button.paypal {
  padding: 9px 10px 10px;
  color: #fff;
  width: 190px;

  background-position: 10px 9px;
  background-size: 75px;
  border: #f63;
  height: 39px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
  text-align: right;
}

.button.paypal.one_time {
  width: 235px;
}

div.invoice {
  background: #f3f3f4;
  border: 1px solid #d7d7d9;
  height: 200px;
}

.x_content .board {
  border: 0;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  background: none;
}

.x_content .board .page {
  padding: 0 !important;
  float: none;
}

.x_content .board .page section {
  padding: 15px 20px;
  border-bottom: 1px solid #e8e8e9;
  font-size: 14px;
}

.x_content .board .page section:last-of-type {
  border-bottom: 0;
}

.x_content .board .page .dropdown-menu section {
  padding: 0;
  border: 0;
}

.x_content .board .page section .form_row {
  margin-top: 0;
  margin-bottom: 5px !important;
}

.x_content.confirmation .board .page section .form_row {
  margin-bottom: 0 !important;
}

.x_content .board .page section .dropdown-menu .form_row {
  margin-top: 11px !important;
  margin-bottom: 2px !important;
}

.x_content .board .page section .form_row.payment_icons {
  margin-bottom: 0;
}

.x_content .board .page section .cc_images {
  display: inline-block;
  width: 100%;
  text-align: left;
}

.x_content .board .page section .cc_images img {
  height: auto;
  margin: 0 auto;
  margin-left: 8px;
}

.x_content .board .page section .cc_images img:first-of-type {
  margin-left: 0;
}

.x_content .board .page section label:not(.uploadifive-button) {
  margin-bottom: 5px;
  display: block;
}

.x_content .board .page section .dropdown-menu label {
  margin-bottom: inherit;
  display: inline-block;
}

.x_content .board .page section.radio_checkbox .form_row {
  margin-top: 0;
  margin-bottom: 10px;
}

.x_content .board .page section.radio_checkbox .form_row:last-of-type {
  margin-bottom: 0;
}

.x_content .board .page section.radio_checkbox .form_row label {
  padding-left: 10px;
  display: inline-block;
  margin-bottom: 0;
}

.x_content .board .page section p {
  margin: 0;
}

.x_content .board .page header.box_header {
  font-size: 14px;
}

.dataTables_filter,
.dataTables_length,
.dataTables_info {
  display: none;
}

.ellipsis {
  margin-right: 7px;
}

.pagination_section {
  border: 1px solid #d7d7d9;
}

.paginate_button {
  display: inline-block;
  box-sizing: border-box;
  padding: 7px 13px;
  margin: 0;
  text-align: center;
  text-decoration: none !important;
  cursor: pointer;
  color: #333 !important;
  height: 35px;
  border: 1px solid #d7d7d9;
  background: #e8e8e9;
  margin-left: 0px;
}

.paginate_button.previous,
.paginate_button.next,
.paginate_button.start,
.paginate_button.end {
  width: 40px;
  display: inline-block;
  vertical-align: middle;
}

.paginate_button.previous:before,
.paginate_button.next:before,
.paginate_button.start:before,
.paginate_button.end:before {
  content: "\e726";
  font-family: "Linearicons";
  font-size: 11px;
  font-weight: 600;
  font-variant: normal;
  text-transform: none;
  position: relative;
  top: 1px;
  left: -1px;
}

.paginate_button.start:after,
.paginate_button.end:after {
  content: "\e726";
  font-family: "Linearicons";
  font-size: 11px;
  font-weight: 600;
  font-variant: normal;
  text-transform: none;
  position: relative;
  top: 1px;
  left: -1px;
}

.paginate_button.previous:before {
  content: "\e93b";
}

.paginate_button.next:before {
  content: "\e93c";
  left: 0px;
}

.paginate_button.start:before {
  content: "\e93b";
  left: 0px;
}

.paginate_button.end:before {
  content: "\e93c";
  left: 1px;
}

.paginate_button.start:after {
  content: "\e93b";
  left: -6px;
}

.paginate_button.end:after {
  content: "\e93c";
  left: -5px;
}

.paginate_button:not(.previous):not(.next) {
  width: 43px;
}

.paginate_button.start {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.paginate_button.end {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.paginate_button.current,
.paginate_button:active {
  background: #d7d7d9 !important;
}

.paginate_button.current {
  cursor: default;
  pointer-events: none;
}

.paginate_button:not(.current):hover {
  background: #e0e0e2;
}

.paginate_button.disabled {
  cursor: default;
  pointer-events: none;
  background: #e8e8e9;
  color: #bebebe !important;
}

table.dataTable thead th.sorting_enabled.sorting,
table.dataTable thead th.sorting_enabled.sorting_asc,
table.dataTable thead th.sorting_enabled.sorting_desc {
  cursor: pointer;
}

table.dataTable thead th.sorting_enabled.sorting,
table.dataTable thead th.sorting_enabled.sorting_asc,
table.dataTable thead th.sorting_enabled.sorting_desc,
table.dataTable thead th.sorting_enabled.sorting_asc_disabled,
table.dataTable thead th.sorting_enabled.sorting_desc_disabled {
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 15px;
}

table.dataTable thead th.sorting_enabled.sorting {
}

table.dataTable thead th.sorting_enabled.sorting_asc {
}

table.dataTable thead th.sorting_enabled.sorting_desc {
}

table.dataTable thead th.sorting_enabled.sorting_asc_disabled {
}

table.dataTable thead th.sorting_enabled.sorting_desc_disabled {
}

.dataTables_empty {
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.2);
  cursor: default;
}

/*td.dataTables_empty:before {
    font-family: 'Linearicons';
    font-size: 20px;
    margin-right: 10px;
    margin-top: -3px;
    vertical-align: middle;
    display: inline-block;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-font-smoothing: grayscale;
    content: "\e88d";
}*/
.dataTables_empty:hover {
  background: #fff !important;
}

.flippable.flipped .board.back,
.flippable .board.front {
  display: block;
}

.flippable.flipped .board.front {
  display: none;
}

.flippable .board.back {
  display: none;
}

.offline_autocomplete {
  width: 100%;
  font-size: 14px;
  text-align: left;
  border: 2px solid rgba(0, 0, 0, 0.15);
  margin-top: -2px;
}

.offline_autocomplete ul {
  list-style: none;
  padding: 5px;
  margin: 0;
  background: #f3f3f4;
}

.offline_autocomplete ul li {
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  padding: 10px;
  margin-top: 5px;
  cursor: pointer;
}

.offline_autocomplete ul li:nth-child(1) {
  margin-top: 0;
}

.offline_autocomplete ul li:hover,
.offline_autocomplete ul li.selected {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.05);
}

form[data-connection-type="individual"] .form_row.organization,
form[data-connection-type="individual"] section.organization,
form[data-connection-type="organization"] section.individual,
form[data-connection-type="organization"] .form_row.individual,
form[data-connection-type="organization"] img.individual,
form[data-connection-type="individual"] img.organization {
  display: none !important;
}

form[data-connection-type="individual"] .form_row.individual,
form[data-connection-type="individual"] section.individual,
form[data-connection-type="organization"] .form_row.organization,
form[data-connection-type="organization"] section.organization {
  display: block !important;
}

#desk.settings
  form[data-connection-type="individual"]
  .form_row.double.individual,
#desk.settings
  form[data-connection-type="individual"]
  section.double.individual,
#desk.settings
  form[data-connection-type="organization"]
  .form_row.double.organization {
  display: -ms-flexbox !important;
  display: -webkit-box !important;
  display: flex !important;
  display: -webkit-flex !important;
}

form[data-connection-type="individual"] img.individual,
form[data-connection-type="organization"] img.organization {
  display: inline !important;
}

form[data-connection-type="organization"] .dark_tick.individual,
form[data-connection-type="individual"] .dark_tick.organization {
  visibility: hidden;
}

form[data-connection-type="individual"] .dark_tick.individual,
form[data-connection-type="organization"] .dark_tick.organization {
  visibility: visible;
}

form[data-connection-type="individual"] .custom_radio_label.individual,
form[data-connection-type="organization"] .custom_radio_label.organization {
  background: #ffc;
}

#desk.statement footer {
  padding-top: 10px;
  border-top: 1px solid #e7e7e7;
}

#desk.statement footer .right.branding {
  padding-top: 10px;
}

#desk.statement footer .right.branding .remove_branding {
  background: #ff6633;
  color: #fff;
  width: 100px;
  margin: 0px auto;
  margin-top: 7px;
  margin-right: 20px;
  border-radius: 3px;
  padding: 5px 0;
  display: block;
  text-align: center;
  float: left;
  display: block;
  text-align: center;
}

#desk.statement footer a.button {
  display: inline-block;
  float: right;
  margin-top: 12px;
  font-style: normal;
  line-height: 18px;
  padding: 8px 12px 0;
  height: 35px;
  font-size: 14px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  color: #fff;
  text-align: center;
  border: none;
}

#desk.statement footer ul {
  padding: 20px 0 0;
  list-style: none;
  display: inline-block;
  float: left;
  margin: 0;
}

#desk.statement footer ul li {
  margin: 0 20px 10px 0;
  padding: 0;
  display: inline-block;
  line-height: 1;
}

#desk.statement header .statement_status {
  font-size: 16px;
  color: #fff;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  font-weight: 400;
  padding: 7px 10px;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

#desk.statement header h2.title .statement_status {
  display: inline-block;
  margin-right: 10px;
  font-size: inherit;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  text-transform: capitalize;
  vertical-align: top;
  height: 35px;
  /* padding-top: 10px; */
  text-align: center;
}

#desk.statement header h2.title .statement_status span {
  font-size: 19px;
  display: inline-block;
}

#desk.statement header h2.title input {
  display: inline-block;
  width: auto;
}

.tag.clean.draft,
.tag.clean.deleted,
.tag.clean.closed,
.tag.clean.trashed,
#desk.statement header .statement_status.draft,
#desk.statement header .statement_status.deleted,
#desk.statement header .statement_status.closed,
#desk.statement header .statement_status.trashed {
  background: #a1a1a1;
}

.tag.clean.unpaid {
  background: rgba(0, 0, 0, 0.47);
}

.statement_amount_container.total_due.draft .statement_amount,
.statement_amount_container.total_due.deleted .statement_amount,
.statement_amount_container.total_due.closed .statement_amount,
.statement_amount_container.total_due.trashed .statement_amount {
  border-color: #a1a1a1;
}

.tag.clean.paused,
#desk.statement header .statement_status.paused {
  background: #e3af52;
}

.statement_amount_container.total_due.paused .statement_amount {
  border-color: #e3af52;
}

.tag.clean.invoiced,
.tag.clean.completed,
.tag.clean.payable,
.tag.clean.partial,
.tag.clean.pending,
.tag.clean.sent,
#desk.statement header .statement_status.invoiced,
#desk.statement header .statement_status.completed,
#desk.statement header .statement_status.partial,
#desk.statement header .statement_status.payable,
#desk.statement header .statement_status.pending,
#desk.statement header .statement_status.sent {
  background: #2676a5;
}

.tag.clean.unsent,
#desk.statement header .statement_status.unsent {
  background: #363b4d;
}

.statement_amount_container.total_due.unsent .statement_amount {
  border-color: #363b4d;
}

.statement_amount_container.total_due.invoiced .statement_amount,
.statement_amount_container.total_due.completed .statement_amount,
.statement_amount_container.total_due.partial .statement_amount,
.statement_amount_container.total_due.pending .statement_amount,
.statement_amount_container.total_due.payable .statement_amount,
.statement_amount_container.total_due.sent .statement_amount {
  border-color: #2676a5;
}

.tag.clean.paid,
.tag.clean.accepted,
.tag.clean.active,
#desk.statement header .statement_status.paid,
#desk.statement header .statement_status.accepted,
#desk.statement header .statement_status.active {
  background: #3da07b;
}

.statement_amount_container.total_due.paid .statement_amount,
.statement_amount_container.total_due.accepted .statement_amount,
.statement_amount_container.total_due.active .statement_amount {
  border-color: #3da07b;
}

.tag.clean.due,
.tag.clean.expired,
#desk.statement header .statement_status.due,
#desk.statement header .statement_status.expired {
  background: #e35256;
}

.statement_amount_container.total_due.due .statement_amount,
.statement_amount_container.total_due.expired .statement_amount {
  border-color: #e35256;
}

#desk.statement.view .board:not(.inputs_enabled) input,
#desk.statement.view .board:not(.inputs_enabled) select,
#desk.statement.view
  .board:not(.inputs_enabled)
  [data-currency="code"]:not(.total) {
  tab-index: -1;
  background: transparent !important;
  border: 0 solid transparent !important;
  padding: 0 !important;
}

table td .tag.clean {
  padding: 8px 5px;
  width: auto;
  min-width: 65px;
  font-size: 12px;
}

/*#desk.statement.view .uploadifive-queue-item,
#desk.statement.view .tag {
    max-height: 30px;
}*/
#desk.statement.view .statement_details .form_heading,
#desk.statement.view .statement_section .form_heading {
  margin-bottom: 0;
}

#desk.statement.view .statement_details {
  width: 50%;
}

#desk.statement.view .form_row.address_from .form_heading,
#desk.statement.view .form_row.address_to .form_heading {
  margin-bottom: 10px !important;
}

#desk.statement.view header {
  border-bottom: 0;
  padding-bottom: 0;
}

#desk.statement.view .hide_on_view {
  display: none !important;
}

#desk.statement.view .item_textarea_container .files_area {
  margin-left: -3px;
}

#desk.statement.view .board:not(.inputs_enabled) textarea {
  tab-index: -1;
  background: transparent !important;
  border: 0 solid transparent !important;
  padding: 0 !important;
  height: auto;
  line-height: normal;
  resize: none;
}

#desk.statement.view .board:not(.inputs_enabled) .item_textarea_container {
  tab-index: -1;
  background: transparent !important;
  border: 0 solid transparent !important;
  padding: 0 !important;
}

#desk.statement.view
  .board:not(.inputs_enabled)
  input[name="statement[due_date]"] {
  margin-top: 0 !important;
}

#desk.statement.view .board:not(.inputs_enabled) .statement_section {
  border-bottom: 0;
  margin-bottom: 10px;
}

#desk.statement.view .board:not(.inputs_enabled) .one_item_line.actual input {
  line-height: normal;
  height: 15px;
}

#desk.statement.view
  .board:not(.inputs_enabled)
  .statement_amount_container
  .close_icon {
  display: none;
  pointer-events: none;
  cursor: default;
}

.close_icon {
  cursor: pointer;
  /* iOS onClick Fix */
}

#desk.statement.view .board:not(.inputs_enabled) .totals {
  margin-top: 0;
}

#desk.statement.view
  .board:not(.inputs_enabled)
  .statement_amount_container.tds
  .statement_amount {
  padding: 7px;
}

#desk.statement.view .board:not(.inputs_enabled) .tag {
  padding: 7px;
  min-width: 80px;
  text-align: center;
}

#desk.statement.view .uploadifive-queue-item .inside {
  width: auto !important;
  max-width: 75% !important;
}

#desk.statement.view a.download_item:before {
  margin-right: 2px;
  float: right;
  margin-left: 10px;
}

#desk.statement.view .board:not(.inputs_enabled) a.close_item {
  display: none;
}

#desk.statement.view .board:not(.inputs_enabled) .input_addon {
  cursor: default;
  pointer-events: none;
  background: transparent !important;
  border-color: transparent !important;
  width: 0;
  margin-right: 10px;
}

#desk.statement.view .board:not(.inputs_enabled) .select_arrows {
  display: none;
}

#desk.statement.view .board:not(.inputs_enabled)::-webkit-input-placeholder {
  color: transparent !important;
}

#desk.statement.view .board:not(.inputs_enabled):-moz-placeholder {
  color: transparent !important;
}

#desk.statement.view .board:not(.inputs_enabled)::-moz-placeholder {
  color: transparent !important;
}

#desk.statement.view .board:not(.inputs_enabled):-ms-input-placeholder {
  color: transparent !important;
}

#desk.statement.view .item_column .inner,
#desk.statement.view .item_column_heading {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

#desk.statement.view .statement_logo_container a {
  pointer-events: none;
  cursor: default;
}

#desk.statement.view .statement_logo_container a.statement_logo:hover {
  border: 0;
}

#desk.statement.view .autocomplete_card {
  padding: 0;
  border: 0;
  background: transparent;
}

#desk.statement.view .autocomplete_card .close_icon {
  display: none;
  pointer-events: none;
  cursor: default;
}

#desk.statement.view .totals .totals_container {
  width: auto;
}

#desk.statement.view [data-currency="code"] {
  pointer-events: none;
}

#desk.statement.view .page.recurring,
#desk.statement.view .page.statement_info {
  padding: 25px 50px !important;
}

#desk.statement.view .page.recurring section.flex .form_row.inline,
#desk.statement.view .page.statement_info section.flex .form_row.inline {
  width: 100%;
  margin-right: 10px;
  margin-top: 0 !important;
  background: rgba(0, 0, 0, 0.05);
  padding: 20px 15px;
  border-radius: 3px;
}

#desk.statement.view .page.statement_info section.flex .form_row.inline {
  margin-right: 0;
  margin-top: 0 !important;
  background: none;
  padding: 0;
  border-radius: 0;
  margin-bottom: 0;
}

#desk.statement.view .page.statement_info .left {
  line-height: 40px;
}

#desk.statement.view .page.recurring section.flex .form_row.inline:last-of-type,
#desk.statement.view
  .page.statement_info
  section.flex
  .form_row.inline:last-of-type {
  margin-right: 0;
}

#desk.statement.view
  .page.recurring
  section.flex
  .form_row.inline.profile_status
  a,
#desk.statement.view
  .page.statement_info
  section.flex
  .form_row.inline.profile_status
  a {
  color: #fff;
  padding: 7px;
  border-radius: 3px;
}

#desk.statement.view input.due_days {
  margin-top: 0;
  text-align: center;
  max-width: 30px;
  width: auto;
}

#desk.statement.view input.due_days::-webkit-inner-spin-button,
#desk.statement.view input.due_days::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

html.public main,
html.public #container {
  margin: 0;
}

html.public #desk {
  margin: 0 auto;
}

html.public .header.app_board_header {
  left: 0;
}

html.public .header.app_board_header .max_width {
  max-width: 980px;
  margin: 0 auto;
}

html.public .headline_main_button .main_button {
  min-width: 0 !important;
}

html.public .statement_section .statement_logo_container {
  top: -3px;
}

html.public .input_addon {
  font-size: 14px;
  width: 45px;
  padding-top: 6px;
}

html.public .payment_amount {
  margin-top: -29px;
}

html.public .payment_amount input {
  max-width: 125px;
  text-align: right;
}

html.public ul.statement_payment_methods li {
  display: inline-block;
  padding: 15px;
  text-align: right;
  border: 2px solid #d7d7d9;
  border-left-width: 50px;
  border-radius: 2px;
  color: #333333;
  position: relative;
  margin-right: 10px;
  position: relative;
  margin-bottom: 15px;
}

html.public ul.statement_payment_methods a.selected li {
  background: #ffc;
}

html.public ul.statement_payment_methods li:before {
  padding: 25px 20px;
  content: " ";
  position: absolute;
}

html.public ul.statement_payment_methods li.loading:before,
html.public
  ul.statement_payment_methods
  a.stripe_form_open
  li.stripe
  .stripe_payment_container
  button.loading:before {
  background: none !important;
  padding: 0;
  display: block;
  z-index: 2000;
  position: absolute;
  content: "" !important;
  left: -58px;
  top: 9px;
  width: 30px;
  height: 30px;
  border: solid 2px transparent;
  border-top-color: rgba(0, 0, 0, 0.5);
  border-left-color: rgba(0, 0, 0, 0.5);
  border-radius: 999px;
  -webkit-animation: pace-spinner 600ms linear infinite;
  -moz-animation: pace-spinner 600ms linear infinite;
  -ms-animation: pace-spinner 600ms linear infinite;
  -o-animation: pace-spinner 600ms linear infinite;
  animation: pace-spinner 600ms linear infinite;
}

html.public
  ul.statement_payment_methods
  a.stripe_form_open
  li.stripe
  .stripe_payment_container
  button.loading:before {
  border-top-color: #ffffff;
  border-left-color: #ffffff;
  left: 21px;
}

html.public ul.statement_payment_methods li.offline_payment:before {
  background-size: 31px;
  left: -41px;
  top: 7px;
}

html.public ul.statement_payment_methods li.credit_card:before {
  background-size: 33px;
  left: -42px;
  top: 7px;
}

html.public ul.statement_payment_methods li.paypal {
  border-color: rgba(0, 156, 222, 0.3);
}

html.public ul.statement_payment_methods li.paypal:not(.loading):before {
  background-size: 40px;
  left: -45px;
  top: 4px;
}

html.public ul.statement_payment_methods li.paypal.loading:before {
  left: -40px;
}

html.public ul.statement_payment_methods li.mollie {
  border-left-width: 90px;
}

html.public ul.statement_payment_methods li.mollie:not(.loading):before {
  background-size: 70px;
  left: -79px;
  top: 14px;
  padding: 25px 38px;
}

html.public ul.statement_payment_methods a li.stripe {
  border-color: #4379ff;
}

html.public ul.statement_payment_methods a li.stripe .stripe_payment_container {
  display: none;
}

html.public
  ul.statement_payment_methods
  a.stripe_form_open
  li.stripe
  .stripe_payment_container {
  display: block;
  margin-top: 20px;
  text-align: center;
  position: relative;
}

html.public
  ul.statement_payment_methods
  a.stripe_form_open
  li.stripe
  .stripe_payment_container
  img {
  position: absolute;
  height: 25px;
  right: -1px;
  top: -40px;
}

html.public ul.statement_payment_methods a.stripe_form_open li.stripe {
  width: 100%;
  text-align: left;
  height: 125px;
  cursor: default;
}

html.public
  ul.statement_payment_methods
  a.stripe_form_open
  li.stripe
  .stripe_payment_container
  .StripeElement {
  display: inline-block;
  width: 100%;
}

html.public
  ul.statement_payment_methods
  a.stripe_form_open
  li.stripe
  .stripe_payment_container
  button {
  display: inline-block;
  height: 50px;
  vertical-align: top;
  background: #4479ff;
  border: 0;
  color: #ffffff;
  border-radius: 3px;
  margin-left: 10px;
  width: 80px;
  position: relative;
}

html.public
  ul.statement_payment_methods
  a.stripe_form_open
  li.stripe
  .stripe_payment_container
  button.loading {
  color: transparent;
}

html.public ul.statement_payment_methods li.stripe:not(.loading):before {
  background-size: 40px;
  left: -45px;
  top: 4px;
  padding: 25px 38px;
}

html.public ul.statement_payment_methods li.stripe.loading:before {
  left: -40px;
  border-top-color: #ffffff;
  border-left-color: #ffffff;
}

html.public .main_button.dropdown-toggle {
  background: rgba(0, 0, 0, 0.27);
}

html.public .page.statement_settings section.flex aside {
  display: inline-block;
  background: #fff;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  margin: 0 20px 0 0;
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column;
  float: left;
  width: 100%;
  padding: 0 20px 15px 0;
}

html.public .page.statement_settings section.flex aside.credit_card {
  background: rgba(0, 0, 0, 0.02);
  border: 2px solid #d7d7d9;
  padding: 5px 20px 15px;
}

html.public .page.statement_settings section.flex aside:last-of-type {
  margin-right: 0;
}

html.public .page.statement_settings section label {
  display: block;
  margin-bottom: 5px;
}

html.public .page.statement_settings section aside a.button {
  padding: 11px 16px;
  font-size: 14px;
  text-align: center;
  outline: none;
  line-height: 1;
  text-decoration: none;
  display: inline-block;
  background: #f63;
  color: #fff;
  font-weight: 400;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border: none;
  position: relative;
  height: 36px;
}

html.public .page.statement_settings section aside a.button.loading:before {
  left: 53px;
}

html.public .page.statement_settings section aside.credit_card a.button {
  margin-top: 15px;
}

html.public .page.statement_settings section aside a.cancel {
  margin-left: 10px;
  color: #333333;
}

html.public
  .page.statement_settings
  section.flex
  aside.credit_card
  img.payment_processor.stripe {
  float: right;
  margin-top: 15px;
  opacity: 0.1;
}

html.public .page.statement_settings textarea {
  max-height: 150px;
}

.pace {
  -webkit-pointer-events: none;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.pace-inactive {
  display: none;
}

.pace .pace-progress {
  background: #999;
  position: fixed;
  z-index: 9999999999999;
  top: 0;
  right: 100%;
  width: 100%;
  height: 2px;
}

#desk.payment_integrations section:not(.radio_checkbox) .form_row {
  max-width: 350px;
}

#desk.activity_log ul li {
  padding: 16px 20px;
  height: 50px;
  border-top: 1px solid #e8e8e9;
}

#desk.activity_log ul li:first-of-type {
  border-top: none;
}

#desk.activity_log ul li span.date {
  width: 115px;
  display: inline-block;
}

span.new {
  position: relative;
  background: #3da07b;
  text-transform: uppercase;
  color: #fff;
  font-size: 12px;
  top: -2px;
  height: 19px;
  display: inline-block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 5px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  text-align: center;
  -webkit-box-shadow: 0 1px 0 rgba(0, 0, 0, 0.07);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.07);
  padding: 3px;
  margin-right: 5px;
}

.input_loader {
  margin: 0 auto;
  font-size: 2px;
  border-top: 1.1em solid #999;
  border-right: 1.1em solid #999;
  border-bottom: 1.1em solid #999;
  border-left: 1.1em solid #fff;
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: pace-spinner 0.6s infinite linear;
  animation: pace-spinner 0.6s infinite linear;
  display: none;
}

.input_loader,
.input_loader:after {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  position: absolute;
  right: 10px;
  top: 9px;
}

.input_restrainer {
  position: relative;
}

#desk.track table .input_restrainer {
  display: inline-block;
  height: auto;
  width: 65%;
}

#desk.settings .column.left {
  float: none;
  padding-right: 20px;
  border-right: 1px solid #e8e8e8;
  margin-right: 20px;
  width: 60%;
}

#desk.settings .column.left.single {
  width: 100%;
  padding-right: 0;
  border-right: 0;
  margin-right: 0;
}

#desk.settings .column.right {
  width: 40%;
}

#desk.settings section.half_half .column.right,
#desk.settings section.half_half .column.left:not(.single) {
  width: 50%;
}

#desk.settings .form_row.double {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
}

#desk.settings .form_row.double .left,
#desk.settings .form_row.double .right {
  width: 50%;
}

#desk.settings .form_row.double .left {
  margin-right: 20px;
  float: none;
}

#desk section.no_pb_pt .column {
  padding-top: 20px;
  padding-bottom: 20px;
}

section[data-payment-method="paypal"] {
  display: none;
}

.board[data-payment-method="credit_card"] [data-payment-method="credit_card"] {
  display: block;
}

.board[data-payment-method="credit_card"] [data-payment-method="paypal"] {
  display: none;
}

.board[data-payment-method="paypal"] [data-payment-method="paypal"] {
  display: block;
}

.board[data-payment-method="paypal"] [data-payment-method="credit_card"] {
  display: none;
}

label.filter-container {
  display: block;
  margin: 0;
  padding: 7px 10px;
  color: #333333;
  position: relative;
  font-weight: 400;
  font-style: normal;
  cursor: pointer;
  border-bottom: 1px solid #d7d7d9;
}

label.filter-container:last-of-type {
  border-bottom: 0;
}

input.filter-column {
  display: inline-block;
  margin-top: 0;
  top: 0 !important;
  margin-right: 10px;
}

input.jscolor {
  color: inherit !important;
}

.table_tabs {
  text-align: right;
  padding: 0;
}

.table_tabs a.tab {
  width: 100px;
  font-size: 13px;
  display: inline-block;
  padding: 10px 0 10px 0;
  background: #e8e8e9;
  text-align: center;
  border-radius: 0;
  color: #333;
  border: 2px solid #d1d1d2;
  border-bottom: 0;
  cursor: pointer;
  margin-left: -6px;
}

.table_tabs a.tab.current {
  background: #d1d1d2;
  border-color: #d1d1d2;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  pointer-events: none;
  cursor: default;
}

.table_tabs a.tab.current.disabled {
  color: #333 !important;
  pointer-events: none;
  cursor: default;
}

.table_tabs a.tab:not(.current):hover {
  background: #e1e1e2;
}

.table_tabs a.tab:not(.current):active {
  background: #d1d1d2;
}

.table_tabs a i {
  color: #e35256;
  font-style: normal;
  border-radius: 99px;
  margin-left: 5px;
  text-align: right;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.table_tabs a i.red {
  color: #e35256;
}

.table_tabs a i.gray {
  color: #666666;
}

.table_tabs a.overdue i.green {
  color: #3da07b;
  font-style: normal;
  border-radius: 99px;
  margin-left: 5px;
  text-align: right;
  font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
}

.dropdown-menu.icons li a:before {
  font-family: "Linearicons";
  font-size: 20px;
  margin-right: 10px;
  margin-top: -3px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
}

.dropdown-menu.icons li a.i_new_invoice:before {
  content: "\e6b5";
}

.dropdown-menu.icons li a.i_archive:before {
  content: "\e69d";
}

.dropdown-menu.icons li a.i_unarchive:before {
  content: "\e69e";
}

.dropdown-menu.icons li a.i_new_bill:before {
  content: "\e6b4";
}

.dropdown-menu.icons li a.i_new_estimate:before {
  content: "\e6b3";
}

.dropdown-menu.icons li a.i_new_recinvoice:before,
.dropdown-menu.icons li a.i_new_recbill:before {
  content: "\e8da";
}

.dropdown-menu.icons li a.i_new_connection:before {
  content: "\e71f";
}

.dropdown-menu.icons li a.i_new_track_time:before {
  content: "\e8f1";
}

.dropdown-menu.icons li a.i_new_track_expense:before {
  content: "\e750";
}

.dropdown-menu.icons li a.i_new_track_mileage:before {
  content: "\e842";
}

.dropdown-menu.icons li a.i_print:before {
  content: "\e6b1";
}

.dropdown-menu.icons li a.i_download_pdf:before {
  content: "\e8f5";
}

.dropdown-menu.icons li a.i_account_statement:before {
  content: "\e6d8";
}

.dropdown-menu.icons li a.i_preview:before {
  content: "\e911";
}

.dropdown-menu.icons li a.i_mark_payable:before {
  content: "\e98f";
}

.dropdown-menu.icons li a.i_mark_paid:before {
  content: "\e999";
}

.dropdown-menu.icons li a.i_mark_unpaid:before {
  content: "\e99a";
}

.dropdown-menu.icons li a.i_mark_sent:before {
  content: "\e693";
}

.dropdown-menu.icons li a.i_send:before {
  content: "\e699";
}

.dropdown-menu.icons li a.i_mark_draft:before {
  content: "\e98d";
}

.dropdown-menu.icons li a.i_send_reminder:before {
  content: "\e955";
}

.dropdown-menu.icons li a.i_post_comment:before {
  content: "\e612";
}

.dropdown-menu.icons li a.i_manage_payments:before {
  content: "\e92e";
}

.dropdown-menu.icons li a.i_convert_to:before {
  content: "\e6b9";
}

.dropdown-menu.icons li a.i_duplicate:before {
  content: "\e6b8";
}

.dropdown-menu.icons li a.i_reopen:before {
  content: "\e69e";
}

.dropdown-menu.icons li a.i_cancel:before {
  content: "\e92a";
}

.dropdown-menu.icons li a.i_delete:before {
  content: "\e681";
}

.dropdown-menu.icons li a.i_activity:before {
  content: "\e92d";
}

.dropdown-menu.icons li a.i_list:before {
  content: "\e6b7";
}

.dropdown-menu.icons li a.i_start_profile:before {
  content: "\e96a";
}

.dropdown-menu.icons li a.i_pause_profile:before {
  content: "\e96b";
}

.dropdown-menu.icons li a.i_manage_contacts:before {
  content: "\e71a";
}

.dropdown-menu.icons li a.i_item:before {
  content: "\e6ba";
}

.dropdown-menu.icons li a.i_expense:before {
  content: "\e767";
}

.dropdown-menu.icons li a.i_task:before {
  content: "\e8e8";
}

.dropdown-menu.icons li a.i_trip:before {
  content: "\e781";
}

.dropdown-menu.icons li a.i_tag:before {
  content: "\e755";
}

/* NEW TABLE FOR REPORTS */
table.new-table {
  background: #ffffff;
  width: 100%;
  text-align: left;
  border: 2px solid #d7d7d9;
  margin-bottom: 50px;
}

table.new-table.reports td:nth-child(2) {
  max-width: 200px;
}

table.new-table tbody:not(.totals) tr:not(.red_backlight):hover {
  background: #f3f3f4;
}

table.new-table th {
  padding: 10px;
  background: #e8e8e9;
}

table.new-table td {
  padding: 10px 10px;
  border-top: 1px solid #d7d7d9;
}

table.new-table span.tag.clean {
  padding: 5px 0;
  height: auto;
  margin: 0 !important;
  font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
    sans-serif;
  font-size: 13px;
}

.board.report_builder select {
  min-width: 200px;
}

.board.report_builder header.box_header {
  border-bottom: 2px solid #d7d7d9;
}

.board.report_builder .autocomplete_card p {
  margin: 0 !important;
}

.dropdown-toggle.download_report {
  color: #fff;
  padding: 0 10px;
  background: rgba(0, 0, 0, 0.47);
  font-size: 14px;
  display: inline-block;
  width: 145px;
  border: none;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  height: 36px;
  line-height: 35px;
  text-align: left;
}

.dropdown-toggle.download_report.export {
  margin-left: 10px;
  color: #333333;
  background: #d7d7d9;
  width: 80px;
  height: 35px;
}

.dropdown-toggle.download_report.export + .dropdown-menu {
  margin-bottom: 50px;
}

.dropdown-toggle.download_report.export + .dropdown-menu > li a,
.dropdown-toggle.in_table + .dropdown-menu > li a {
  padding: 5px 10px;
}

.dropdown-toggle.download_report.export:after,
.dropdown-toggle.download_report.export:hover:after {
  color: #333333 !important;
}

.dropdown-toggle.download_report.disabled {
  opacity: 0.25;
  pointer-events: none;
  cursor: default;
}

.download_report.dropdown-toggle:before {
  content: "";
  display: none;
}

.download_report.dropdown-toggle:after,
.download_report.dropdown-toggle:hover:after {
  color: #fff !important;
}

.download_report.dropdown-toggle:after {
  top: 0;
}

@media print {
  html {
    min-width: 0 !important;
  }

  @page {
    size: auto;
    margin: 0;
  }

  main {
    margin: 0;
  }

  .header.app_board_header,
  .sidebar_menu,
  aside#alerts,
  h2 .statement_status,
  .page.extra.account_statement,
  .page.statement_info {
    display: none !important;
  }

  #container,
  section#desk {
    margin: 0;
    padding: 0;
    background: #fff;
  }

  .board {
    border: 0;
    padding: 25px !important;
    -webkit-print-color-adjust: exact;
  }

  #desk .board .page,
  .form_standard {
    margin: 0 !important;
    padding: 0 !important;
  }

  #desk.statement footer {
    padding-bottom: 0;
  }

  .statement_amount_container.total_due .td_label {
    position: relative;
    z-index: 9999999999;
    color: #fff !important;
  }

  #desk.statement.view input[type="text"]:not(.status_line),
  #desk.statement.view input[type="search"],
  #desk.statement.view input[type="email"],
  #desk.statement.view input[type="password"],
  #desk.statement.view input[type="number"] {
    height: 25px;
    line-height: 25px;
  }

  .board.back {
    display: none;
  }

  #desk.statement footer ul,
  #desk.statement footer .right.branding {
    padding-top: 0;
  }

  .statement_amount_container .statement_amount {
    padding: 5px 7px;
    height: 35px;
  }

  .statement_amount_container.total_due .statement_amount {
    padding: 5px inherit;
    height: 40px;
  }

  .statement_amount .col,
  .statement_amount .col:first-child,
  .statement_amount .col.first,
  .statement_amount .col:last-child {
    height: 25px;
    line-height: 25px !important;
  }

  .page.account_statement .address_from {
    min-height: 0 !important;
  }

  .page.account_statement table.free {
    font-size: 12px;
  }

  /*
     * Hides the Zendesk Widget in the print version.
     * Context: https://support.zendesk.com/hc/en-us/community/posts/360048899273-Hiding-Chat-button-on-printed-pages
     */
  iframe#launcher,
  iframe#webWidget {
    display: none !important;
  }
}

.mobile {
  display: none;
}

/* MOBILE */

/*
* normal view: 1085px > oo
* compact view: 800px > 1085px
* mobile view: oo > 800px
*/
.show_compact {
  display: none;
}

.show_mobile {
  display: none;
}

@media screen and (min-width: 801px) and (max-width: 1085px) {
  .hide_compact {
    display: none;
  }

  .show_compact {
    display: initial;
  }

  .sidebar_menu ul li,
  .sidebar_menu ul li a {
    cursor: pointer;
  }

  .sidebar_menu ul.sb_menu li a span {
    margin-left: 0;
  }

  .sidebar_menu .upper .frame .select_business ul.dropdown-menu li.heading {
    text-align: center;
  }

  main {
    margin-left: 75px;
  }

  html:not(.public) .in_app_ad_top.eversign_initial_promo_banner {
    padding-left: 5px;
    padding-right: 5px;
  }

  .header.app_board_header {
    left: 75px;
  }

  #desk {
    margin-right: 20px;
  }

  #container {
    padding-top: 86px;
    margin-left: 20px;
  }

  .header.app_board_header {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  #container .announcement {
    margin-right: 20px;
  }

  .sidebar_menu {
    width: 75px;
  }

  .sidebar_menu ul {
    margin-top: 50px;
  }

  .sidebar_menu .upper .logo {
    display: none;
  }

  .sidebar_menu .upper .frame .select_business .business span,
  .sidebar_menu .upper .frame .select_business .business.dropdown-toggle:after {
    display: none;
  }

  .sidebar_menu .upper .frame .select_business .business img {
    margin-right: 0;
  }

  .sidebar_menu ul.sb_menu li a span.sidebar_menu_link_text:before {
    margin-right: 0;
  }

  .sidebar_menu ul.sb_menu li a {
    text-align: center;
    padding-left: 0;
  }

  .sidebar_menu ul.sb_menu li a span.sidebar_menu_link_text {
    margin-left: 0;
  }

  .sidebar_menu ul li a.new {
    right: -50px;
    background: rgba(0, 0, 0, 0.3);
  }

  .sidebar_menu ul li a.new:hover {
    background: rgba(0, 0, 0, 0.6);
  }

  html.admin .sidebar_menu ul.disabled {
    margin-top: 50px;
  }

  .sidebar_menu .upper .frame .select_business ul.dropdown-menu li a {
    height: 40px;
    padding: 10px 22px 4px;
  }

  .sidebar_menu .upper .frame .select_business ul.dropdown-menu li.logout a {
    border-bottom: 0 !important;
  }

  .sidebar_menu .upper .frame .select_business ul.dropdown-menu {
    background: #ffffff;
    width: 200px;
    box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.2);
    -webkit-box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.2);
    -moz-box-shadow: 0 2px 8px 0 rgba(75, 75, 87, 0.2);
    border: 2px solid rgb(193, 193, 193);
  }

  .sidebar_menu .upper .frame .select_business ul.dropdown-menu li.logout a {
    padding-top: 10px;
  }

  #desk.settings .board .page.settings section a span.right {
    display: none;
  }

  #container .announcement .announcement_content form .form_row input {
    width: 100% !important;
  }

  #desk.dashboard ul.legend li {
    max-width: none;
    border-left-width: 5px;
  }

  #desk.dashboard ul.legend {
    padding-top: 25px;
    width: 90%;
    float: none;
    margin: 0 auto;
  }

  #desk.dashboard .board #pie-chart {
    display: none;
  }

  .table_tabs .meta,
  table.standard-table .fade,
  span.st_descr {
    display: none !important;
  }

  #options-strip .client_selector {
    max-width: 115px;
  }

  #desk.statement.view .page.recurring section.flex .form_row.inline {
    white-space: nowrap;
  }

  #desk.statement.view
    .page.recurring
    section.flex
    .form_row.inline:nth-child(1) {
    width: 30%;
  }

  #desk.statement.view
    .page.recurring
    section.flex
    .form_row.inline:nth-child(2) {
    width: 50%;
  }

  #desk.statement.view
    .page.recurring
    section.flex
    .form_row.inline:nth-child(3) {
    text-align: right;
  }

  #desk.statement.view .page.recurring section.flex .form_row.inline {
    padding: 15px 0;
    background: transparent;
  }

  table.standard-table span.description_meta {
    max-width: 250px;
  }

  table.standard-table .sumdata_statement_total {
    width: 100px;
  }

  table td.connection_name a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
    display: block;
  }

  table td.connection_id a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
    display: block;
  }

  table .tds_name {
    width: 115px;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    max-width: none;
  }

  ul.tabs.general {
    padding-bottom: 20px;
  }

  .statement_lang_curr_container {
    text-align: right;
    width: 400px;
  }

  .form_row.language_select {
    float: none;
    text-align: left;
  }

  .form_row.currency_select {
    float: none;
    width: 50%;
    text-align: left;
  }

  #desk.statement .button.clipboard {
    display: none;
  }

  #desk.statement .credit_card_payment section.flex {
    display: block;
  }

  #desk.statement .credit_card_payment aside.credit_card {
    margin-top: 20px;
  }

  #desk.statement
    .page.statement_settings
    section.flex
    aside:not(.credit_card) {
    padding-right: 0;
  }

  #desk.statement .subtitle.in_cc_box {
    display: block;
    border: 0;
    border-top: 0 !important;
    padding: 0 !important;
    margin-top: 15px !important;
  }

  .statement_details {
    width: 40%;
  }

  .textarea_actions .attach_button {
    background: #fff !important;
    width: 26px !important;
    border: 0 !important;
    padding: 0 !important;
  }
}

@media screen and (max-width: 800px) {
  .hide_mobile {
    display: none !important;
  }

  .show_mobile {
    display: initial;
  }

  .sidebar_menu {
    display: none;
    top: 64px;
    width: 100%;
  }

  .sidebar_menu .upper .logo {
    display: none;
  }

  main {
    margin-left: 0;
  }

  .headline_main_button .main_button.help {
    display: none;
  }

  .header.app_board_header {
    left: 0;
  }

  #desk .board.multiple_boxes {
    display: block;
    margin-bottom: 0;
  }

  #desk.dashboard .board.multiple_boxes .page {
    display: block;
    width: 100%;
    max-width: none;
    margin-bottom: 20px;
  }

  #container .announcement {
    display: none;
  }

  [data-chart-box-heading="true"] {
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    margin-bottom: -6px;
  }

  ul.tabs,
  .dataTables_paginate,
  table.standard-table thead tr {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
  }

  thead tr th {
    width: 100%;
  }

  ul.tabs li:before {
    content: "";
    display: none;
  }

  ul.tabs li {
    padding: 10px;
    width: auto;
    white-space: nowrap;
    height: 40px;
  }

  ul.tabs li strong {
    display: none;
  }

  ul.tabs a {
    width: 50%;
    box-sizing: border-box;
    display: inline-block;
    padding: 0;
    margin-left: 5px;
    border: 2px solid #d7d7d9;
    background: #e8e8e9;
    color: #444;
    border-radius: 2px;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
  }

  ul.tabs a:first-child {
    margin-left: 0;
  }

  #options-strip .search input {
    display: block;
    height: 40px;
  }

  #options-strip .search:after {
    top: 10px;
  }

  #desk {
    margin-right: 20px;
  }

  #container {
    padding-top: 0px;
    margin-left: 20px;
  }

  .header.app_board_header .max_width {
    padding-left: 20px !important;
    padding-right: 20px !important;
    box-sizing: border-box;
  }

  .header.app_board_header {
    position: fixed;
    height: 65px;
    padding: 0 !important;
    box-sizing: border-box;
  }

  .back_button.secondary {
    display: none;
  }

  a.show_mobile.mobile_menu {
    cursor: pointer;
  }

  a.show_mobile.mobile_menu:before {
    font-family: "Ionicons";
    font-size: 20px;
    margin-right: 10px;
    margin-top: -10px;
    display: inline-block;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-font-smoothing: grayscale;
    content: "\f394";
    color: #fff;
    background: rgba(0, 0, 0, 0.47);
    padding: 5px 10px;
    height: 37px;
    border-radius: 2px;
    margin-top: 14px;
  }

  .headline_main_button .main_button,
  .headline_main_button .save-button {
    min-width: 0 !important;
    height: 37px;
    padding: 11px 8px;
    /*font-size: 14px;*/
  }

  .headline_main_button .save_as_draft {
    width: auto;
  }

  .header.app_board_header h1 {
    font-size: 20px;
    line-height: 40px;
  }

  html .sidebar_menu ul.disabled {
    margin-top: initial !important;
  }

  .sidebar_menu ul li a {
    color: #ffffff;
  }

  .sidebar_menu ul li a.new {
    display: none;
    visibility: hidden;
  }

  .sidebar_menu ul li a:not(.new) {
    height: 50px;
  }

  .sidebar_menu ul li:hover a {
    background: initial !important;
  }

  .sidebar_menu .upper {
    margin-bottom: 26px;
  }

  .sidebar_menu .upper .frame .select_business ul.dropdown-menu li a {
    padding: 15px 22px 4px;
  }

  .sidebar_menu {
    z-index: 999;
  }

  .header.app_board_header h1 {
    display: none;
  }

  .mobile_header {
    display: block;
    width: 100%;
    margin-top: 80px;
    margin-bottom: 15px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .react-loaded {
    height: 0;
    width: 0;
    overflow: hidden;
    opacity: 0;
  }

  .mobile_header .inner {
    background: #d7d7d9;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 2px;
    text-align: center;
  }

  #desk.dashboard ul.legend li {
    max-width: none;
    border-left-width: 5px;
  }

  #desk.dashboard ul.legend {
    padding-top: 25px;
    width: 90%;
    float: none;
    margin: 0 auto;
  }

  #desk.dashboard .board #pie-chart {
    display: none;
  }

  #desk.dashboard ul.ataglance li:before {
    display: none;
  }

  #desk.dashboard ul.ataglance li,
  #desk.dashboard ul.linked_list li,
  .board header.box_header,
  #desk.dashboard .board #main-chart {
    padding: 10px 10px;
  }

  #desk ul.linked_list li span:not(.right) {
    width: 65%;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    float: left;
  }

  #desk.settings
    .form_row:not(.custom_period):not(.individual):not(.organization) {
    margin-top: 0;
    display: block !important;
    width: 100%;
    padding: 0 !important;
  }

  #desk.settings .form_row.custom_period {
    margin-bottom: 0px;
    width: 100%;
  }

  #desk.settings .form_row.custom_period .inline {
    display: block !important;
    margin-bottom: 20px;
  }

  #desk.settings .form_row.custom_period .inline input {
    width: 100%;
  }

  .line_breaks {
    display: none;
  }

  .report_builder_section {
    padding-bottom: 15px;
  }

  #desk.settings .board .page section {
    padding: 15px 10px;
  }

  .dropdown-toggle.download_report {
    width: 100px;
  }

  .table_tabs .meta {
    display: none !important;
  }

  #options-strip .right {
    float: none;
  }

  #options-strip .search input {
    width: 200px;
  }

  #options-strip .button {
    height: 40px;
  }

  #options-strip .button.table_sorting {
    margin: 0;
    position: relative;
  }

  #options-strip.tabs-above {
    margin-bottom: 10px;
  }

  select,
  input[type="text"],
  input[type="search"],
  input[type="email"],
  input[type="password"],
  input[type="number"] {
    height: 40px;
  }

  .select_arrows:after {
    margin-top: -19px;
  }

  .table_tabs {
    height: auto;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .table_tabs a.tab {
    width: 100%;
    display: block;
    border-bottom: 2px solid #d1d1d2;
    margin-top: -2px;
    margin-left: 0;
    height: 40px;
  }

  .inline.options.dropdown {
    display: none !important;
  }

  .standard-search,
  #options-strip .search input {
    width: 100%;
  }

  .standard-search {
    position: relative;
    margin-top: 20px;
  }

  ul.tabs.general {
    padding-bottom: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    overflow-x: scroll;
  }

  #show-per-page-strip {
    margin-top: 20px;
  }

  #show-per-page-strip .right {
    display: none;
  }

  .paginate_button:not(.previous):not(.next),
  .ellipsis {
    display: none;
  }

  #show-per-page-strip .left,
  .paginate_button {
    width: 100%;
  }

  .paginate_button.previous {
    margin-left: 0;
  }

  .paginate_button.next {
    margin-left: 10px;
  }

  .paginate_button {
    height: 45px;
    padding: 11px 13px;
  }

  /* tables */
  table.standard-table tr {
    background: #fff;
    border: 2px solid #d7d7d9;
    display: block;
    /* display: -webkit-flex; */
    margin-bottom: 10px;
    max-width: 100%;
    position: relative;
    border-radius: 2px;
  }

  table.standard-table tr {
    color: #222;
    height: 80px;
  }

  table.statements tr,
  table.new_clients_table tr,
  table.team tr,
  table.items tr,
  table.tasks tr,
  table.trips tr,
  table.expenses tr,
  table.tags tr {
    height: 100px;
  }

  table.standard-table td {
    padding: 0;
    display: inline-block;
  }

  table.standard-table td.tracker_amount {
    display: inline-block;
    position: absolute;
    z-index: 1;
    top: 52px;
    font-size: 13px;
    left: 10px;
  }

  table.standard-table td.effective_statement_status {
    position: relative;
    float: left;
    top: 12px;
    left: 40px;
    position: absolute;
  }

  table.standard-table td:first-child {
    border-left: 0;
    background: inherit;
    padding-right: 0;
    width: 45px;
  }

  table .statement_hash,
  table td.tracker_id,
  table.team tr td:nth-child(1),
  table.items tr td:nth-child(1),
  table.tasks tr td:nth-child(1),
  table.expenses tr td:nth-child(1),
  table.trips tr td:nth-child(1),
  table.tags tr td:nth-child(1),
  table.files tr td:nth-child(1),
  table.trash tr td:nth-child(1),
  table.new_clients_table tr .connection_id:first-of-type {
    background: #d7d7d9;
    padding-left: 10px !important;
    height: 30px !important;
    padding-top: 8px !important;
    float: left;
    width: 100%;
    text-align: left;
  }

  table.team tr td:nth-child(1),
  table.categories tr td:nth-child(1),
  table.files tr td:nth-child(1),
  table.trash tr td:nth-child(1),
  table.connection_contacts tr td:nth-child(1) {
    background: transparent;
  }

  table.connection_contacts tr td:nth-child(1) {
    top: -15px;
    position: relative;
  }

  table input[type="checkbox"] {
    position: relative;
    vertical-align: middle;
    top: 2px;
    left: 1px;
  }

  table td.connection_id input[type="checkbox"],
  table.team td input[type="checkbox"],
  table.categories td input[type="checkbox"] {
  }

  td.statement_date,
  th.statement_hash {
    display: none !important;
  }

  table .statement_date,
  table .statement_due_date,
  table .statement_expiration_date,
  table .statement_creation_ts,
  table .tracker_amount,
  table.team td:nth-child(2),
  table.team td:nth-child(3) {
    width: auto;
  }

  table.standard-table td {
    padding: 10px;
    border-top: 0;
  }

  table.standard-table td.tracker_actions {
    top: 0;
    position: absolute;
    right: 0;
  }

  table.standard-table td.sumdata_statement_total {
    position: relative;
    float: right;
    top: 10px;
  }

  td.statement_due_date,
  td.statement_creation_ts,
  td.statement_expiration_date,
  td.tracker_amount,
  table.team tr td:nth-child(4),
  table.items tr td:nth-child(4),
  table.expenses td:nth-child(2),
  table.tags td:nth-child(2),
  table.track tr td:nth-child(4),
  td.statement_expiration_date,
  table:not(.new_clients_table) tr td.connection_id {
    float: none;
    position: absolute;
    left: 10px;
    top: 42px;
  }

  table.categories tr td:nth-child(4),
  td.statement_expiration_date,
  table.expenses tr td:nth-child(3),
  table.tags tr td:nth-child(3) {
    right: 10px;
    width: 50px;
    display: block;
    position: relative;
    z-index: 1;
    top: -19px;
    float: right;
    margin-right: 0;
    margin-top: 0;
  }

  table.categories.items tr td:nth-child(4) {
    margin-right: 10px;
  }

  table.team tr td:nth-child(4) {
    top: -33px;
    right: 0;
    width: 50px !important;
    position: relative;
  }

  table.team tr td:nth-child(4):before {
  }

  table.items tr td:nth-child(4):before {
  }

  table.trash tr td:nth-child(4):before {
  }

  table.team tr td:nth-child(4) span,
  table.team tr td:nth-child(4) section,
  table.items tr td:nth-child(4) span,
  table.items tr td:nth-child(4) section,
  table.trash tr td:nth-child(4) span,
  table.trash tr td:nth-child(4) section {
    display: inline-block;
  }

  td.statement_due_date,
  td.statement_creation_ts,
  td.tracker_amount {
    top: 67px;
  }

  td.email_address {
    float: none;
    position: absolute;
    left: 10px;
    top: 27px;
    font-size: 13px;
  }

  table.items td:nth-child(3),
  table.tasks td:nth-child(3),
  table.trips td:nth-child(3) {
    margin-left: 10px;
    margin-top: 0;
    color: #999;
    position: absolute;
    left: 0;
  }

  table.items td:nth-child(3) section,
  table.tasks td:nth-child(3) section,
  table.trips td:nth-child(3) section {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  td.email_address {
    top: 45px;
  }

  table.tasks td:nth-child(3) span:before,
  table.trips td:nth-child(3) span:before {
    content: "Rate: ";
  }

  table.items tr td:nth-child(6),
  table.tasks tr td:nth-child(4),
  table.expenses tr td:nth-child(3),
  table.trips tr td:nth-child(4),
  table.tags tr td:nth-child(3) {
    padding: 0;
    width: auto;
  }

  td.phone_number {
    float: none;
    position: absolute;
    left: 10px;
    top: 65px;
  }

  td.statement_expiration_date:before {
    content: "Expires: ";
  }

  table.items td:nth-child(2),
  table.tasks td:nth-child(2),
  table.expenses td:nth-child(2),
  table.trips td:nth-child(2),
  table.tags td:nth-child(2) {
    width: auto;
    float: left;
    margin-top: 0px;
    margin-left: 0px;
  }

  table.track tr td:nth-child(4) {
    width: auto;
  }

  table td.statement_id,
  table td.statement_recurring_profile_name,
  table td.tds_name,
  table td.connection_name,
  table.team tr td:nth-child(2),
  table.items td:nth-child(2),
  table.tasks td:nth-child(2),
  table.trips td:nth-child(2),
  table.files tr td:nth-child(3),
  table.trash tr td:nth-child(3) {
    position: relative;
    float: left;
    padding-left: 0;
  }

  table.trash tr td:nth-child(2) {
    position: absolute;
    left: 33px;
  }

  table.trash tr td:nth-child(3) {
    display: none;
  }

  table.files tr td:nth-child(3) {
    padding: 0;
  }

  table.team td:nth-child(3) {
    position: absolute;
    right: 75px;
    top: 12px;
  }

  td.connection_details {
    float: left;
    display: block !important;
    margin-top: 10px;
    margin-left: 10px;
  }

  table .connection_details {
    width: auto;
  }

  td.effective_statement_status {
    float: right;
    display: block !important;
    margin-top: 0;
  }

  table .effective_statement_status {
    text-align: center;
    position: absolute;
    right: 10px;
  }

  .tag.clean {
    padding: 10px 0;
    text-align: center;
    min-width: 75px;
    color: #fff;
    border: 0;
    min-width: 0;
    text-transform: capitalize !important;
    height: auto;
    margin: 0 !important;
    font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
      sans-serif;
    font-size: 13px;
  }

  .tag.clean.green {
    background: #3da07b;
    color: #fff !important;
  }

  .tag.clean.archived {
    background: #a7a7a9;
    color: #fff !important;
  }

  td.sumdata_statement_total {
    float: right;
    display: block !important;
    position: absolute;
    right: 10px;
    top: 38px;
    font-size: 15px;
  }

  table .sumdata_statement_total {
    text-align: left;
    width: auto;
    padding: 10px 10px 10px 0;
    padding-right: 10px;
  }

  table.standard-table .fade {
    display: none;
  }

  table.standard-table td:last-child,
  table.standard-table tr:last-child td,
  table.standard-table th:last-child {
    border: 0;
  }

  table.min-height td {
    height: auto;
  }

  table.standard-table thead tr {
    height: auto;
    background: #e8e8e9 !important;
    margin-bottom: 20px;
  }

  table td.connection_details a,
  table.time_entries td.connection_id a,
  table.expense_entries td.connection_id a,
  table.mileage_entries td.connection_id a,
  table td.connection_name a,
  table.items td:nth-child(2),
  table.items td:nth-child(2) span,
  table.tasks td:nth-child(2),
  table.tasks td:nth-child(2) span,
  table.expenses td:nth-child(2),
  table.expenses td:nth-child(2) span,
  table.trips td:nth-child(2),
  table.trips td:nth-child(2) span,
  table.tags td:nth-child(2),
  table.tags td:nth-child(2) span {
    white-space: nowrap;
    text-overflow: ellipsis;
    /* overflow: hidden; */
    display: block;
  }

  table td.connection_details a {
    width: 100%;
  }

  table.items td:nth-child(2),
  table.tasks td:nth-child(2),
  table.expenses td:nth-child(2),
  table.trips td:nth-child(2),
  table.tags td:nth-child(2) {
    width: 75%;
    display: inline-block;
  }

  table.standard-table span.item_description {
    display: block;
    width: 125px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  table.items td:nth-child(2) span,
  table.tasks td:nth-child(2) span,
  table.expenses td:nth-child(2) span,
  table.trips td:nth-child(2) span,
  table.tags td:nth-child(2) span {
    width: 100%;
  }

  table td.connection_name a {
    width: auto;
    display: inline-block;
    position: relative;
    z-index: 1;
  }

  table.time_entries td.connection_id a,
  table.expense_entries td.connection_id a,
  table.mileage_entries td.connection_id a {
    width: 150px;
  }

  span.st_descr {
    display: none;
  }

  table.standard-table th {
    border-top: 0;
    padding: 10px 20px 10px 10px;
  }

  table.standard-table th.statement_due_date,
  table.standard-table th.sumdata_statement_total,
  table.standard-table th.statement_id,
  table.standard-table th.statement_creation_ts {
    display: inline-block;
    width: 100% !important;
  }

  th.statement_date,
  th.effective_statement_status,
  th.connection_details,
  th.statement_recurring_profile_name,
  th.tds_name,
  table.time_entries th.connection_id,
  table.expense_entries th.connection_id,
  table.mileage_entries th.connection_id,
  th.tracker_amount,
  td.tracker_amount,
  th.email_address,
  th.phone_number,
  th.country_code,
  th.connection_id {
    display: none;
  }

  table.nojson .dataTables_empty {
    vertical-align: middle;
    display: block !important;
    margin-top: 25px;
  }

  table .tds_name {
    max-width: none;
    min-width: 0;
  }

  table td.tracker_date,
  td.country_code,
  .helptip {
    display: none !important;
  }

  table .tracker_actions,
  table.new_clients_table tr td.connection_id:last-of-type,
  table.team.standard-table td:last-child,
  table.items td:nth-child(6),
  table.tasks td:nth-child(4),
  table.expenses td:nth-child(3),
  table.trips td:nth-child(4),
  table.tags td:nth-child(3) {
    width: auto;
    float: right;
    margin-top: 15px;
    margin-right: 10px;
  }

  table .tracker_actions,
  table.new_clients_table tr td.connection_id:last-of-type,
  table.team.standard-table td:last-child,
  table.items td:nth-child(6),
  table.tasks td:nth-child(4),
  table.expenses td:nth-child(4),
  table.trips td:nth-child(4),
  table.tags td:nth-child(4) {
    margin-top: 17px;
  }

  .button.start-timer {
    padding: 8px 0;
    width: 45px;
    height: 39px;
  }

  table.time_entries thead,
  table.expense_entries thead,
  table.mileage_entries thead {
    display: none;
  }

  table.time_entries tr,
  table.expense_entries tr,
  table.mileage_entries tr {
    height: 80px;
  }

  table.new_clients_table .button.edit {
    display: none;
  }

  table td.connection_actions {
    float: right;
    width: 75px;
    position: relative;
    top: -18px;
    right: -15px;
  }

  table.nojson tr:hover {
    background: #ffffff;
  }

  #desk.statement.view .page.recurring section.flex {
    display: block;
  }

  #desk.statement.view .page.recurring section.flex .form_row.inline {
    padding: 10px 15px;
    background: transparent;
  }

  #desk.settings .board .page.settings section a span.right,
  #desk.settings .board form .page section.vanity_url .input_addon.left,
  .board .client_image_container {
    display: none;
  }

  form[data-connection-type="individual"] img.individual,
  form[data-connection-type="organization"] img.organization {
    display: none !important;
  }

  #desk.settings .board input[type="text"]:not(.double_input) {
    width: 100% !important;
  }

  #desk.settings .board form .page section.vanity_url input {
    width: 58% !important;
  }

  .board .client_type_define {
    margin-left: 0;
    width: 100%;
    max-width: 300px;
  }

  #desk.settings .form_row.double .left,
  #desk.settings .form_row.double .right {
    width: 100%;
  }

  #desk.settings .form_row.double .left {
    margin-right: 0;
    margin-bottom: 20px;
  }

  #desk.settings
    form[data-connection-type="individual"]
    .form_row.double.individual,
  #desk.settings
    form[data-connection-type="individual"]
    section.double.individual,
  #desk.settings
    form[data-connection-type="organization"]
    .form_row.double.organization {
    display: block !important;
  }

  #desk.settings .board .page section.flex {
    display: block !important;
  }

  #desk.settings .column.left {
    padding-right: 0;
    border-right: 0;
  }

  #desk.settings section.half_half .column.right,
  #desk.settings section.half_half .column.left:not(.single) {
    width: 100%;
  }

  #desk section.no_pb_pt .column {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  #desk.settings .board .page section.radio_checkbox .form_row label {
    max-width: 90%;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0;
  }

  #desk.settings .board .page section.radio_checkbox .form_row label + label {
    margin-bottom: 5px;
  }

  #desk.settings
    .board
    .page
    section.radio_checkbox
    .form_row
    input[type="checkbox"] {
    vertical-align: middle;
    display: inline-block;
  }

  table.team thead,
  table.team tr td:nth-child(2) img {
    display: none;
  }

  table.team .tag.clean {
    margin-top: 0 !important;
  }

  table.standard-table.track td,
  table.standard-table.team td,
  table.team tr td:nth-child(6) {
    padding: 0;
  }

  table.team tr td:nth-child(5) {
    margin-top: 13px;
    margin-left: 10px;
    margin-right: 10px;
    float: left;
  }

  table.team tr td:nth-child(2),
  table.categories td:nth-child(2) {
    display: block;
    left: 40px;
    top: -20px;
  }

  table.categories.expenses td:nth-child(2),
  table.categories.tags td:nth-child(2) {
    top: 10px;
  }

  table.team tr td:nth-child(2) span.name,
  table.categories td:nth-child(2) span.name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 125px;
  }

  .custom_field_container .set_default input {
    margin-left: 0;
    margin-right: 5px;
    vertical-align: middle;
  }

  .custom_field_container.tds .double_input.first,
  .custom_field_container.tds .double_input.second {
    width: 48.3% !important;
  }

  .custom_field_container.tds {
    border-bottom: 1px solid #d7d7d9;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }

  .custom_field_container.tds .remove_custom_field_button {
    margin-top: 12px;
    background: none;
    border: 0;
    color: #2676a5;
    float: right;
    padding: 0;
  }

  .custom_field_container .set_default {
    margin-top: 12px;
  }

  a.remove_custom_field_button:before {
    content: "(";
  }

  a.remove_custom_field_button:after {
    content: ")";
  }

  table.items thead,
  table.items tr td:nth-child(5),
  table.expenses thead,
  table.tasks thead,
  table.trips thead,
  table.tags thead {
    display: none;
  }

  table.standard-table.nojson td {
    padding: 0;
  }

  table td.tds_name {
    top: 7px;
    display: inline-block;
  }

  table.items td,
  table.tasks td,
  table.trips td,
  table.tags td,
  table.expenses td {
    padding: 0;
  }

  .logo_container {
    width: 125px;
    height: 125px;
  }

  table.colors input[type="text"] {
    height: 39px;
    width: 75px;
  }

  table.colors .input_addon {
    height: 39px;
  }

  table.colors .button.apply {
    width: 50px;
  }

  table.languages thead,
  table.modify_language thead,
  table.colors thead,
  table.colors span.hex,
  table.colors tr td:nth-child(2) .color_preview {
    display: none;
  }

  table.colors tr td:nth-child(3) .color_preview {
    display: inline-block;
  }

  table.colors td {
    padding: 0;
  }

  span.color_preview {
    margin-left: 0;
  }

  table.colors tr {
    height: 85px;
  }

  table.colors td:first-child {
    width: 100%;
    background: #d7d7d9;
    text-align: left;
    padding: 2px 10px;
    margin-bottom: 9px;
  }

  table.colors td:nth-child(3) {
    margin-left: 10px;
    margin-right: 10px;
  }

  table.colors td.actions {
    float: right;
    padding-right: 10px !important;
  }

  table.colors .button.revert {
    margin-left: 5px;
  }

  table.languages tr td:nth-child(2) {
    width: 102px;
    padding-right: 10px !important;
    float: right;
    padding-left: 0;
  }

  table.languages tr {
    height: 65px;
  }

  table.languages td.language {
    margin-top: 5px;
    padding-left: 10px;
  }

  table.modify_language tr td:nth-child(1) {
    width: 100%;
    background: #d7d7d9;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  table.modify_language tr td:nth-child(1):before {
    content: "Location: ";
    display: inline-block;
    font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel,
      Arial, sans-serif;
  }

  table.modify_language tr td:nth-child(2) {
    width: 100%;
    background: #d7d7d9;
    padding-top: 0;
    padding-bottom: 5px;
  }

  table.modify_language tr td:nth-child(1) section,
  table.modify_language tr td:nth-child(2) section {
    display: inline-block;
  }

  table.modify_language tr td:nth-child(2):before {
    content: "Phrase: ";
    display: inline-block;
    font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel,
      Arial, sans-serif;
  }

  table.modify_language tr {
    height: 115px;
  }

  table.modify_language tr td:nth-child(4) {
    width: 70px;
    float: right;
  }

  table.modify_language input[type="text"] {
    height: 39px;
  }

  table.files thead,
  table.files tr td:nth-child(4) {
    position: absolute;
    right: -20px;
    top: 0;
  }

  table.files tr td:nth-child(2) span {
    max-width: 125px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  table.files tr td:nth-child(3) span {
    display: none;
  }

  table.files tr td:nth-child(6) {
    width: auto;
    text-align: right;
    float: right;
    display: inline-block;
    margin-top: -5px;
    padding-right: 10px;
  }

  table.files tr td:nth-child(5) {
    line-height: 32px;
  }

  table.files tr {
    height: 85px;
  }

  table.trash tr td:nth-child(2) {
  }

  #options-strip .client_selector {
    max-width: 50%;
    margin-right: 0;
    float: right;
  }

  input[type="checkbox"]:focus,
  input[type="radio"]:focus {
    background: inherit !important;
    border-color: inherit !important;
  }

  input[type="checkbox"]:not([class^="css-"]),
  input[type="radio"]:not([class^="css-"]) {
    outline: none;
    width: 20px;
    height: 20px;
    font-size: 11px;
    line-height: 2;
    display: block;
    font-weight: bold;
    border-radius: 3px;
    border: 1px solid #b9b9b9;
    -webkit-appearance: none;
    color: #7f7f7f;
    position: relative;
    vertical-align: bottom;
    position: relative;
    top: -1px;
    float: left;
  }

  input[type="checkbox"] + label,
  input[type="radio"] + label {
    padding-left: 30px !important;
    text-indent: 0px;
    display: block;
  }

  input[type="radio"] {
    border-radius: 99px;
  }

  .select-all-none input[type="checkbox"] {
    top: 6px !important;
    left: 1px !important;
  }

  input[type="checkbox"]:checked,
  input[type="checkbox"]:checked:focus,
  input[type="radio"]:checked,
  input[type="radio"]:checked:focus {
    background: #2676a5 !important;
    border-color: #2676a5 !important;
  }

  input[type="checkbox"]:checked:after,
  input[type="radio"]:checked:after {
    content: "";
    width: 12px;
    height: 8px;
    position: absolute;
    top: 3px;
    left: 3px;
    border: 3px solid #fcfff4;
    border-top: none;
    border-right: none;
    background: transparent;
    opacity: 1;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  #options-strip .button.dropdown-toggle:after {
    top: 0;
  }

  .button.default.dropdown-toggle:before {
    left: 9px;
    top: 3px;
  }

  #options-strip .button.dropdown-toggle:before {
    font-size: 20px;
  }

  .button.dropdown-toggle:after {
    right: 8px;
  }

  thead th {
    font-family: "pn-r", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel, Arial,
      sans-serif;
  }

  .button.dropdown-toggle.add_new.in_table:before {
    left: 11px;
    top: 3px;
  }

  .x_window {
    width: 100%;
    border-radius: 0;
    position: relative;
    margin-bottom: 0;
    top: 0;
    height: auto;
  }

  .sidebar_menu ul.sb_menu li a span.sidebar_menu_link_text {
    margin-left: 0px;
    position: relative;
    top: 1px;
    font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel,
      Arial, sans-serif;
    border-radius: 3px;
    text-align: center;
  }

  .sidebar_menu ul.sb_menu li {
    border: none;
    clear: both;
    display: inline-block;
    position: relative;
    width: auto;
  }

  .sidebar_menu ul.sb_menu li {
    padding: 0;
    margin: 5px 2px;
    background: rgba(0, 0, 0, 0.2);
    width: 46%;
    text-align: center;
    border-radius: 3px;
  }

  .sidebar_menu ul.sb_menu li a span.sidebar_menu_link_text:before {
    display: block;
    text-align: center;
    margin-right: 0;
    margin-top: 0;
  }

  .sidebar_menu ul.sb_menu li a {
    padding: 0;
  }

  .sidebar_menu ul.sb_menu {
    text-align: center;
  }

  /* STATEMENT PAGES */
  #desk.statement .board .page {
    padding: 15px !important;
  }

  .statement_logo_container,
  .item_area .one_item_line .drag_item {
    display: none;
  }

  #desk.statement header h2.title input {
    width: 100%;
    max-width: 250px;
  }

  #desk.statement header h2.title .statement_status {
    height: 40px;
    padding: 10px;
    vertical-align: initial;
    min-width: 75px;
  }

  .form_row.statement_description textarea {
    width: 100%;
  }

  #desk.statement .title {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
  }

  .item_column.action .button {
    height: 40px;
  }

  #desk.statement .input_addon {
    padding-top: 7px;
    height: 40px;
  }

  .statement_details {
    width: 50%;
  }

  #desk.statement footer a.button.flip {
    float: none;
    width: 100%;
    margin-top: 15px;
    height: 40px;
    padding: 10px;
  }

  #desk.statement footer a:not(.button) {
    position: relative !important;
    margin: 0 auto;
    width: 100%;
    text-align: left;
    bottom: 0 !important;
    margin-top: 10px;
  }

  .statement_amount_container:not(.total_due) .statement_amount {
    height: 55px;
  }

  #desk.statement footer {
    margin-top: 25px;
  }

  #desk.statement .totals .totals_container {
    margin-top: -12px;
  }

  #desk.statement .board .page.statement_settings input[type="checkbox"],
  #desk.statement .board .page.statement_settings input[type="radio"] {
    display: inline-block;
    vertical-align: middle;
  }

  #desk.statement.view .page.statement_info .left strong,
  #desk.statement.view .page.statement_info #selectable {
    display: none;
  }

  #desk.statement.view .page.statement_info .left a {
    cursor: pointer !important;
    text-align: center;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    background: #e8e8e9;
    border: 2px solid #d7d7d9;
    color: #444;
    width: 85px;
    display: inline-block;
    vertical-align: middle;
    padding: 9px 0;
    background: #f5f5f5;
    color: #999;
  }

  #desk.statement.view .page.statement_info .left {
    line-height: normal;
  }

  #desk.statement.view .page.recurring,
  #desk.statement.view .page.statement_info {
    padding: 15px !important;
  }

  #desk.statement.view .totals .totals_container {
    margin-top: 0;
  }

  html.public a.show_mobile.mobile_menu {
    display: none;
  }

  .headline_main_button .main_button,
  .headline_main_button .save-button {
    min-width: 100px !important;
  }

  html.public .headline_main_button {
    float: none;
    display: -webkit-flex;
  }

  html.public .headline_main_button .main_button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  html.public .headline_main_button .main_button:first-child {
    margin-right: 10px;
  }

  .back_button.secondary {
    float: none;
    height: 37px;
    margin-top: 14px;
    padding: 9px 13px 7px;
  }

  html.public .back_button.secondary.flip {
    display: inline-block !important;
  }

  html.public body,
  html.public body main,
  html.public #wrapper {
    background: #f3f3f4;
  }

  html.public #desk {
    margin: 20px 20px 0px 20px;
  }

  html.public #desk.statement .board .page.statement_settings .title,
  #desk.statement .board .page.statement_settings .subtitle {
    font-size: 16px;
  }

  html.public #desk.statement .board .page.statement_settings .title .right {
    display: none;
  }

  #desk.statement .board .page.statement_settings .subtitle {
    margin-top: 15px !important;
  }

  html.public .payment_amount {
    float: none;
    margin-top: 20px;
  }

  html.public ul.statement_payment_methods li {
    width: 100%;
    text-align: center;
  }

  html.public .page.statement_settings,
  html.public .page.statement_settings > div {
    min-height: 0 !important;
  }

  html.public .page.statement_settings section.flex {
    display: block;
  }

  html.public .page.statement_settings section.flex aside {
    float: none;
    display: block;
    padding: 0;
  }

  html.public .page.statement_settings section.flex aside.credit_card {
    margin-top: 20px;
  }

  #desk.statement .subtitle.in_cc_box {
    display: block;
    border: 0;
    border-top: 0 !important;
    padding: 0 !important;
    margin-top: 15px !important;
  }

  html.public .page.statement_settings section.flex aside.credit_card .flex {
    display: block;
  }

  html.public
    .page.statement_settings
    section.flex
    aside.credit_card
    .form_row.flex
    .flex_item {
    margin-bottom: 20px;
  }

  html.public .flex .flex_item {
    margin-right: 10px;
  }

  html.public .flex .flex_item:last-of-type {
    margin-right: 0px;
  }

  html.public #desk.statement .input_addon {
    padding-top: 9px;
  }

  table.free tr.border_bottom.large {
    border-bottom: 0;
  }

  #desk.settings .column.left,
  #desk.settings .column.right {
    width: 100%;
    float: none;
  }

  #desk .board.multiple_boxes .page {
    margin-bottom: 20px;
  }

  #desk.settings .board label:not(.filter-container) {
    display: block !important;
  }

  #desk section.invoices ul li {
    height: auto !important;
    border-top: 1px solid #e8e8e9 !important;
    border-bottom: 0;
  }

  #desk section.invoices ul li,
  #desk section.invoices ul li:last-of-type {
    padding-top: 15px !important;
  }

  #desk section.invoices ul li:first-child {
    border-top: 0 !important;
    padding-top: 0 !important;
  }

  #desk section.invoices ul li:last-of-type {
    padding-bottom: 0 !important;
  }

  #desk section.invoices ul li .left {
    float: none;
    width: 100%;
    display: block;
  }

  #desk section.invoices ul li .right {
    float: none;
    width: 100%;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
    margin-top: 20px;
  }

  #desk section.invoices ul li a {
    width: 100%;
    text-align: center;
  }

  #desk.checkout .flex .flex_item {
    margin-bottom: 20px;
  }

  .cc_images img {
    margin-left: 8px;
  }

  input[name="security_code"] {
    max-width: 100px;
  }

  #desk.checkout .flex .flex_item.cvv_code {
    width: 100px;
    display: inline-block;
    margin-right: 15px;
  }

  #desk.checkout .flex .flex_item.cvv_code_icon {
    width: 100px;
    display: inline-block;
  }

  #desk.checkout .flex .flex_item.cvv_code_icon img {
    margin-top: 0px !important;
    height: 40px;
  }

  .sidebar_menu .upper .frame .select_business .business {
    padding: 10px 15px;
  }

  .sidebar_menu .upper .frame .select_business ul.dropdown-menu {
    margin-top: 20px;
  }

  .sidebar_menu .upper .frame .select_business ul.dropdown-menu li a,
  .sidebar_menu .upper .frame .select_business ul.dropdown-menu li.logout a {
    padding: 10px 22px 0px;
    height: 40px;
  }

  #container {
    overflow-x: hidden;
  }

  .x_form .board .client_type_define {
    float: none;
    margin-top: 0;
  }

  .x_page.overlay {
    top: 0;
  }
}

/* EXTRA BREAKPOINT FOR STATEMENT PAGES */
@media screen and (max-width: 800px) {
  .total_input,
  .unit_inputÂ {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
  }

  #desk.statement .form_row.inline:not(.hide_on_view) {
    width: 100%;
    display: block !important;
    padding-right: 0;
  }

  .statement_lang_curr_container {
    float: none;
    border-top: 1px solid #e7e7e7;
    margin-top: 35px;
  }

  #desk.statement .form_row.inline {
    float: none;
  }

  .statement_details {
    float: none;
    width: 100%;
  }

  #desk.statement .form_standard select.with_addon,
  .unit_input input,
  .quantity_input input {
    width: 100% !important;
  }

  li.item_column:before {
    content: "Name";
    display: block;
    border-bottom: 2px solid #d7d7d9;
    margin-bottom: 10px;
    font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel,
      Arial, sans-serif;
  }

  .item_column.name_description:before {
    content: "Name & Description";
  }

  .item_column.name_description .inner {
    margin-bottom: 15px;
  }

  .item_column.quantity:before {
    content: "Quantity";
  }

  .item_column.unit:before {
    content: "Rate/Unit";
  }

  .item_column.amount:before {
    content: "Amount";
  }

  .item_column.action:before {
    display: none;
  }

  .item_column {
    margin: 0;
    padding: 0;
    display: block;
    margin-bottom: 15px;
  }

  .item_column .inner {
    padding: 0 !important;
  }

  .item_row {
    display: none;
  }

  .item_column.quantity,
  .item_column.unit,
  .item_column.amount,
  .item_column.action {
    width: 100%;
  }

  .item_column.action {
    margin-bottom: 0;
  }

  #desk.statement .input_addon {
    padding-top: 10px;
  }

  .form_standard input[type="text"].with_addon.total {
    width: 100%;
  }

  .textarea_actions.right .restrainer.disabled {
    position: absolute;
  }

  .item_area .item_row {
    display: block;
    background: rgba(0, 0, 0, 0.05);
    padding: 10px;
    border-radius: 3px;
  }

  .item_rows.item_area {
    margin-left: 0;
  }

  #desk.statement.view .item_rows.item_area {
    margin-bottom: 20px;
    padding-bottom: 25px;
    border-bottom: 1px solid #e7e7e7;
  }

  .item_rows.item_area:before,
  #desk.statement.view
    .statement_section
    .form_heading
    label:not(.hide_on_view) {
    display: block;
    text-align: left;
    margin-bottom: 10px;
    font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel,
      Arial, sans-serif;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    padding: 5px;
  }

  #desk.statement.view .totals:before {
    display: block;
    text-align: left;
    margin-bottom: 10px;
    font-family: "pn-sb", "Open Sans", "Gill Sans MT", "Gill Sans", Corbel,
      Arial, sans-serif;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    padding: 5px;
    content: "Summary";
    margin-top: 25px;
  }

  .item_rows.item_area:before {
    content: "Items";
    text-align: center;
  }

  .item_area .one_item_line {
    padding-left: 0;
  }

  .item_column.action .button {
    display: none;
  }

  .item_column.action .button + .dropdown-menu {
    display: -ms-flexbox !important;
    display: -webkit-box !important;
    display: flex !important;
    display: -webkit-flex !important;
    position: relative;
    background: none;
    border: 0;
    box-shadow: none;
    float: none;
    margin: 0;
  }

  .item_column.action .button + .dropdown-menu li {
    width: 100%;
  }

  .item_column.action .button + .dropdown-menu li a {
    background: rgba(0, 0, 0, 0.1);
    border: 2px solid #d7d7d9;
    text-align: center;
  }

  .item_column.action .inner .relative {
    width: 100%;
  }

  .item_column.action .button + .dropdown-menu li:first-child {
    margin-right: 10px;
  }

  .item_row {
    border-bottom: 0;
  }

  .new_item.dropdown-toggle {
    float: none;
    display: block;
    width: 100%;
  }

  #desk.statement .totals {
    margin-top: 30px;
  }

  #desk.statement .totals .totals_container {
    float: none;
    width: 100%;
    max-width: none;
  }

  .inline.tds_rate {
    width: 30% !important;
  }

  .inline.tds_name {
    width: 45% !important;
  }

  .statement_amount .close_icon:after {
    font-size: 17px;
    position: relative !important;
    float: left !important;
    margin-left: 10px;
    left: -10px;
    cursor: pointer;
  }

  .close_icon {
    cursor: pointer;
    /* iOS onClick Fix */
  }

  .statement_amount_container.tds.total .statement_amount {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
  }

  .button_row li.link,
  #desk.statement footer a.button:before {
    display: none;
  }

  .item_area .item_row {
    margin-top: 15px;
  }

  .item_area .item_row:first-child {
    margin-top: 0;
  }

  #desk.statement header h2.title .statement_status {
    text-align: center;
  }

  #desk.statement header h2.title .statement_status {
    padding: 10px 10px;
  }

  .input_loader,
  .input_loader:after {
    top: 12px;
  }

  .autocomplete-suggestions.connection_autocomplete {
    margin-top: -82px;
  }

  .autocomplete-suggestions.item_autocomplete {
    width: 100% !important;
    margin-top: -77px;
    max-width: 266px;
  }

  .item_textarea_container,
  .item_textarea_container .files_area {
    background: #fff;
  }

  #desk.statement .board .page.statement_settings .subtitle a {
    margin-top: 3px;
  }

  .textarea_actions.right,
  .textarea_actions.left {
    float: none;
    text-align: center;
  }

  .textarea_actions .dropdown-menu.popover {
    left: -67px !important;
  }

  .button_row.tax_discount_shipping .right {
    float: none;
  }

  .button_row li {
    float: none;
    display: inline-block;
    margin-left: 5px;
  }

  .button_row.tax_discount_shipping {
    text-align: center;
  }

  .attach_button:before {
    position: absolute;
    left: 10px;
  }

  .attach_button .tipr_container_bottom {
    margin-top: 40px;
    z-index: 999;
  }

  .statement_amount input[type="checkbox"],
  .statement_amount input[type="checkbox"] + label {
    display: none !important;
  }

  #desk.statement.view .statement_details {
    width: 100%;
  }

  #desk.statement.view .board:not(.inputs_enabled) .statement_section {
    margin-bottom: 30px;
    padding-bottom: 0;
    border-bottom: 1px solid #e7e7e7;
  }

  #desk.statement.view .board:not(.inputs_enabled) input,
  #desk.statement.view .board:not(.inputs_enabled) select,
  #desk.statement.view
    .board:not(.inputs_enabled)
    [data-currency="code"]:not(.total) {
    height: initial;
  }

  #desk.statement.view .board:not(.inputs_enabled) .one_item_line.actual input {
    text-align: left;
  }

  #desk.statement.view
    .statement_amount_container:not(.total_due)
    .statement_amount,
  #desk.statement.view
    .board:not(.inputs_enabled)
    .statement_amount_container.tds
    .statement_amount {
    padding: 7px 0;
  }

  #desk.statement:not(.view) .statement_section .form_row.inline.hide_on_view {
    margin-top: 0;
    margin-bottom: 0;
  }

  .hide_on_view {
    height: initial !important;
  }

  .headline_main_button .save_as_draft {
    margin-left: 0;
  }

  a.show_mobile.mobile_menu:before {
    margin-right: 0;
  }

  #desk.statement .board .page.recurring .form_row.frequency,
  #desk.statement .board .page.extra .form_row {
    width: 100%;
  }

  #desk.statement .statement_amount_container.total_due .col.status_line {
    height: 35px;
  }

  .headline_main_button .dropdown-menu {
    max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;
  }

  #desk.statement.view .form_standard .unit_lower {
    text-align: left;
  }

  .table_contact_autocomplete {
    display: none;
  }

  .table_sorting + .dropdown-menu {
    top: 40px;
  }

  table.standard-table td span.tag_meta {
    display: none;
  }

  .pagination_section {
    border: 0;
  }

  tracker_amount {
    display: inline-block;
  }

  table td.connection_name span.email {
    margin-top: 14px;
  }

  table td.connection_name span {
    left: 0;
    position: relative;
    left: -27px;
  }

  table.team td.member span.role {
    font-size: inherit;
  }

  table.team td.status span.last_logged_in {
    display: none;
  }

  table.team td.member span.role {
    top: 10px;
    font-size: 14px;
    display: block;
    position: relative;
    left: -30px;
  }

  table.standard-table .item_name span.item_description {
    font-size: inherit;
    display: block;
    bottom: 0;
    margin-top: 15px;
    left: -28px;
  }

  table.standard-table.categories .price {
    display: block;
    position: absolute;
    top: 68px;
    left: 2px;
  }

  #options-strip .search:before {
    top: 10px;
  }

  table.standard-table .statement_id span.date,
  table.standard-table .statement_recurring_profile_name span.date,
  table.standard-table .tds_name span.date,
  table.standard-table .name span.date,
  table.statement_comments td.comment span.date {
    display: none;
  }

  table.standard-table .statement_id span.title_meta,
  table.standard-table .statement_recurring_profile_name span.title_meta,
  table.standard-table .tds_name span.client,
  table.standard-table span.description_meta.filled {
    display: block;
    position: relative;
    width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    left: -35px;
  }

  table.standard-table .tds_name span.client {
    top: 4px;
  }

  .paginate_button.previous,
  .paginate_button.next,
  .paginate_button.start,
  .paginate_button.end {
    width: 48.5%;
    border-width: 2px;
  }

  table.standard-table {
    border: none;
  }

  table td.blank {
    width: 100% !important;
  }

  table td.blank:not(.loading) {
    margin-top: 28px;
  }

  table td.blank.loading:before {
    top: 24px;
  }

  table.new_clients_table tr .connection_id:first-of-type {
    background: transparent;
  }

  table td.connection_name {
    left: 42px;
    top: -20px;
  }

  table.standard-table .name span.filename {
    display: block;
    position: absolute;
    left: 40px;
    top: 10px;
  }

  table.standard-table .name span.uploader {
    margin: 0;
  }

  .button.clipboard {
    margin-right: 5px;
  }

  table.connection_contacts td.contact span.tel {
    display: none;
  }

  table.connection_contacts td.contact span.name {
    left: -10px;
    position: relative;
  }

  table.connection_contacts td.contact span.email {
    position: relative;
    top: 5px;
    left: -41px;
  }

  table.connection_contacts td.actions {
    position: absolute;
    right: -10px;
  }

  table.statement_activity td.date,
  table.statement_activity td.activity {
    width: 100%;
    display: block;
  }

  table.statement_activity td.activity {
    position: relative;
    top: -10px;
  }

  table.statement_payments tr td:nth-child(1),
  table.statement_comments tr td:nth-child(1) {
    position: absolute;
  }

  table.statement_payments td.payment_info span.date,
  table.statement_comments td.comment span.name {
    position: absolute;
    left: 40px;
    top: 13px;
  }

  table.statement_comments td.comment span.name {
    top: 14px;
  }

  table.statement_payments td.payment_info span.amount {
    position: absolute;
    left: 120px;
    top: 13px;
  }

  table.statement_payments td.details,
  table.statement_comments td.comment span.comment {
    position: relative;
    top: 29px;
    left: 2px;
  }

  table.statement_comments td.comment span.comment {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  table.statement_payments td.actions,
  table.statement_comments td.actions {
    position: absolute;
    right: -15px;
    top: 0;
  }

  table.statement_payments td.status {
    display: none;
  }

  html.public ul.statement_payment_methods a.stripe_form_open li.stripe {
    height: auto;
  }

  html.public
    ul.statement_payment_methods
    a.stripe_form_open
    li.stripe
    .stripe_payment_container {
    margin-top: 10px;
  }

  html.public
    ul.statement_payment_methods
    a.stripe_form_open
    li.stripe
    .stripe_payment_container
    img {
    display: none;
  }

  html.public
    ul.statement_payment_methods
    a.stripe_form_open
    li.stripe
    .stripe_payment_container
    .flex {
    display: block;
  }

  html.public
    ul.statement_payment_methods
    a.stripe_form_open
    li.stripe
    .stripe_payment_container
    .StripeElement {
    display: block;
    margin-bottom: 10px;
  }

  html.public
    ul.statement_payment_methods
    a.stripe_form_open
    li.stripe
    .stripe_payment_container
    button {
    display: block;
    margin: 0;
    float: right;
  }

  /*!!*/
}

/* STRIPE 2019 */
#card-element:not(.StripeElement) {
  height: 50px;
}

.stripe.no_popup {
  max-width: 450px;
}

.stripe.no_popup img {
  margin-bottom: 15px;
}

.StripeElement {
  box-sizing: border-box;
  height: 50px;
  padding: 15px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: #f9f9f9;
  border-color: #d7d7d9;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  border-color: #a7a7a9;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.x_content .board .page section p.processed_stripe,
#desk .board .page section p.processed_stripe {
  display: block;
  margin-bottom: 10px;
}

.x_content .board .page section p.processed_stripe:before,
#desk .board .page section p.processed_stripe:before {
  font-family: "Linearicons";
  font-size: 20px;
  margin-right: 5px;
  margin-top: -5px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: grayscale;
  content: "\e66b";
}

.x_content .board .page section p.processed_stripe + p {
  font-size: 12px;
}

#desk .board .page section p.processed_stripe + p {
  max-width: 600px;
  font-size: 13px;
  color: #a4a4a4;
}

/* STRIPE 2019 */

/* RECAPTCHA 2019 */
.grecaptcha-badge {
  opacity: 0 !important;
}

.highlight {
  margin-top: 0px !important;
}

body[data-current-page="send_invoice"] .grecaptcha-badge,
body[data-current-page="send_bill"] .grecaptcha-badge,
body[data-current-page="send_estimate"] .grecaptcha-badge,
body[data-current-page="send_account_statement"] .grecaptcha-badge,
body[data-current-page="send_receipt"] .grecaptcha-badge {
  opacity: 1 !important;
  z-index: 1 !important;
}

/* RECAPTCHA 2019 */

/** duplicated code but I would spend weeks cleaning up this mess also we have to be compatible with IE11 so no custom properties **/
.ccfg_button_warning {
  background: #e35256;
  margin-top: 15px;
  color: #fff;
  text-align: center;
  padding: 0 10px;
  border: none;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  height: 36px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  line-height: 36px;
}

input,
tr,
td,
body {
  font-family: "Roboto", sans-serif !important;
}
</style>
